<!-- Dashboard HTML Start-->
<section class="dashboard-top-hld">

  <section class="bg-white b5containeradjust pb-md-5 pb-0 mb-bg-1  pt-md-3 pt-4">

    <div class="container banr" id="banner">
      <div class="px-3">
        <div class="banner p-4  alert alert-dismissible" *ngIf="ifBannerDataExists">
          <div class="">
            <a name="btn_BannerClose_Dashboard" href="#" (click)="HideBanner()" class="close text-white alertclose"
              data-bs-dismiss="alert" aria-label="close">
              <svg viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.8923 2.30139L38.788 39.0577" stroke="white" stroke-width="4" stroke-linecap="round" />
                <path d="M38.8207 2.33331L2.85965 39.0258" stroke="white" stroke-width="4" stroke-linecap="round" />
              </svg>
            </a>
            <h2 class="text-white fontadjust">{{heading}}</h2>
            <div class="d-md-flex justify-content-between align-items-center">
              <p class="text-white  m-0 col-md-9 ps-md-0 px-0" [innerHTML]="content ">
              </p>
              <div class="butttonsection text-md-end text-center mt-md-0 mt-3 col-md-3 pe-md-0 px-0">
                <button *ngIf="linkCategory === 'onPlatformNavigate'" name="btn_Banner_Dashboard"
                  href="javascript:void(0)" routerLinkActive="active-link" (click)="competitionCTA()"
                  class="toppbtn topbtn-lg me-0">{{buttonText}}</button>
                <button id="offPlatform" *ngIf="linkCategory === 'offPlatformNavigate'" name="btn_Banner_Dashboard"
                  href="javascript:void(0)" (click)="callOffPlatformNavigate()"
                  class="toppbtn topbtn-lg me-0">{{buttonText}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class=" stickybottomconainer">
        <div class="d-flex flex-wrap align-items-stretch pt-4">
          <div class="col-md-12 mb-md-4 mb-4" *ngIf="isDataAvailable!=null && !isDataAvailable">
            <section class="d-flex flex-wrap cshadow cshadownew p-md-4 p-3 rounded bg-white">
              <p class="text-center bureauNull m-0 text-red">
                Vericred Credit Bureau has little to no information on you and your credit history. If you think that
                you
                should be seeing information here but can't, please ask a Financial Assessor how to submit a query
                to credit bureau.
              </p>
            </section>
          </div>

          <div class="col-12 col-md-7 px-3 px-md-3 main_header pb-4 pb-md-0">
            <h2 class="page-caption  mb-3 d-none d-md-block">Your Credit Score
              <a #creditScorePopoverBtn style="cursor: pointer;" name="tip_auxilaryButton_chatToCoach_showMore_creditScore" id="tip_auxilaryButton_chatToCoach_showMore_creditScore" (click)="togglePopover('creditScorePopover', creditScorePopoverBtn)">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                    stroke="#4AAEAC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M12 16V12" stroke="#4AAEAC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M12 8H12.01" stroke="#4AAEAC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </a>
            </h2>
            <div class="drawer_info" *ngIf="showInfoBanner">
              <div class="d-flex align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" class="svg_size" width="21" height="37" viewBox="0 0 21 37" fill="none">
                <g data-figma-bg-blur-radius="4">
                  <path
                    d="M4.42105 2.17647C4.42105 3.3785 3.43137 4.35294 2.21053 4.35294C0.989686 4.35294 0 3.3785 0 2.17647C0 0.974439 0.989686 0 2.21053 0C3.43137 0 4.42105 0.974439 4.42105 2.17647Z"
                    fill="white" fill-opacity="0.1" />
                  <path
                    d="M4.42105 7.61765C4.42105 8.81968 3.43137 9.79412 2.21053 9.79412C0.989686 9.79412 0 8.81968 0 7.61765C0 6.41562 0.989686 5.44118 2.21053 5.44118C3.43137 5.44118 4.42105 6.41562 4.42105 7.61765Z"
                    fill="white" fill-opacity="0.1" />
                  <path
                    d="M9.94737 7.61765C9.94737 8.81968 8.95768 9.79412 7.73684 9.79412C6.516 9.79412 5.52632 8.81968 5.52632 7.61765C5.52632 6.41562 6.516 5.44118 7.73684 5.44118C8.95768 5.44118 9.94737 6.41562 9.94737 7.61765Z"
                    fill="white" fill-opacity="0.1" />
                  <path
                    d="M4.42105 13.0588C4.42105 14.2609 3.43137 15.2353 2.21053 15.2353C0.989686 15.2353 0 14.2609 0 13.0588C0 11.8568 0.989686 10.8824 2.21053 10.8824C3.43137 10.8824 4.42105 11.8568 4.42105 13.0588Z"
                    fill="white" fill-opacity="0.1" />
                  <path
                    d="M9.94737 13.0588C9.94737 14.2609 8.95768 15.2353 7.73684 15.2353C6.516 15.2353 5.52632 14.2609 5.52632 13.0588C5.52632 11.8568 6.516 10.8824 7.73684 10.8824C8.95768 10.8824 9.94737 11.8568 9.94737 13.0588Z"
                    fill="white" fill-opacity="0.1" />
                  <path
                    d="M15.4737 13.0588C15.4737 14.2609 14.484 15.2353 13.2632 15.2353C12.0423 15.2353 11.0526 14.2609 11.0526 13.0588C11.0526 11.8568 12.0423 10.8824 13.2632 10.8824C14.484 10.8824 15.4737 11.8568 15.4737 13.0588Z"
                    fill="white" fill-opacity="0.1" />
                  <path
                    d="M4.42105 18.5C4.42105 19.702 3.43137 20.6765 2.21053 20.6765C0.989686 20.6765 0 19.702 0 18.5C0 17.298 0.989686 16.3235 2.21053 16.3235C3.43137 16.3235 4.42105 17.298 4.42105 18.5Z"
                    fill="white" fill-opacity="0.1" />
                  <path
                    d="M9.94737 18.5C9.94737 19.702 8.95768 20.6765 7.73684 20.6765C6.516 20.6765 5.52632 19.702 5.52632 18.5C5.52632 17.298 6.516 16.3235 7.73684 16.3235C8.95768 16.3235 9.94737 17.298 9.94737 18.5Z"
                    fill="white" fill-opacity="0.1" />
                  <path
                    d="M15.4737 18.5C15.4737 19.702 14.484 20.6765 13.2632 20.6765C12.0423 20.6765 11.0526 19.702 11.0526 18.5C11.0526 17.298 12.0423 16.3235 13.2632 16.3235C14.484 16.3235 15.4737 17.298 15.4737 18.5Z"
                    fill="white" fill-opacity="0.1" />
                  <path
                    d="M21 18.5C21 19.702 20.0103 20.6765 18.7895 20.6765C17.5686 20.6765 16.5789 19.702 16.5789 18.5C16.5789 17.298 17.5686 16.3235 18.7895 16.3235C20.0103 16.3235 21 17.298 21 18.5Z"
                    fill="white" fill-opacity="0.1" />
                  <path
                    d="M4.42105 23.9412C4.42105 25.1432 3.43137 26.1176 2.21053 26.1176C0.989686 26.1176 0 25.1432 0 23.9412C0 22.7391 0.989686 21.7647 2.21053 21.7647C3.43137 21.7647 4.42105 22.7391 4.42105 23.9412Z"
                    fill="white" fill-opacity="0.1" />
                  <path
                    d="M9.94737 23.9412C9.94737 25.1432 8.95768 26.1176 7.73684 26.1176C6.516 26.1176 5.52632 25.1432 5.52632 23.9412C5.52632 22.7391 6.516 21.7647 7.73684 21.7647C8.95768 21.7647 9.94737 22.7391 9.94737 23.9412Z"
                    fill="white" fill-opacity="0.1" />
                  <path
                    d="M15.4737 23.9412C15.4737 25.1432 14.484 26.1176 13.2632 26.1176C12.0423 26.1176 11.0526 25.1432 11.0526 23.9412C11.0526 22.7391 12.0423 21.7647 13.2632 21.7647C14.484 21.7647 15.4737 22.7391 15.4737 23.9412Z"
                    fill="white" fill-opacity="0.1" />
                  <path
                    d="M4.42105 29.3824C4.42105 30.5844 3.43137 31.5588 2.21053 31.5588C0.989686 31.5588 0 30.5844 0 29.3824C0 28.1803 0.989686 27.2059 2.21053 27.2059C3.43137 27.2059 4.42105 28.1803 4.42105 29.3824Z"
                    fill="white" fill-opacity="0.1" />
                  <path
                    d="M9.94737 29.3824C9.94737 30.5844 8.95768 31.5588 7.73684 31.5588C6.516 31.5588 5.52632 30.5844 5.52632 29.3824C5.52632 28.1803 6.516 27.2059 7.73684 27.2059C8.95768 27.2059 9.94737 28.1803 9.94737 29.3824Z"
                    fill="white" fill-opacity="0.1" />
                  <path
                    d="M4.42105 34.8235C4.42105 36.0256 3.43137 37 2.21053 37C0.989686 37 0 36.0256 0 34.8235C0 33.6215 0.989686 32.6471 2.21053 32.6471C3.43137 32.6471 4.42105 33.6215 4.42105 34.8235Z"
                    fill="white" fill-opacity="0.1" />
                </g>
                <defs>
                  <clipPath id="bgblur_0_4617_3583_clip_path" transform="translate(4 4)">
                    <path
                      d="M4.42105 2.17647C4.42105 3.3785 3.43137 4.35294 2.21053 4.35294C0.989686 4.35294 0 3.3785 0 2.17647C0 0.974439 0.989686 0 2.21053 0C3.43137 0 4.42105 0.974439 4.42105 2.17647Z" />
                    <path
                      d="M4.42105 7.61765C4.42105 8.81968 3.43137 9.79412 2.21053 9.79412C0.989686 9.79412 0 8.81968 0 7.61765C0 6.41562 0.989686 5.44118 2.21053 5.44118C3.43137 5.44118 4.42105 6.41562 4.42105 7.61765Z" />
                    <path
                      d="M9.94737 7.61765C9.94737 8.81968 8.95768 9.79412 7.73684 9.79412C6.516 9.79412 5.52632 8.81968 5.52632 7.61765C5.52632 6.41562 6.516 5.44118 7.73684 5.44118C8.95768 5.44118 9.94737 6.41562 9.94737 7.61765Z" />
                    <path
                      d="M4.42105 13.0588C4.42105 14.2609 3.43137 15.2353 2.21053 15.2353C0.989686 15.2353 0 14.2609 0 13.0588C0 11.8568 0.989686 10.8824 2.21053 10.8824C3.43137 10.8824 4.42105 11.8568 4.42105 13.0588Z" />
                    <path
                      d="M9.94737 13.0588C9.94737 14.2609 8.95768 15.2353 7.73684 15.2353C6.516 15.2353 5.52632 14.2609 5.52632 13.0588C5.52632 11.8568 6.516 10.8824 7.73684 10.8824C8.95768 10.8824 9.94737 11.8568 9.94737 13.0588Z" />
                    <path
                      d="M15.4737 13.0588C15.4737 14.2609 14.484 15.2353 13.2632 15.2353C12.0423 15.2353 11.0526 14.2609 11.0526 13.0588C11.0526 11.8568 12.0423 10.8824 13.2632 10.8824C14.484 10.8824 15.4737 11.8568 15.4737 13.0588Z" />
                    <path
                      d="M4.42105 18.5C4.42105 19.702 3.43137 20.6765 2.21053 20.6765C0.989686 20.6765 0 19.702 0 18.5C0 17.298 0.989686 16.3235 2.21053 16.3235C3.43137 16.3235 4.42105 17.298 4.42105 18.5Z" />
                    <path
                      d="M9.94737 18.5C9.94737 19.702 8.95768 20.6765 7.73684 20.6765C6.516 20.6765 5.52632 19.702 5.52632 18.5C5.52632 17.298 6.516 16.3235 7.73684 16.3235C8.95768 16.3235 9.94737 17.298 9.94737 18.5Z" />
                    <path
                      d="M15.4737 18.5C15.4737 19.702 14.484 20.6765 13.2632 20.6765C12.0423 20.6765 11.0526 19.702 11.0526 18.5C11.0526 17.298 12.0423 16.3235 13.2632 16.3235C14.484 16.3235 15.4737 17.298 15.4737 18.5Z" />
                    <path
                      d="M21 18.5C21 19.702 20.0103 20.6765 18.7895 20.6765C17.5686 20.6765 16.5789 19.702 16.5789 18.5C16.5789 17.298 17.5686 16.3235 18.7895 16.3235C20.0103 16.3235 21 17.298 21 18.5Z" />
                    <path
                      d="M4.42105 23.9412C4.42105 25.1432 3.43137 26.1176 2.21053 26.1176C0.989686 26.1176 0 25.1432 0 23.9412C0 22.7391 0.989686 21.7647 2.21053 21.7647C3.43137 21.7647 4.42105 22.7391 4.42105 23.9412Z" />
                    <path
                      d="M9.94737 23.9412C9.94737 25.1432 8.95768 26.1176 7.73684 26.1176C6.516 26.1176 5.52632 25.1432 5.52632 23.9412C5.52632 22.7391 6.516 21.7647 7.73684 21.7647C8.95768 21.7647 9.94737 22.7391 9.94737 23.9412Z" />
                    <path
                      d="M15.4737 23.9412C15.4737 25.1432 14.484 26.1176 13.2632 26.1176C12.0423 26.1176 11.0526 25.1432 11.0526 23.9412C11.0526 22.7391 12.0423 21.7647 13.2632 21.7647C14.484 21.7647 15.4737 22.7391 15.4737 23.9412Z" />
                    <path
                      d="M4.42105 29.3824C4.42105 30.5844 3.43137 31.5588 2.21053 31.5588C0.989686 31.5588 0 30.5844 0 29.3824C0 28.1803 0.989686 27.2059 2.21053 27.2059C3.43137 27.2059 4.42105 28.1803 4.42105 29.3824Z" />
                    <path
                      d="M9.94737 29.3824C9.94737 30.5844 8.95768 31.5588 7.73684 31.5588C6.516 31.5588 5.52632 30.5844 5.52632 29.3824C5.52632 28.1803 6.516 27.2059 7.73684 27.2059C8.95768 27.2059 9.94737 28.1803 9.94737 29.3824Z" />
                    <path
                      d="M4.42105 34.8235C4.42105 36.0256 3.43137 37 2.21053 37C0.989686 37 0 36.0256 0 34.8235C0 33.6215 0.989686 32.6471 2.21053 32.6471C3.43137 32.6471 4.42105 33.6215 4.42105 34.8235Z" />
                  </clipPath>
                </defs>
              </svg>
                <div class="py-1 pe-1 drawer_info_text d-none d-md-block" >We're making things better for you! <span  id="btn_auxilaryButton_creditScore_featureNoticeOpenDrawer_dashboard" name="btn_auxilaryButton_creditScore_featureNoticeOpenDrawer_dashboard" (click)="openOffcanvasNewCS('desktop')">Here's what’s changed and why.</span></div>
                <div class="drawer_info_text d-block d-md-none">We're making things better for you! <span name="btn_auxilaryButton_creditScore_featureNoticeOpenDrawer_dashboard" id="btn_auxilaryButton_creditScore_featureNoticeOpenDrawer_dashboard" (click)="openOffcanvasNewCS('mobile')">Here's what’s changed and why.</span></div>
              </div>


            </div>
            <div class="scorebox padding_box_section" [ngStyle]="showInfoBanner ? {'margin-top': '0px'} : {}">
            <div class="row flex-wrap justify-content-center scoreContainer">
              <div class="col-12 col-lg-5 content d-none d-md-block" [ngClass]="{'padding_text_withBanner': showInfoBanner,  'padding_text': !showInfoBanner}">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="32" viewBox="0 0 19 32" fill="none">
                    <path
                      d="M3.59655e-07 7.06658C-0.000131063 7.24932 0.0357564 7.43031 0.105628 7.59917C0.175501 7.76803 0.277982 7.92144 0.407201 8.05066C0.53642 8.17988 0.689863 8.28236 0.85872 8.35223C1.02758 8.4221 1.20854 8.45799 1.39128 8.45786C1.57403 8.45799 1.75499 8.4221 1.92385 8.35223C2.0927 8.28236 2.24615 8.17988 2.37537 8.05066C2.50459 7.92144 2.60707 7.76803 2.67694 7.59917C2.74681 7.43031 2.7827 7.24932 2.78257 7.06658C2.78257 6.69758 2.63598 6.34372 2.37506 6.0828C2.11415 5.82188 1.76028 5.67529 1.39128 5.67529C1.20854 5.67516 1.02758 5.71108 0.85872 5.78095C0.689863 5.85082 0.53642 5.95327 0.407201 6.08249C0.277982 6.21171 0.175501 6.36516 0.105628 6.53401C0.0357564 6.70287 -0.000131063 6.88383 3.59655e-07 7.06658Z"
                      fill="#E59A2C" />
                    <path
                      d="M5.23633 7.06658C5.2362 7.24932 5.27208 7.43031 5.34196 7.59917C5.41183 7.76803 5.51431 7.92144 5.64353 8.05066C5.77275 8.17988 5.92619 8.28236 6.09505 8.35223C6.26391 8.4221 6.44487 8.45799 6.62761 8.45786C6.81036 8.45799 6.99135 8.4221 7.16021 8.35223C7.32906 8.28236 7.48248 8.17988 7.6117 8.05066C7.74091 7.92144 7.8434 7.76803 7.91327 7.59917C7.98314 7.43031 8.01903 7.24932 8.0189 7.06658C8.0189 6.69758 7.87231 6.34372 7.61139 6.0828C7.35047 5.82188 6.9966 5.67529 6.62761 5.67529C6.25862 5.67529 5.90475 5.82188 5.64383 6.0828C5.38292 6.34372 5.23633 6.69758 5.23633 7.06658Z"
                      fill="#E59A2C" />
                    <path
                      d="M3.59655e-07 11.5839C-0.000131063 11.7667 0.0357564 11.9476 0.105628 12.1165C0.175501 12.2854 0.277982 12.4388 0.407201 12.568C0.53642 12.6972 0.689863 12.7997 0.85872 12.8696C1.02758 12.9394 1.20854 12.9753 1.39128 12.9752C1.57403 12.9753 1.75499 12.9394 1.92385 12.8696C2.0927 12.7997 2.24615 12.6972 2.37537 12.568C2.50459 12.4388 2.60707 12.2854 2.67694 12.1165C2.74681 11.9476 2.7827 11.7667 2.78257 11.5839C2.7827 11.4012 2.74681 11.2202 2.67694 11.0513C2.60707 10.8825 2.50459 10.729 2.37537 10.5998C2.24615 10.4706 2.0927 10.3681 1.92385 10.2983C1.75499 10.2284 1.57403 10.1925 1.39128 10.1926C1.20854 10.1925 1.02758 10.2284 0.85872 10.2983C0.689863 10.3681 0.53642 10.4706 0.407201 10.5998C0.277982 10.729 0.175501 10.8825 0.105628 11.0513C0.0357564 11.2202 -0.000131063 11.4012 3.59655e-07 11.5839Z"
                      fill="#E59A2C" />
                    <path
                      d="M5.23633 11.5839C5.2362 11.7667 5.27208 11.9476 5.34196 12.1165C5.41183 12.2854 5.51431 12.4388 5.64353 12.568C5.77275 12.6972 5.92619 12.7997 6.09505 12.8696C6.26391 12.9394 6.44487 12.9753 6.62761 12.9752C6.81036 12.9753 6.99135 12.9394 7.16021 12.8696C7.32906 12.7997 7.48248 12.6972 7.6117 12.568C7.74091 12.4388 7.8434 12.2854 7.91327 12.1165C7.98314 11.9476 8.01903 11.7667 8.0189 11.5839C8.01903 11.4012 7.98314 11.2202 7.91327 11.0513C7.8434 10.8825 7.74091 10.729 7.6117 10.5998C7.48248 10.4706 7.32906 10.3681 7.16021 10.2983C6.99135 10.2284 6.81036 10.1925 6.62761 10.1926C6.44487 10.1925 6.26391 10.2284 6.09505 10.2983C5.92619 10.3681 5.77275 10.4706 5.64353 10.5998C5.51431 10.729 5.41183 10.8825 5.34196 11.0513C5.27208 11.2202 5.2362 11.4012 5.23633 11.5839Z"
                      fill="#E59A2C" />
                    <path
                      d="M10.4717 11.5839C10.4717 11.9529 10.6182 12.3068 10.8792 12.5677C11.1401 12.8286 11.494 12.9752 11.863 12.9752C12.232 12.9752 12.5858 12.8286 12.8467 12.5677C13.1077 12.3068 13.2542 11.9529 13.2542 11.5839C13.2542 11.2149 13.1077 10.861 12.8467 10.6001C12.5858 10.3392 12.232 10.1926 11.863 10.1926C11.494 10.1926 11.1401 10.3392 10.8792 10.6001C10.6182 10.861 10.4717 11.2149 10.4717 11.5839Z"
                      fill="#E59A2C" />
                    <path
                      d="M0 16.1002C0 16.4692 0.146589 16.8231 0.407505 17.084C0.668422 17.345 1.02229 17.4915 1.39128 17.4915C1.76028 17.4915 2.11414 17.345 2.37506 17.084C2.63598 16.8231 2.78257 16.4692 2.78257 16.1002C2.78257 15.9176 2.74656 15.7367 2.67663 15.568C2.6067 15.3992 2.50421 15.2459 2.375 15.1168C2.24579 14.9877 2.09243 14.8853 1.92363 14.8155C1.75484 14.7457 1.57394 14.7098 1.39128 14.71C1.20862 14.7098 1.02773 14.7457 0.858934 14.8155C0.690141 14.8853 0.536772 14.9877 0.407566 15.1168C0.278361 15.2459 0.175864 15.3992 0.105933 15.568C0.0360022 15.7367 -4.72015e-08 15.9176 0 16.1002Z"
                      fill="#E59A2C" />
                    <path
                      d="M5.23633 16.1002C5.23633 16.4692 5.38292 16.8231 5.64383 17.084C5.90475 17.345 6.25862 17.4915 6.62761 17.4915C6.9966 17.4915 7.35047 17.345 7.61139 17.084C7.87231 16.8231 8.01889 16.4692 8.01889 16.1002C8.01889 15.9176 7.98289 15.7367 7.91296 15.568C7.84303 15.3992 7.74053 15.2459 7.61133 15.1168C7.48212 14.9877 7.32875 14.8853 7.15996 14.8155C6.99117 14.7457 6.81027 14.7098 6.62761 14.71C6.44495 14.7098 6.26405 14.7457 6.09526 14.8155C5.92647 14.8853 5.7731 14.9877 5.64389 15.1168C5.51469 15.2459 5.41219 15.3992 5.34226 15.568C5.27233 15.7367 5.23633 15.9176 5.23633 16.1002Z"
                      fill="#E59A2C" />
                    <path
                      d="M10.4717 16.1001C10.4728 16.4682 10.6197 16.8209 10.8803 17.0809C11.1408 17.341 11.4939 17.4871 11.862 17.4874C12.231 17.4874 12.5848 17.3408 12.8458 17.0799C13.1067 16.8189 13.2533 16.4651 13.2533 16.0961C13.253 15.7273 13.1063 15.3737 12.8454 15.113C12.5845 14.8522 12.2308 14.7058 11.862 14.7058C11.6793 14.7057 11.4984 14.7415 11.3296 14.8113C11.1608 14.8812 11.0074 14.9835 10.8782 15.1126C10.749 15.2418 10.6465 15.3951 10.5766 15.5638C10.5067 15.7326 10.4707 15.9134 10.4707 16.0961"
                      fill="#E59A2C" />
                    <path
                      d="M15.708 16.1002C15.708 16.4692 15.8546 16.8231 16.1155 17.084C16.3764 17.345 16.7303 17.4915 17.0993 17.4915C17.4681 17.4913 17.8217 17.3446 18.0824 17.0837C18.3431 16.8228 18.4896 16.4691 18.4896 16.1002C18.4896 15.7315 18.3431 15.3779 18.0824 15.1172C17.8216 14.8564 17.468 14.71 17.0993 14.71C16.9166 14.7098 16.7357 14.7457 16.5669 14.8155C16.3981 14.8853 16.2447 14.9877 16.1155 15.1168C15.9863 15.2459 15.8838 15.3992 15.8139 15.568C15.744 15.7367 15.708 15.9176 15.708 16.1002Z"
                      fill="#E59A2C" />
                    <path
                      d="M3.59655e-07 20.6174C-0.000131063 20.8001 0.0357564 20.9811 0.105628 21.1499C0.175501 21.3188 0.277982 21.4722 0.407201 21.6014C0.53642 21.7307 0.689863 21.8331 0.85872 21.903C1.02758 21.9729 1.20854 22.0088 1.39128 22.0086C1.57403 22.0088 1.75499 21.9729 1.92385 21.903C2.0927 21.8331 2.24615 21.7307 2.37537 21.6014C2.50459 21.4722 2.60707 21.3188 2.67694 21.1499C2.74681 20.9811 2.7827 20.8001 2.78257 20.6174C2.78257 20.2484 2.63598 19.8945 2.37506 19.6336C2.11415 19.3727 1.76028 19.2261 1.39128 19.2261C1.20854 19.2259 1.02758 19.2618 0.85872 19.3317C0.689863 19.4016 0.53642 19.5041 0.407201 19.6333C0.277982 19.7625 0.175501 19.9159 0.105628 20.0848C0.0357564 20.2537 -0.000131063 20.4346 3.59655e-07 20.6174Z"
                      fill="#E59A2C" />
                    <path
                      d="M5.23633 20.6174C5.2362 20.8001 5.27208 20.9811 5.34196 21.1499C5.41183 21.3188 5.51431 21.4722 5.64353 21.6014C5.77275 21.7307 5.92619 21.8331 6.09505 21.903C6.26391 21.9729 6.44487 22.0088 6.62761 22.0086C6.81036 22.0088 6.99135 21.9729 7.16021 21.903C7.32906 21.8331 7.48248 21.7307 7.6117 21.6014C7.74091 21.4722 7.8434 21.3188 7.91327 21.1499C7.98314 20.9811 8.01903 20.8001 8.0189 20.6174C8.0189 20.2484 7.87231 19.8945 7.61139 19.6336C7.35047 19.3727 6.9966 19.2261 6.62761 19.2261C6.25862 19.2261 5.90475 19.3727 5.64383 19.6336C5.38292 19.8945 5.23633 20.2484 5.23633 20.6174Z"
                      fill="#E59A2C" />
                    <path
                      d="M10.4717 20.6174C10.4717 20.9863 10.6182 21.3402 10.8792 21.6011C11.1401 21.8621 11.494 22.0086 11.863 22.0086C12.232 22.0086 12.5858 21.8621 12.8467 21.6011C13.1077 21.3402 13.2542 20.9863 13.2542 20.6174C13.2542 20.2484 13.1077 19.8945 12.8467 19.6336C12.5858 19.3727 12.232 19.2261 11.863 19.2261C11.494 19.2261 11.1401 19.3727 10.8792 19.6336C10.6182 19.8945 10.4717 20.2484 10.4717 20.6174Z"
                      fill="#E59A2C" />
                    <path
                      d="M3.59655e-07 25.1366C-0.000131063 25.3194 0.0357564 25.5004 0.105628 25.6692C0.175501 25.8381 0.277982 25.9915 0.407201 26.1207C0.53642 26.2499 0.689863 26.3524 0.85872 26.4223C1.02758 26.4922 1.20854 26.5281 1.39128 26.5279C1.57403 26.5281 1.75499 26.4922 1.92385 26.4223C2.0927 26.3524 2.24615 26.2499 2.37537 26.1207C2.50459 25.9915 2.60707 25.8381 2.67694 25.6692C2.74681 25.5004 2.7827 25.3194 2.78257 25.1366C2.7827 24.9539 2.74681 24.7729 2.67694 24.6041C2.60707 24.4352 2.50459 24.2818 2.37537 24.1526C2.24615 24.0233 2.0927 23.9209 1.92385 23.851C1.75499 23.7811 1.57403 23.7452 1.39128 23.7454C1.20854 23.7452 1.02758 23.7811 0.85872 23.851C0.689863 23.9209 0.53642 24.0233 0.407201 24.1526C0.277982 24.2818 0.175501 24.4352 0.105628 24.6041C0.0357564 24.7729 -0.000131063 24.9539 3.59655e-07 25.1366Z"
                      fill="#E59A2C" />
                    <path
                      d="M5.23633 25.1366C5.2362 25.3194 5.27208 25.5004 5.34196 25.6692C5.41183 25.8381 5.51431 25.9915 5.64353 26.1207C5.77275 26.2499 5.92619 26.3524 6.09505 26.4223C6.26391 26.4922 6.44487 26.5281 6.62761 26.5279C6.81036 26.5281 6.99135 26.4922 7.16021 26.4223C7.32906 26.3524 7.48248 26.2499 7.6117 26.1207C7.74091 25.9915 7.8434 25.8381 7.91327 25.6692C7.98314 25.5004 8.01903 25.3194 8.0189 25.1366C8.01903 24.9539 7.98314 24.7729 7.91327 24.6041C7.8434 24.4352 7.74091 24.2818 7.6117 24.1526C7.48248 24.0233 7.32906 23.9209 7.16021 23.851C6.99135 23.7811 6.81036 23.7452 6.62761 23.7454C6.44487 23.7452 6.26391 23.7811 6.09505 23.851C5.92619 23.9209 5.77275 24.0233 5.64353 24.1526C5.51431 24.2818 5.41183 24.4352 5.34196 24.6041C5.27208 24.7729 5.2362 24.9539 5.23633 25.1366Z"
                      fill="#E59A2C" />
                    <path
                      d="M3.59655e-07 30.1857C3.12454e-07 30.3684 0.0360026 30.5492 0.105933 30.718C0.175864 30.8867 0.278361 31.04 0.407567 31.1692C0.536773 31.2983 0.690141 31.4006 0.858934 31.4705C1.02773 31.5403 1.20862 31.5761 1.39128 31.576C1.57394 31.5761 1.75484 31.5403 1.92363 31.4705C2.09243 31.4006 2.2458 31.2983 2.375 31.1692C2.50421 31.04 2.6067 30.8867 2.67663 30.718C2.74657 30.5492 2.78257 30.3684 2.78257 30.1857C2.7827 30.003 2.74681 29.822 2.67694 29.6532C2.60707 29.4843 2.50459 29.3309 2.37537 29.2016C2.24615 29.0724 2.0927 28.9699 1.92385 28.9001C1.75499 28.8302 1.57403 28.7943 1.39128 28.7944C1.20854 28.7943 1.02758 28.8302 0.85872 28.9001C0.689863 28.9699 0.53642 29.0724 0.407201 29.2016C0.277982 29.3309 0.175501 29.4843 0.105628 29.6532C0.0357564 29.822 -0.000131063 30.003 3.59655e-07 30.1857Z"
                      fill="#E59A2C" />
                    <path
                      d="M3.59655e-07 2.01555C-0.000131063 2.19829 0.0357564 2.37926 0.105628 2.54811C0.175501 2.71697 0.277982 2.87042 0.407201 2.99963C0.53642 3.12885 0.689863 3.23133 0.85872 3.30121C1.02758 3.37108 1.20854 3.40697 1.39128 3.40683C1.57403 3.40697 1.75499 3.37108 1.92385 3.30121C2.0927 3.23133 2.24615 3.12885 2.37537 2.99963C2.50459 2.87042 2.60707 2.71697 2.67694 2.54811C2.74681 2.37926 2.7827 2.19829 2.78257 2.01555C2.7827 1.83281 2.74681 1.65185 2.67694 1.48299C2.60707 1.31413 2.50459 1.16069 2.37537 1.03147C2.24615 0.902249 2.0927 0.799768 1.92385 0.729896C1.75499 0.660024 1.57403 0.624137 1.39128 0.624268C1.20854 0.624137 1.02758 0.660024 0.85872 0.729896C0.689863 0.799768 0.53642 0.902249 0.407201 1.03147C0.277982 1.16069 0.175501 1.31413 0.105628 1.48299C0.0357564 1.65185 -0.000131063 1.83281 3.59655e-07 2.01555Z"
                      fill="#E59A2C" />
                  </svg>
                </div>
                <h1 class="font-weight-bold mb-1 userName">Hi, {{userData?.given_name | titleCase }}!</h1>
                <p>Check out your monthly insights below</p>
              </div>
              <div class="col-12 d-block d-md-none text-center pt-2 pb-2">
                <div style="display: inline-block; position: relative;">
                  <h3 class="font-weight-bold mb-1">Your Credit Score
                    <a #creditScorePopoverButton style="cursor: pointer;" name="tip_auxilaryButton_chatToCoach_showMore_creditScore"
                      id="tip_auxilaryButton_chatToCoach_showMore_creditScore"
                      (click)="togglePopover('creditScorePopover', creditScorePopoverButton)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                        <path
                          d="M12.5469 22C18.0697 22 22.5469 17.5228 22.5469 12C22.5469 6.47715 18.0697 2 12.5469 2C7.02403 2 2.54688 6.47715 2.54688 12C2.54688 17.5228 7.02403 22 12.5469 22Z"
                          stroke="#E59A2C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12.5469 16V12" stroke="#E59A2C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12.5469 8H12.5569" stroke="#E59A2C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </a>
                  </h3>
                </div>
                <p>Hi {{userData?.given_name | titleCase }}, check out your monthly insights below</p>
              </div>
              <div class="col-12 col-md-7 text-center" [ngClass]="{'credit-history-container_withBanner': showInfoBanner,  'credit-history-container': !showInfoBanner}">
                <div class="semi-ring-wrapper pb-md-5 pb-3 mb-bg-1  pt-md-3 pt-4">
                
                <svg viewBox="0 0 200 115" class="semi-ring">
                    <path class="ring-bg" d="M 10 100 A 90 90 0 0 1 190 100" [attr.stroke-dasharray]="circumference"
                      [attr.stroke-dashoffset]="0" stroke-linecap="round"/>
                
                    <path class="ring-fg" d="M 10 100 A 90 90 0 0 1 190 100" [attr.stroke-dasharray]="circumference"
                      [attr.stroke-dashoffset]="strokeOffset" stroke-linecap="round" *ngIf="animateCSdial"/>
                    <svg xmlns="http://www.w3.org/2000/svg"
                      [attr.x]="iconX - 11" [attr.y]="iconY - 11"                    
                      width="23" height="25" viewBox="0 0 37 40" fill="none">
                      <g filter="url(#filter0_d_4919_267)">
                        <circle cx="18.5203" cy="17.5199" r="14" transform="rotate(17.2376 18.5203 17.5199)" fill="white" />
                      </g>
                      <g [attr.transform]="'rotate(' + (iconRotation ?? 0) + ' ' + arrowPivotX + ' ' + arrowPivotY + ')'">
                        <path
                          d="M19.3527 11.38C19.2875 11.449 19.2365 11.5302 19.2027 11.6189C19.1689 11.7077 19.153 11.8022 19.1557 11.8971C19.1585 11.9919 19.18 12.0854 19.2189 12.172C19.2578 12.2585 19.3133 12.3366 19.3824 12.4017C19.4514 12.4669 19.5326 12.5178 19.6213 12.5516C19.71 12.5854 19.8046 12.6014 19.8995 12.5986C19.9943 12.5958 20.0878 12.5744 20.1744 12.5355C20.2609 12.4966 20.339 12.4409 20.4041 12.3718C20.5357 12.2324 20.6064 12.0464 20.6008 11.8548C20.5952 11.6632 20.5138 11.4817 20.3744 11.3502C20.3053 11.285 20.2242 11.234 20.1355 11.2003C20.0467 11.1665 19.9522 11.1505 19.8573 11.1533C19.7625 11.156 19.669 11.1775 19.5824 11.2164C19.4958 11.2553 19.4178 11.3109 19.3527 11.38Z"
                          fill="#E59A2C" />
                        <path
                          d="M21.3312 13.2475C21.266 13.3165 21.215 13.3977 21.1813 13.4864C21.1475 13.5751 21.1315 13.6696 21.1343 13.7645C21.137 13.8594 21.1585 13.9528 21.1974 14.0394C21.2363 14.126 21.2919 14.204 21.361 14.2691C21.43 14.3343 21.5111 14.3853 21.5999 14.4191C21.6886 14.4528 21.7831 14.4688 21.878 14.466C21.9729 14.4632 22.0663 14.4418 22.1529 14.4029C22.2395 14.364 22.3175 14.3084 22.3826 14.2393C22.5142 14.0998 22.5849 13.9138 22.5793 13.7222C22.5738 13.5306 22.4923 13.3491 22.3529 13.2176C22.2134 13.0861 22.0275 13.0153 21.8359 13.0209C21.6443 13.0265 21.4627 13.108 21.3312 13.2475Z"
                          fill="#E59A2C" />
                        <path
                          d="M17.7423 13.0873C17.6771 13.1563 17.6262 13.2375 17.5924 13.3262C17.5586 13.4149 17.5426 13.5094 17.5454 13.6043C17.5482 13.6992 17.5696 13.7926 17.6085 13.8792C17.6474 13.9658 17.703 14.0439 17.7721 14.109C17.8411 14.1742 17.9223 14.2251 18.011 14.2589C18.0997 14.2927 18.1942 14.3086 18.2891 14.3059C18.384 14.3031 18.4774 14.2816 18.564 14.2427C18.6506 14.2038 18.7287 14.1482 18.7938 14.0791C18.859 14.0101 18.9099 13.9289 18.9437 13.8402C18.9775 13.7515 18.9935 13.657 18.9907 13.5621C18.9879 13.4672 18.9665 13.3738 18.9276 13.2872C18.8887 13.2006 18.8331 13.1225 18.764 13.0574C18.695 12.9922 18.6138 12.9413 18.5251 12.9075C18.4364 12.8737 18.3419 12.8578 18.247 12.8605C18.1521 12.8633 18.0587 12.8848 17.9721 12.9237C17.8855 12.9626 17.8074 13.0182 17.7423 13.0873Z"
                          fill="#E59A2C" />
                        <path
                          d="M19.7208 14.9537C19.6556 15.0228 19.6047 15.104 19.5709 15.1927C19.5371 15.2814 19.5211 15.3759 19.5239 15.4708C19.5267 15.5657 19.5481 15.6591 19.587 15.7457C19.6259 15.8323 19.6815 15.9103 19.7506 15.9754C19.8196 16.0406 19.9008 16.0916 19.9895 16.1254C20.0782 16.1591 20.1727 16.1751 20.2676 16.1723C20.3625 16.1695 20.4559 16.1481 20.5425 16.1092C20.6291 16.0703 20.7072 16.0147 20.7723 15.9456C20.8375 15.8766 20.8884 15.7954 20.9222 15.7067C20.956 15.6179 20.972 15.5234 20.9692 15.4285C20.9665 15.3336 20.945 15.2402 20.9061 15.1536C20.8672 15.0671 20.8116 14.989 20.7425 14.9239C20.6735 14.8587 20.5923 14.8078 20.5036 14.774C20.4149 14.7402 20.3204 14.7242 20.2255 14.727C20.1306 14.7298 20.0372 14.7512 19.9506 14.7901C19.864 14.829 19.7859 14.8846 19.7208 14.9537Z"
                          fill="#E59A2C" />
                        <path
                          d="M21.6994 16.8204C21.5678 16.9599 21.4971 17.1459 21.5026 17.3375C21.5082 17.5291 21.5897 17.7106 21.7291 17.8421C21.8686 17.9737 22.0545 18.0444 22.2461 18.0388C22.4377 18.0332 22.6193 17.9517 22.7508 17.8123C22.8823 17.6728 22.9531 17.4868 22.9475 17.2952C22.9419 17.1036 22.8605 16.9221 22.721 16.7906C22.5816 16.6591 22.3956 16.5883 22.204 16.5939C22.0124 16.5995 21.8309 16.681 21.6994 16.8204Z"
                          fill="#E59A2C" />
                        <path
                          d="M16.1323 14.7944C16.0008 14.9339 15.93 15.1199 15.9356 15.3115C15.9412 15.5031 16.0227 15.6846 16.1621 15.8161C16.3015 15.9476 16.4875 16.0184 16.6791 16.0128C16.8707 16.0072 17.0522 15.9257 17.1838 15.7863C17.2489 15.7172 17.2998 15.636 17.3335 15.5474C17.3672 15.4587 17.3831 15.3642 17.3803 15.2693C17.3775 15.1745 17.3561 15.0811 17.3172 14.9946C17.2783 14.908 17.2227 14.83 17.1537 14.765C17.0847 14.6998 17.0035 14.6489 16.9149 14.6151C16.8262 14.5813 16.7318 14.5653 16.6369 14.5681C16.5421 14.5708 16.4487 14.5922 16.3621 14.6311C16.2755 14.6699 16.1974 14.7254 16.1323 14.7944Z"
                          fill="#E59A2C" />
                        <path
                          d="M18.1108 16.6599C17.9793 16.7994 17.9085 16.9853 17.9141 17.1769C17.9197 17.3686 18.0012 17.5501 18.1406 17.6816C18.28 17.8131 18.466 17.8839 18.6576 17.8783C18.8492 17.8727 19.0308 17.7912 19.1623 17.6517C19.2274 17.5827 19.2783 17.5015 19.312 17.4128C19.3457 17.3241 19.3617 17.2297 19.3589 17.1348C19.3561 17.04 19.3346 16.9466 19.2957 16.8601C19.2568 16.7735 19.2012 16.6955 19.1322 16.6304C19.0632 16.5653 18.9821 16.5143 18.8934 16.4806C18.8047 16.4468 18.7103 16.4308 18.6154 16.4335C18.5206 16.4363 18.4272 16.4577 18.3406 16.4965C18.254 16.5354 18.176 16.5909 18.1108 16.6599Z"
                          fill="#E59A2C" />
                        <path
                          d="M20.0893 18.5258C19.9585 18.6653 19.8882 18.8509 19.894 19.0421C19.8998 19.2332 19.9811 19.4143 20.1201 19.5456C20.2595 19.6771 20.4455 19.7479 20.6371 19.7423C20.8287 19.7367 21.0102 19.6552 21.1418 19.5157C21.2732 19.3763 21.3438 19.1904 21.3381 18.9988C21.3325 18.8073 21.251 18.6259 21.1117 18.4944C21.0427 18.4293 20.9615 18.3784 20.8729 18.3446C20.7842 18.3108 20.6898 18.2948 20.5949 18.2975C20.5001 18.3003 20.4067 18.3217 20.3201 18.3605C20.2335 18.3994 20.1555 18.4549 20.0903 18.5239"
                          fill="#E59A2C" />
                        <path
                          d="M22.0679 20.3931C21.9363 20.5325 21.8656 20.7185 21.8711 20.9101C21.8767 21.1017 21.9582 21.2832 22.0976 21.4147C22.2371 21.5461 22.423 21.6167 22.6145 21.6111C22.806 21.6054 22.9875 21.5239 23.1189 21.3845C23.2504 21.2452 23.3211 21.0593 23.3155 20.8679C23.3099 20.6764 23.2285 20.495 23.0892 20.3636C23.0202 20.2984 22.9391 20.2475 22.8504 20.2137C22.7618 20.1799 22.6673 20.1639 22.5724 20.1667C22.4776 20.1694 22.3842 20.1908 22.2976 20.2297C22.2111 20.2685 22.133 20.324 22.0679 20.3931Z"
                          fill="#E59A2C" />
                        <path
                          d="M14.5226 16.5011C14.4574 16.5701 14.4065 16.6513 14.3727 16.74C14.3389 16.8287 14.3229 16.9233 14.3257 17.0181C14.3284 17.113 14.3499 17.2065 14.3888 17.293C14.4277 17.3796 14.4833 17.4577 14.5524 17.5228C14.6214 17.588 14.7025 17.6389 14.7913 17.6727C14.88 17.7065 14.9745 17.7225 15.0694 17.7197C15.1643 17.7169 15.2577 17.6954 15.3443 17.6565C15.4309 17.6176 15.5089 17.562 15.574 17.4929C15.7056 17.3535 15.7763 17.1675 15.7708 16.9759C15.7652 16.7843 15.6837 16.6028 15.5443 16.4713C15.4753 16.4061 15.3941 16.3551 15.3054 16.3213C15.2167 16.2876 15.1222 16.2716 15.0273 16.2744C14.9324 16.2771 14.839 16.2986 14.7524 16.3375C14.6658 16.3764 14.5877 16.432 14.5226 16.5011Z"
                          fill="#E59A2C" />
                        <path
                          d="M16.5001 18.3676C16.4349 18.4366 16.384 18.5178 16.3502 18.6065C16.3164 18.6952 16.3004 18.7897 16.3032 18.8846C16.306 18.9795 16.3274 19.0729 16.3663 19.1595C16.4052 19.2461 16.4608 19.3242 16.5299 19.3892C16.5989 19.4544 16.6801 19.5054 16.7688 19.5392C16.8575 19.573 16.952 19.5889 17.0469 19.5861C17.1418 19.5834 17.2352 19.5619 17.3218 19.523C17.4084 19.4841 17.4865 19.4285 17.5516 19.3594C17.6831 19.2199 17.7539 19.034 17.7483 18.8424C17.7427 18.6508 17.6612 18.4692 17.5218 18.3377C17.3824 18.2062 17.1964 18.1354 17.0048 18.141C16.8132 18.1466 16.6317 18.2281 16.5001 18.3676Z"
                          fill="#E59A2C" />
                        <path
                          d="M18.4796 20.2333C18.3481 20.3727 18.2773 20.5587 18.2829 20.7503C18.2885 20.9419 18.37 21.1234 18.5094 21.255C18.6488 21.3865 18.8348 21.4572 19.0264 21.4516C19.218 21.446 19.3995 21.3646 19.5311 21.2251C19.6626 21.0857 19.7334 20.8997 19.7278 20.7081C19.7222 20.5165 19.6407 20.335 19.5013 20.2034C19.3619 20.0719 19.1759 20.0012 18.9843 20.0068C18.7927 20.0124 18.6112 20.0938 18.4796 20.2333Z"
                          fill="#E59A2C" />
                        <path
                          d="M12.9113 18.2094C12.8461 18.2784 12.7951 18.3596 12.7613 18.4483C12.7275 18.537 12.7116 18.6315 12.7143 18.7264C12.7171 18.8213 12.7386 18.9147 12.7775 19.0013C12.8163 19.0879 12.8719 19.166 12.941 19.231C13.01 19.2962 13.0912 19.3472 13.1799 19.381C13.2686 19.4147 13.3632 19.4307 13.458 19.4279C13.5529 19.4252 13.6463 19.4037 13.7329 19.3648C13.8195 19.3259 13.8976 19.2703 13.9627 19.2012C14.0279 19.1322 14.0789 19.051 14.1126 18.9623C14.1464 18.8736 14.1624 18.779 14.1596 18.6842C14.1569 18.5893 14.1354 18.4959 14.0965 18.4093C14.0576 18.3227 14.002 18.2446 13.9329 18.1795C13.8639 18.1143 13.7828 18.0634 13.694 18.0296C13.6053 17.9958 13.5108 17.9798 13.4159 17.9826C13.321 17.9854 13.2276 18.0069 13.141 18.0458C13.0544 18.0847 12.9764 18.1403 12.9113 18.2094Z"
                          fill="#E59A2C" />
                        <path
                          d="M14.8898 20.0758C14.8246 20.1448 14.7736 20.226 14.7398 20.3147C14.7061 20.4035 14.6901 20.498 14.6929 20.5929C14.6956 20.6877 14.7171 20.7812 14.756 20.8678C14.7949 20.9543 14.8505 21.0324 14.9196 21.0975C14.9886 21.1627 15.0697 21.2136 15.1585 21.2474C15.2472 21.2812 15.3417 21.2972 15.4366 21.2944C15.5315 21.2916 15.6249 21.2702 15.7115 21.2313C15.7981 21.1924 15.8761 21.1367 15.9412 21.0676C16.0064 20.9986 16.0574 20.9174 16.0912 20.8287C16.125 20.74 16.1409 20.6455 16.1382 20.5506C16.1354 20.4557 16.1139 20.3623 16.0751 20.2757C16.0362 20.1891 15.9806 20.111 15.9115 20.046C15.8425 19.9808 15.7613 19.9298 15.6726 19.8961C15.5838 19.8623 15.4893 19.8463 15.3945 19.8491C15.2996 19.8518 15.2061 19.8733 15.1195 19.9122C15.0329 19.9511 14.9549 20.0067 14.8898 20.0758Z"
                          fill="#E59A2C" />
                        <path
                          d="M11.1115 20.1163C11.0464 20.1854 10.9955 20.2666 10.9618 20.3552C10.928 20.4439 10.9121 20.5384 10.9149 20.6333C10.9177 20.7281 10.9392 20.8215 10.9781 20.908C11.0169 20.9946 11.0725 21.0726 11.1416 21.1376C11.2106 21.2028 11.2917 21.2537 11.3804 21.2875C11.469 21.3213 11.5635 21.3373 11.6583 21.3345C11.7532 21.3318 11.8466 21.3104 11.9331 21.2716C12.0197 21.2327 12.0978 21.1772 12.1629 21.1082C12.2281 21.0392 12.2791 20.958 12.3128 20.8693C12.3466 20.7805 12.3626 20.686 12.3598 20.5911C12.3571 20.4962 12.3356 20.4028 12.2967 20.3162C12.2578 20.2296 12.2022 20.1516 12.1331 20.0865C12.0641 20.0213 11.983 19.9704 11.8943 19.9366C11.8055 19.9028 11.711 19.8868 11.6161 19.8896C11.5212 19.8924 11.4278 19.9138 11.3412 19.9527C11.2546 19.9916 11.1766 20.0472 11.1115 20.1163Z"
                          fill="#E59A2C" />
                        <path
                          d="M21.1525 9.47133C21.0873 9.54034 21.0363 9.62152 21.0026 9.71024C20.9688 9.79895 20.9528 9.89347 20.9555 9.98836C20.9583 10.0833 20.9798 10.1767 21.0187 10.2633C21.0576 10.3499 21.1131 10.4279 21.1822 10.493C21.2513 10.5582 21.3324 10.6091 21.4211 10.6429C21.5099 10.6767 21.6044 10.6927 21.6993 10.6899C21.7941 10.6871 21.8876 10.6657 21.9742 10.6268C22.0608 10.5878 22.1388 10.5323 22.2039 10.4631C22.2691 10.3941 22.3201 10.313 22.3539 10.2242C22.3876 10.1355 22.4036 10.041 22.4009 9.94612C22.3981 9.85123 22.3766 9.7578 22.3377 9.67121C22.2988 9.58462 22.2433 9.50655 22.1742 9.44147C22.1052 9.37628 22.024 9.32534 21.9353 9.29156C21.8466 9.25777 21.752 9.24181 21.6571 9.24458C21.5623 9.24736 21.4688 9.26881 21.3822 9.30772C21.2956 9.34663 21.2176 9.40222 21.1525 9.47133Z"
                          fill="#E59A2C" />
                        <defs>
                          <filter id="filter0_d_4919_267" x="0.516602" y="3.51611" width="36.0078" height="36.0076"
                            filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha" />
                            <feOffset dy="4" />
                            <feGaussianBlur stdDeviation="2" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4919_267" />
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4919_267" result="shape" />
                          </filter>
                        </defs>
                      </g>
                    </svg>
                  </svg>                  
                
                  <div class="ring-label">
                    <div class="score-label">YOUR SCORE</div>
                    <div class="score-value">{{ this.scoreNumber }}</div>
                    <div class="score-text">{{this.scoreStatus}}</div>
                  </div>
                
                  <div class="score-range">
                    <span>0</span>
                    <span>1000</span>
                  </div>
                  <div class="last_updated">Last Updated: {{creditHistory.createdDate | date: 'dd-MM-yyyy'}}
                  </div>
                </div>
              </div>
              <div class='d-block d-md-none customWidthNewCS'>
                <owl-carousel-o (window:resize)="onResize($event)" [options]="customOptionsNewCreditScore" *ngIf="this.scoreNumber>2">

                  <ng-template carouselSlide *ngIf="this.scoreNumber>=801">
                    <div class="itemNewCS">
                      <div class="d-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="39" height="38" viewBox="0 0 39 38" fill="none">
                          <g filter="url(#filter0_d_4721_34022)">
                            <path
                              d="M34.5 18C34.5 26.2843 27.7843 33 19.5 33C11.2157 33 4.5 26.2843 4.5 18C4.5 9.71573 11.2157 3 19.5 3C27.7843 3 34.5 9.71573 34.5 18Z"
                              fill="white" />
                            <path
                              d="M19.6389 7C19.3322 7 19.0343 7.10892 18.6578 7.29283C18.3573 7.43924 13.3434 10.1756 12.7725 10.488C12.5223 10.6246 12.4287 10.9407 12.5639 11.1942C12.6991 11.4469 13.012 11.5415 13.263 11.4049C15.4964 10.1863 18.8956 8.33468 19.1068 8.23202C19.6185 7.98204 19.6839 8.00258 19.9906 8.16774C20.2319 8.29808 25.7752 11.1728 26.0112 11.2951C26.2649 11.4263 26.5751 11.3254 26.7059 11.0692C26.8358 10.813 26.736 10.4996 26.4823 10.3675C24.4858 9.3319 20.6623 7.34907 20.475 7.2473C20.1559 7.07588 19.8943 7 19.6389 7Z"
                              fill="#61A60E" />
                            <path
                              d="M24.9798 14.5269H21.0309V17.273H17.4841V19.8406H14.2803L14.282 11.6495C16.4368 10.4737 19.6159 8.76321 19.6566 8.74625C19.6566 8.74625 19.661 8.74803 19.6627 8.74982C19.8616 8.85695 23.3889 10.6871 24.9807 11.512L24.9798 14.5269Z"
                              fill="#61A60E" />
                            <path
                              d="M26.2447 23.7331C26.1616 23.7331 26.0777 23.7536 25.9999 23.7956C23.7665 25.0142 20.3673 26.8658 20.1561 26.9685C19.6443 27.2185 19.5789 27.1979 19.2722 27.0328C19.031 26.9024 13.4876 24.0277 13.2516 23.9063C12.998 23.7751 12.6878 23.8759 12.557 24.1322C12.427 24.3884 12.5269 24.7018 12.7806 24.833C14.7762 25.8677 18.5988 27.8514 18.7861 27.9523C19.487 28.33 19.9139 28.2442 20.6042 27.9068C20.9047 27.7604 25.9186 25.0232 26.4895 24.7116C26.7405 24.575 26.8333 24.2589 26.6981 24.0054C26.6044 23.8313 26.4277 23.7322 26.2438 23.7322"
                              fill="#A2D45E" />
                            <path
                              d="M24.9798 23.5519C22.8251 24.7276 19.646 26.4382 19.6053 26.4551C19.6053 26.4551 19.6009 26.4534 19.5991 26.4516C19.4003 26.3444 15.8712 24.5143 14.2803 23.6894V20.579H18.2159V18.0114H21.7627V15.2652H24.9807L24.9798 23.5519Z"
                              fill="#A2D45E" />
                          </g>
                          <defs>
                            <filter id="filter0_d_4721_34022" x="0.5" y="0" width="38" height="38" filterUnits="userSpaceOnUse"
                              color-interpolation-filters="sRGB">
                              <feFlood flood-opacity="0" result="BackgroundImageFix" />
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha" />
                              <feOffset dy="1" />
                              <feGaussianBlur stdDeviation="2" />
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4721_34022" />
                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4721_34022" result="shape" />
                            </filter>
                          </defs>
                        </svg>
                        <img src="../../assets/images/SanlamLogo.svg" alt="sanlamlogo" class="card_icon"/>
                        <!-- <img src="../../assets/images/NedbankLogo.svg" alt="nedbanklogo" class="card_icon"/> -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="39" height="38" style="margin-left: '-18px';" viewBox="0 0 39 38" fill="none">
                          <g filter="url(#filter0_d_4721_34025)">
                            <path
                              d="M34.5 18C34.5 26.2843 27.7843 33 19.5 33C11.2157 33 4.5 26.2843 4.5 18C4.5 9.71573 11.2157 3 19.5 3C27.7843 3 34.5 9.71573 34.5 18Z"
                              fill="white" />
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M19.5 12C19.7761 12 20 12.2239 20 12.5V17.5H25C25.2761 17.5 25.5 17.7239 25.5 18C25.5 18.2761 25.2761 18.5 25 18.5H20V23.5C20 23.7761 19.7761 24 19.5 24C19.2239 24 19 23.7761 19 23.5V18.5H14C13.7239 18.5 13.5 18.2761 13.5 18C13.5 17.7239 13.7239 17.5 14 17.5H19V12.5C19 12.2239 19.2239 12 19.5 12Z"
                              fill="#3D4A59" />
                          </g>
                          <defs>
                            <filter id="filter0_d_4721_34025" x="0.5" y="0" width="38" height="38" filterUnits="userSpaceOnUse"
                              color-interpolation-filters="sRGB">
                              <feFlood flood-opacity="0" result="BackgroundImageFix" />
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha" />
                              <feOffset dy="1" />
                              <feGaussianBlur stdDeviation="2" />
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4721_34025" />
                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4721_34025" result="shape" />
                            </filter>
                          </defs>
                        </svg>


                      </div>
                      <div class="head_card">Check out your personal offers</div>
                      <div class="subHead_card">See what you qualify for based on your credit score</div>
                      <button class="btnNewCS" id="btn_userJourney_offersPage_creditScoreTile_dashboard" name="btn_userJourney_offersPage_creditScoreTile_dashboard" routerLink="/portal/solutions">View my offers</button>
                    </div>
                  </ng-template>

                  <ng-template carouselSlide *ngIf="this.scoreNumber>=3">
                    <div class="itemNewCS">
                      <div class="d-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="39" height="38" viewBox="0 0 39 38" fill="none">
                          <g filter="url(#filter0_d_4721_34019)">
                            <path
                              d="M34.5 18C34.5 26.2843 27.7843 33 19.5 33C11.2157 33 4.5 26.2843 4.5 18C4.5 9.71573 11.2157 3 19.5 3C27.7843 3 34.5 9.71573 34.5 18Z"
                              fill="white" />
                            <path
                              d="M12 14C12 12.8954 12.8954 12 14 12H26C27.1046 12 28 12.8954 28 14V22C28 23.1046 27.1046 24 26 24H14C12.8954 24 12 23.1046 12 22V14ZM14 13C13.4477 13 13 13.4477 13 14V15H27V14C27 13.4477 26.5523 13 26 13H14ZM27 17H13V22C13 22.5523 13.4477 23 14 23H26C26.5523 23 27 22.5523 27 22V17Z"
                              fill="#4AAEAC" />
                            <path
                              d="M14 20C14 19.4477 14.4477 19 15 19H16C16.5523 19 17 19.4477 17 20V21C17 21.5523 16.5523 22 16 22H15C14.4477 22 14 21.5523 14 21V20Z"
                              fill="#4AAEAC" />
                          </g>
                          <defs>
                            <filter id="filter0_d_4721_34019" x="0.5" y="0" width="38" height="38" filterUnits="userSpaceOnUse"
                              color-interpolation-filters="sRGB">
                              <feFlood flood-opacity="0" result="BackgroundImageFix" />
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha" />
                              <feOffset dy="1" />
                              <feGaussianBlur stdDeviation="2" />
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4721_34019" />
                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4721_34019" result="shape" />
                            </filter>
                          </defs>
                        </svg>
                      </div>
                      <div class="head_card">Understand your credit score</div>
                      <div class="subHead_card">View the account details influencing your credit score</div>
                      <button class="btnNewCS" id="btn_userJourney_creditReport_creditScoreTile_dashboard" name="btn_userJourney_creditReport_creditScoreTile_dashboard" routerLink="/portal/account">View my credit report</button>
                    </div>
                  </ng-template>

                  <ng-template carouselSlide *ngIf="this.scoreNumber>=3">
                    <div class="itemNewCS">
                      <div class="d-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="39" height="38" viewBox="0 0 39 38" fill="none">
                          <g filter="url(#filter0_d_4721_34020)">
                            <path
                              d="M34.5 18C34.5 26.2843 27.7843 33 19.5 33C11.2157 33 4.5 26.2843 4.5 18C4.5 9.71573 11.2157 3 19.5 3C27.7843 3 34.5 9.71573 34.5 18Z"
                              fill="white" />
                            <path
                              d="M26.6715 22.3461C26.9935 22.5966 27.0231 23.0725 26.7347 23.361L25.7008 24.3949C25.2173 24.8784 24.5323 25.0561 23.9315 24.8449C21.5188 23.9966 19.2533 22.6078 17.3227 20.6773C15.3922 18.7467 14.0034 16.4812 13.1551 14.0685C12.9439 13.4677 13.1216 12.7827 13.6051 12.2992L14.639 11.2653C14.9274 10.9769 15.4034 11.0065 15.6539 11.3285L17.4476 13.6347C17.5755 13.7992 17.6207 14.0134 17.5702 14.2155L17.0229 16.4046C16.8743 16.9992 17.0485 17.6282 17.4819 18.0616L19.9384 20.5181C20.3718 20.9515 21.0008 21.1257 21.5954 20.9771L23.7845 20.4298C23.9866 20.3793 24.2008 20.4245 24.3653 20.5524L26.6715 22.3461ZM27.4889 24.1152C28.231 23.3731 28.1548 22.1485 27.3264 21.5042L25.0202 19.7105C24.597 19.3813 24.0459 19.265 23.5258 19.395L21.3367 19.9423C21.1056 20.0001 20.8611 19.9323 20.6927 19.7639L18.2361 17.3073C18.0677 17.1389 17.9999 16.8944 18.0577 16.6633L18.605 14.4742C18.735 13.9541 18.6187 13.403 18.2895 12.9798L16.4958 10.6736C15.8515 9.8452 14.6269 9.76896 13.8848 10.5111L12.8508 11.545C12.1111 12.2847 11.7863 13.3911 12.1488 14.4222C13.0489 16.9825 14.5226 19.3856 16.5685 21.4315C18.6144 23.4774 21.0175 24.9511 23.5778 25.8512C24.6089 26.2137 25.7153 25.8889 26.455 25.1492L27.4889 24.1152Z"
                              fill="#E59A2C" />
                          </g>
                          <defs>
                            <filter id="filter0_d_4721_34020" x="0.5" y="0" width="38" height="38" filterUnits="userSpaceOnUse"
                              color-interpolation-filters="sRGB">
                              <feFlood flood-opacity="0" result="BackgroundImageFix" />
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha" />
                              <feOffset dy="1" />
                              <feGaussianBlur stdDeviation="2" />
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4721_34020" />
                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4721_34020" result="shape" />
                            </filter>
                          </defs>
                        </svg>
                      </div>
                      <div class="head_card">Talk to an expert</div>
                      <div class="subHead_card">Discover how you can improve your credit score and more</div>
                      <button class="btnNewCS" id="btn_leadGen_coach_callBack_creditScoreTile_dashboard" name="btn_leadGen_coach_callBack_creditScoreTile_dashboard" (click)="creditScoreCoachCallback(48)">Chat to a coach</button>
                    </div>
                  </ng-template>
                </owl-carousel-o>
              </div>
            
            </div>
            </div>
          </div>
          <div *ngIf="IsCreditInsightFetched" class="d-block d-md-none col-md-5 col-12"><!-- For mobile only-->
            <div class="bggrmobile" *ngIf="!creditInsightData?.length">
              <h2 class="page-caption">Your Credit Score History</h2>
              <div class="scorebox">
                <app-credit-score-history [item]="ChartId[1]"></app-credit-score-history>
              </div>
            </div>
            <!-- Credit insight  -->
            <div id="appcreditinsight" *ngIf="creditInsightData?.length > 0">
              <app-credit-insights></app-credit-insights>
            </div>
          </div> 
        
        <!-- For Desktop only-->
          <div class="col-md-5 col-12 px-md-3 px-3 bggrmobile d-none d-md-block">
            <h2 class="page-caption">Your Credit Score History</h2>
            <div class="scorebox">
              <app-credit-score-history [item]="ChartId[2]"></app-credit-score-history>
            </div>
          </div>
</div>
      </div>
    </div>
  </section>
  <section class="bg-gry pb-5 b5containeradjust pt-md-5 mb-bg-2 d-md-block d-none">
    <div class="container">
      <div class="d-flex align-items-stretch gap16 px-3">
        <!-- progress bar-->
        <div class="col-md-6" *ngIf="isDataAvailable || isDataAvailable==null">

          <h3 class="fw-bold text-start medium_title">How You Compare
            <ng-template #tipContent>* For your age group the average salary to debt ratio is 23%</ng-template>
          </h3>

          <div class="bg-white px-md-5 mt-3 pt-md-5 pb-md-5 boxShadow">

            <div class="">
              <div class="spc-score-bar">
                <span class="your-sc-text-blue" [style.margin-left]="scoreProgress+'%'">
                  <div class="item">
                    <p>Your score</p>
                    <svg [ngClass]="setClassesScoreProgress()" height="25px" id="Layer_1"
                      style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="25px"
                      xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <path
                        d="M98.9,184.7l1.8,2.1l136,156.5c4.6,5.3,11.5,8.6,19.2,8.6c7.7,0,14.6-3.4,19.2-8.6L411,187.1l2.3-2.6  c1.7-2.5,2.7-5.5,2.7-8.7c0-8.7-7.4-15.8-16.6-15.8v0H112.6v0c-9.2,0-16.6,7.1-16.6,15.8C96,179.1,97.1,182.2,98.9,184.7z" />
                    </svg>
                    <p class="percentage" [ngClass]="setClassesScoreProgress()">{{scoreProgress}}%</p>
                  </div>
                </span>
                <div class="bar"></div>
                <div class="d-flex flex-wrap">
                  <div class="number-grap mobile-spce-maintain0">0%</div>
                  <div class="number-grap">20%</div>
                  <div class="number-grap">40%</div>
                  <div class="number-grap">60%</div>
                  <div class="number-grap d-flex justify-content-between"><span>80%</span> <span
                      class="mobile-spce-maintain1">100%</span> </div>
                </div>
                <span class="your-sc-text-blue" [style.margin-left]="scoreAgeProgress+'%'">
                  <div class="item">
                    <p class="percentage" [ngClass]="setClassesScoreAgeProgress()">
                      {{scoreAgeProgress}}%
                    </p>
                    <svg [ngClass]="setClassesScoreAgeProgress()" height="25px" id="Layer_1"
                      style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="25px"
                      xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <path
                        d="M413.1,327.3l-1.8-2.1l-136-156.5c-4.6-5.3-11.5-8.6-19.2-8.6c-7.7,0-14.6,3.4-19.2,8.6L101,324.9l-2.3,2.6  C97,330,96,333,96,336.2c0,8.7,7.4,15.8,16.6,15.8v0h286.8v0c9.2,0,16.6-7.1,16.6-15.8C416,332.9,414.9,329.8,413.1,327.3z" />
                    </svg>
                    <p>Average for your age group</p>
                  </div>
                </span>
              </div>
            </div>
          </div>

        </div>
        <!-- progress bar-->
        <div class="col-md-6 " *ngIf="isDataAvailable || isDataAvailable==null">

          <h3 class="fw-bold text-start mb-1 medium_title">Understand Your Financial Health</h3>

          <div *ngIf="!showSolution" class="bg-white mt-3 boxShadow">
            <div class="innerDiv">
              <div class="text">How much of your income goes towards debt?</div>
              <div class="infographics">
                <div class="dataViz" >
                  <svg viewBox="0 0 36 36" class="circle-svg-large">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent"
                      [style.strokeDasharray]="creditHealthInfo.salaryGoingTowardDebtPercent + ' ' + (100-debtToIncomeInfo.debtToIncomeRatio)"
                      [style.stroke]="debtToIncomeInfo?.dtiColorCode"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" 
                    [attr.y]="(debtToIncomeInfo.isDCEligible && debtToIncomeInfo.debtToIncomeRatio >= 40) ? 10 : 12"
                    text-anchor="middle" dy="6" font-size="6"
                      >{{debtToIncomeInfo.debtToIncomeRatio}}%
                    </text>
                    <text x="18" 
                    [attr.y]="(debtToIncomeInfo.isDCEligible && debtToIncomeInfo.debtToIncomeRatio >= 40) ? 20 : 22"
                    text-anchor="middle" font-size="3" font-weight="400">goes to debt</text>
                  </svg>
                  <button *ngIf="(debtToIncomeInfo.isDCEligible && debtToIncomeInfo.debtToIncomeRatio>=40)" id="btn_auxilaryButton_debtAffordability_viewSolution_dashboard" name="btn_auxilaryButton_debtAffordability_viewSolution_dashboard" class="solution_button_show" (click)="toggleSolution()">
                    View solution
                  </button>
                </div>
                <div class="dataPoint">
                  <div class="debt_repay">
                    <div class="d-flex align align-items-center gap8">
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <circle cx="9.96777" cy="9.26334" r="9" [attr.fill]="debtToIncomeInfo?.dtiColorCode" />
                      </svg>
                      <div>Your monthly debt repayment:</div>
                    </div>
                    <div class="value" [style.color]="debtToIncomeInfo?.dtiColorCode">R {{debtToIncomeInfo.debtRepayments | number:'1.0-0'}}</div>
                  </div>
                  <div class="left_over">
                    <div class="d-flex align-items-center gap8">
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <circle cx="9.96777" cy="9.26334" r="9" fill="#E9E9E9" />
                      </svg>
                      <div>What you have left:</div>
                    </div>
                    <div class="value" *ngIf="debtToIncomeInfo.netIncomeAfterDebt>=0">R {{debtToIncomeInfo.netIncomeAfterDebt | number:'1.0-0'}}</div>
                    <div class="value" *ngIf="debtToIncomeInfo.netIncomeAfterDebt<0">(R {{debtToIncomeInfo.netIncomeAfterDebt | number:'1.0-0'}})</div>
                  </div>
                  <div class="line_break"></div>
                  <div class="d-flex justify-content-center align-items-center gap8">Your monthly income: <span class="text-bold text-nowrap">R {{debtToIncomeInfo.grossIncome | number:'1.0-0'}}</span> 
                    <span class="cursor_pointer" (click)="showUpdateIncomeModel('debtAffordability')">
                     <a id="btn_auxilaryButton_userInput_editIncome_debtAffordability" name="btn_auxilaryButton_userInput_editIncome_debtAffordability"> <svg xmlns="http://www.w3.org/2000/svg" width="17" height="21" viewBox="0 0 17 21" fill="none">
                        <path
                          d="M15.0547 3.27524C14.3981 2.6187 13.3337 2.6187 12.6772 3.27524L6.01232 9.9401C5.96665 9.98577 5.93367 10.0424 5.91645 10.1046L5.04 13.2687C5.00395 13.3985 5.04058 13.5374 5.13573 13.6327C5.23102 13.7278 5.36994 13.7645 5.49968 13.7286L8.66385 12.852C8.72601 12.8347 8.78263 12.8018 8.82831 12.7561L15.493 6.09108C16.1485 5.43411 16.1485 4.37058 15.493 3.71361L15.0547 3.27524ZM6.82631 10.1829L12.281 4.7281L14.0402 6.48728L8.58534 11.9421L6.82631 10.1829ZM6.47492 10.8881L7.88036 12.2936L5.93629 12.8323L6.47492 10.8881ZM14.9648 5.56282L14.5686 5.95901L12.8092 4.1997L13.2056 3.8035C13.5703 3.43882 14.1616 3.43882 14.5262 3.8035L14.9648 4.24187C15.3289 4.60698 15.3289 5.19785 14.9648 5.56282Z"
                          fill="black" stroke="black" stroke-width="0.560367" />
                        <path
                          d="M14.8288 12.1489C14.6224 12.1489 14.4552 12.3161 14.4552 12.5225V15.8394C14.4545 16.4582 13.9532 16.9596 13.3345 16.9602H2.85226C2.23353 16.9596 1.73226 16.4582 1.73153 15.8394V6.10437C1.73226 5.48578 2.23353 4.98437 2.85226 4.98364H6.16922C6.37557 4.98364 6.5428 4.8164 6.5428 4.61006C6.5428 4.40386 6.37557 4.23648 6.16922 4.23648H2.85226C1.82113 4.23765 0.985542 5.07324 0.984375 6.10437V15.8396C0.985542 16.8707 1.82113 17.7063 2.85226 17.7075H13.3345C14.3656 17.7063 15.2012 16.8707 15.2024 15.8396V12.5225C15.2024 12.3161 15.0351 12.1489 14.8288 12.1489Z"
                          fill="black" stroke="black" stroke-width="0.747155" /> 
                      </svg></a>
                    </span>
                  </div>
                  <div class="info_box"  [style.background]="convertHexToRGBA(debtToIncomeInfo?.dtiColorCode, 0.1)">
                    <div class="body_text_default">You’re left with <span class="text-bold">{{debtToIncomeInfo.netIncomePercent}}%</span> of your income
                    to cover all your other expenses</div>
                    <button id="btn_auxilaryButton_debtAffordability_viewMore_dashboard" name="btn_auxilaryButton_debtAffordability_viewMore_dashboard" (click)="openOffcanvas('desktop')">Why does this matter?</button>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="showSolution" class="bg-white mt-3 boxShadow boxShadow_sol ">
            <div class="innerDiv">
              <div class="text">How much of your income goes towards debt?</div>
              <div class="infographics">
                <div class="dataViz">
                  <svg viewBox="0 0 36 36" class="circle-svg-large">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent" [style.strokeDasharray]="debtToIncomeInfo.debtToIncomeRatio + ', 100'"
                        [style.stroke]="debtToIncomeInfo?.solutionColorCode"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent"
                        [style.strokeDasharray]="debtToIncomeInfo.dcrsToIncomeRatio + ', 100'"
                        [style.stroke]="debtToIncomeInfo?.dcrsColorCode"
                        
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      
                    <!-- [style.fill]="creditHealthInfoUiTextElement.salaryTowardDebt?.colorCode" -->
                    <text x="18" y="10" text-anchor="middle" dy="6" font-size="6"
                      >{{debtToIncomeInfo.dcrsToIncomeRatio}}%
                    </text>
                    <text x="18" y="20" text-anchor="middle" font-size="3" font-weight="400">goes to debt</text>
                  </svg>
                  <button class="solution_button_hide" id="btn_auxilaryButton_debtAffordability_hideSolution_dashboard" name="btn_auxilaryButton_debtAffordability_hideSolution_dashboard" (click)="toggleSolution()">
                    Hide solution
                  </button>
                </div>
                <div class="dataPoint">
                  <div class="debt_repay">
                    <div class="d-flex align align-items-center gap8">
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <circle cx="9.96777" cy="9.26334" r="9" [attr.fill] = "debtToIncomeInfo?.dcrsColorCode" />
                      </svg>
                      <div>Your NEW debt repayment could be:</div>
                    </div>
                    <div class="value" [style.color]="debtToIncomeInfo?.dcrsColorCode">R {{debtToIncomeInfo.dcrs | number:'1.0-0'}}</div>
                  </div>
                  <div class="left_over">
                    <div class="d-flex align-items-center gap8">
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <circle cx="9.96777" cy="9.26334" r="9" fill="#E9E9E9" />
                      </svg>
                      <div>What you could have left:</div>
                    </div>
                    <div class="value" *ngIf="debtToIncomeInfo.netIncomeAfterDCRS>=0">R {{debtToIncomeInfo.netIncomeAfterDCRS | number:'1.0-0'}}</div>
                    <div class="value" *ngIf="debtToIncomeInfo.netIncomeAfterDCRS<0">(R {{debtToIncomeInfo.netIncomeAfterDCRS | number:'1.0-0'}})</div>

                  </div>
                  <div class="line_break"></div>
                  <div class="d-flex justify-content-center align-items-center gap8">Your monthly income:
                    <span class="text-bold text-nowrap">R {{debtToIncomeInfo.grossIncome | number:'1.0-0'}}</span>
                      
                  </div>
                  <div class="info_box" [style.background]="convertHexToRGBA(debtToIncomeInfo?.dcrsColorCode, 0.1)">
                    <div class="d-flex body_text_sol">
                      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                        <path
                          d="M2.96777 6.32642C2.96777 3.01271 5.65407 0.326416 8.96777 0.326416C12.2815 0.326416 14.9678 3.01271 14.9678 6.32642C14.9678 8.01766 14.2674 9.54619 13.1421 10.6363C12.9392 10.8329 12.783 11.0371 12.689 11.2551L11.927 13.0242C11.848 13.2076 11.6675 13.3264 11.4678 13.3264C11.7439 13.3264 11.9678 13.5503 11.9678 13.8264C11.9678 14.1026 11.7439 14.3264 11.4678 14.3264C11.7439 14.3264 11.9678 14.5503 11.9678 14.8264C11.9678 15.1026 11.7439 15.3264 11.4678 15.3264L11.2442 15.7736C11.0748 16.1124 10.7285 16.3264 10.3497 16.3264H7.58581C7.20704 16.3264 6.86077 16.1124 6.69138 15.7736L6.46777 15.3264C6.19163 15.3264 5.96777 15.1026 5.96777 14.8264C5.96777 14.5503 6.19163 14.3264 6.46777 14.3264C6.19163 14.3264 5.96777 14.1026 5.96777 13.8264C5.96777 13.5503 6.19163 13.3264 6.46777 13.3264C6.2681 13.3264 6.08756 13.2076 6.00857 13.0242L5.2465 11.2551C5.15258 11.0371 4.99635 10.8329 4.79341 10.6363C3.66817 9.54619 2.96777 8.01766 2.96777 6.32642ZM8.96777 1.32642C6.20635 1.32642 3.96777 3.56499 3.96777 6.32642C3.96777 7.73594 4.55036 9.00852 5.4892 9.91801C5.75177 10.1724 6.00242 10.4823 6.16491 10.8595L6.79681 12.3264H11.1387L11.7706 10.8595C11.9331 10.4823 12.1838 10.1724 12.4463 9.91801C13.3852 9.00852 13.9678 7.73594 13.9678 6.32642C13.9678 3.56499 11.7292 1.32642 8.96777 1.32642Z"
                          fill="#E59A2C" />
                      </svg>
                      <div>You could <span class="text-bold">free up R {{debtToIncomeInfo.debtRepaymentsAfterDCRS | number:'1.0-0'}} more</span> with debt consolidation</div>
                    </div>
                    <button (click)="expertCallbackPopup()" id="btn_leadGen_consolidateLoan_callBack_debtAffordabilitySolution" name="btn_leadGen_consolidateLoan_callBack_debtAffordabilitySolution" [style.background]="debtToIncomeInfo?.dcrsColorCode">Talk to an expert to learn how</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>

  <section class="bg-gry pb-4 pt-4 pt-md-5 b5containeradjust mb-bg-2 d-block d-md-none">
    <div class="container">
      <div class="d-flex align-items-stretch">
        <!-- progress bar-->
        <div class="col-md-12 col-12 px-md-0 px-3" *ngIf="isDataAvailable || isDataAvailable==null">
  
          <h3 class="fw-bold text-start">Understand Your Financial Health
          </h3>
  
          <div *ngIf="!showSolution" class="bg-white mt-3 boxShadow">
            <div class="innerDiv">
              <div class="text">How much of your income goes towards debt?</div>
              <div class="infographics">
                <div class="dataViz">
                  <svg viewBox="0 0 36 36" class="circle-svg-large">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent"
                      [style.strokeDasharray]="creditHealthInfo.salaryGoingTowardDebtPercent + ' ' + (100-debtToIncomeInfo.debtToIncomeRatio)"
                      [style.stroke]="debtToIncomeInfo?.dtiColorCode"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <!-- [style.fill]="creditHealthInfoUiTextElement.salaryTowardDebt?.colorCode" -->
                    <text x="18" 
                    [attr.y]="(debtToIncomeInfo.isDCEligible && debtToIncomeInfo.debtToIncomeRatio >= 40) ? 10 : 12"
                     text-anchor="middle" dy="6" font-size="6"
                      >{{debtToIncomeInfo.debtToIncomeRatio}}%
                    </text>
                    <text x="18" 
                    [attr.y]="(debtToIncomeInfo.isDCEligible && debtToIncomeInfo.debtToIncomeRatio >= 40) ? 20 : 22"
                      text-anchor="middle" font-size="3" font-weight="400">goes to debt</text>
                  </svg>
                  <button *ngIf="(debtToIncomeInfo.isDCEligible && debtToIncomeInfo.debtToIncomeRatio>=40)"
                    id="btn_auxilaryButton_debtAffordability_viewSolution_dashboard"
                    name="btn_auxilaryButton_debtAffordability_viewSolution_dashboard" class="solution_button_show"
                    (click)="toggleSolution()">
                    View solution
                  </button>
                </div>
                <div class="dataPoint">
                  <div class="debt_repay">
                    <div class="d-flex align align-items-center gap8">
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <circle cx="9.96777" cy="9.26334" r="9" [attr.fill]="debtToIncomeInfo?.dtiColorCode" />
                      </svg>
                      <div>Your monthly debt repayment:</div>
                    </div>
                    <div class="value" [style.color]="debtToIncomeInfo?.dtiColorCode">R {{debtToIncomeInfo.debtRepayments | number:'1.0-0'}}</div>
                  </div>
                  <div class="left_over">
                    <div class="d-flex align-items-center gap8">
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <circle cx="9.96777" cy="9.26334" r="9" fill="#E9E9E9" />
                      </svg>
                      <div>What you have left:</div>
                    </div>
                    <div class="value" *ngIf="debtToIncomeInfo.netIncomeAfterDebt>=0">R
                      {{debtToIncomeInfo.netIncomeAfterDebt | number:'1.0-0'}}</div>
                    <div class="value" *ngIf="debtToIncomeInfo.netIncomeAfterDebt<0">(R
                      {{debtToIncomeInfo.netIncomeAfterDebt | number:'1.0-0'}})</div>
                  </div>
                  <div class="line_break"></div>
                  <div class="d-flex justify-content-center align-items-center gap8 align-items-stretch">Your monthly
                    income:
                    <span class="text-bold">R {{debtToIncomeInfo.grossIncome | number:'1.0-0'}}</span>
                    <span class="cursor_pointer" (click)="showUpdateIncomeModel()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="21" viewBox="0 0 17 21" fill="none">
                        <path
                          d="M15.0547 3.27524C14.3981 2.6187 13.3337 2.6187 12.6772 3.27524L6.01232 9.9401C5.96665 9.98577 5.93367 10.0424 5.91645 10.1046L5.04 13.2687C5.00395 13.3985 5.04058 13.5374 5.13573 13.6327C5.23102 13.7278 5.36994 13.7645 5.49968 13.7286L8.66385 12.852C8.72601 12.8347 8.78263 12.8018 8.82831 12.7561L15.493 6.09108C16.1485 5.43411 16.1485 4.37058 15.493 3.71361L15.0547 3.27524ZM6.82631 10.1829L12.281 4.7281L14.0402 6.48728L8.58534 11.9421L6.82631 10.1829ZM6.47492 10.8881L7.88036 12.2936L5.93629 12.8323L6.47492 10.8881ZM14.9648 5.56282L14.5686 5.95901L12.8092 4.1997L13.2056 3.8035C13.5703 3.43882 14.1616 3.43882 14.5262 3.8035L14.9648 4.24187C15.3289 4.60698 15.3289 5.19785 14.9648 5.56282Z"
                          fill="black" stroke="black" stroke-width="0.560367" />
                        <path
                          d="M14.8288 12.1489C14.6224 12.1489 14.4552 12.3161 14.4552 12.5225V15.8394C14.4545 16.4582 13.9532 16.9596 13.3345 16.9602H2.85226C2.23353 16.9596 1.73226 16.4582 1.73153 15.8394V6.10437C1.73226 5.48578 2.23353 4.98437 2.85226 4.98364H6.16922C6.37557 4.98364 6.5428 4.8164 6.5428 4.61006C6.5428 4.40386 6.37557 4.23648 6.16922 4.23648H2.85226C1.82113 4.23765 0.985542 5.07324 0.984375 6.10437V15.8396C0.985542 16.8707 1.82113 17.7063 2.85226 17.7075H13.3345C14.3656 17.7063 15.2012 16.8707 15.2024 15.8396V12.5225C15.2024 12.3161 15.0351 12.1489 14.8288 12.1489Z"
                          fill="black" stroke="black" stroke-width="0.747155" />
                      </svg>
                    </span>
                  </div>
                  <div class="info_box" [style.background]="convertHexToRGBA(debtToIncomeInfo?.dtiColorCode, 0.1)">
                    <div class="body_text_default">You’re left with <span class="text-bold">{{debtToIncomeInfo.netIncomePercent}}%</span> of your
                      income
                      to cover all your other expenses</div>
                    <button id="btn_auxilaryButton_debtAffordability_viewMore_dashboard"
                      name="btn_auxilaryButton_debtAffordability_viewMore_dashboard" (click)="openOffcanvas('mobile')">Why
                      does this matter?</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <div *ngIf="showSolution" class="bg-white mt-3 boxShadow boxShadow_sol">
            <div class="innerDiv">
              <div class="text">How much of your income goes towards debt?</div>
              <div class="infographics">
                <div class="dataViz">
                  <svg viewBox="0 0 36 36" class="circle-svg-large">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent" [style.strokeDasharray]="debtToIncomeInfo.debtToIncomeRatio + ', 100'"
                      [style.stroke]="debtToIncomeInfo?.solutionColorCode"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent" [style.strokeDasharray]="debtToIncomeInfo.dcrsToIncomeRatio + ', 100'"
                      [style.stroke]="debtToIncomeInfo?.dcrsColorCode"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <!-- [style.fill]="creditHealthInfoUiTextElement.salaryTowardDebt?.colorCode" -->
                    <text x="18" y="10" text-anchor="middle" dy="6" font-size="6"
                      >{{debtToIncomeInfo.dcrsToIncomeRatio}}%
                    </text>
                    <text x="18" y="20" text-anchor="middle" font-size="3" font-weight="400">goes to debt</text>
                  </svg>
                  <button class="solution_button_hide" id="btn_auxilaryButton_debtAffordability_hideSolution_dashboard"
                    name="btn_auxilaryButton_debtAffordability_hideSolution_dashboard" (click)="toggleSolution()">
                    Hide solution
                  </button>
                </div>
                <div class="dataPoint">
                  <div class="debt_repay">
                    <div class="d-flex align align-items-center gap8">
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <circle cx="9.96777" cy="9.26334" r="9" [attr.fill]="debtToIncomeInfo?.dcrsColorCode" />
                      </svg>
                      <div>Your NEW debt repayment could be:</div>
                    </div>
                    <div class="value" [style.color]="debtToIncomeInfo?.dcrsColorCode">R {{debtToIncomeInfo.dcrs |
                      number:'1.0-0'}}</div>
                  </div>
                  <div class="left_over">
                    <div class="d-flex align-items-center gap8">
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <circle cx="9.96777" cy="9.26334" r="9" fill="#E9E9E9" />
                      </svg>
                      <div>What you could have left:</div>
                    </div>
                    <div class="value">R {{debtToIncomeInfo.netIncomeAfterDCRS | number:'1.0-0'}}</div>
                  </div>
                  <div class="line_break"></div>
                  <div class="d-flex justify-content-center align-items-center gap8 align-items-stretch">Your monthly
                    income:
                    <span class="text-bold">R {{debtToIncomeInfo.grossIncome | number:'1.0-0'}}</span>
                    
                  </div>
                  <div class="info_box" [style.background]="convertHexToRGBA(debtToIncomeInfo?.dcrsColorCode, 0.1)">
                    <div class="d-flex body_text_sol">
                      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                        <path
                          d="M2.96777 6.32642C2.96777 3.01271 5.65407 0.326416 8.96777 0.326416C12.2815 0.326416 14.9678 3.01271 14.9678 6.32642C14.9678 8.01766 14.2674 9.54619 13.1421 10.6363C12.9392 10.8329 12.783 11.0371 12.689 11.2551L11.927 13.0242C11.848 13.2076 11.6675 13.3264 11.4678 13.3264C11.7439 13.3264 11.9678 13.5503 11.9678 13.8264C11.9678 14.1026 11.7439 14.3264 11.4678 14.3264C11.7439 14.3264 11.9678 14.5503 11.9678 14.8264C11.9678 15.1026 11.7439 15.3264 11.4678 15.3264L11.2442 15.7736C11.0748 16.1124 10.7285 16.3264 10.3497 16.3264H7.58581C7.20704 16.3264 6.86077 16.1124 6.69138 15.7736L6.46777 15.3264C6.19163 15.3264 5.96777 15.1026 5.96777 14.8264C5.96777 14.5503 6.19163 14.3264 6.46777 14.3264C6.19163 14.3264 5.96777 14.1026 5.96777 13.8264C5.96777 13.5503 6.19163 13.3264 6.46777 13.3264C6.2681 13.3264 6.08756 13.2076 6.00857 13.0242L5.2465 11.2551C5.15258 11.0371 4.99635 10.8329 4.79341 10.6363C3.66817 9.54619 2.96777 8.01766 2.96777 6.32642ZM8.96777 1.32642C6.20635 1.32642 3.96777 3.56499 3.96777 6.32642C3.96777 7.73594 4.55036 9.00852 5.4892 9.91801C5.75177 10.1724 6.00242 10.4823 6.16491 10.8595L6.79681 12.3264H11.1387L11.7706 10.8595C11.9331 10.4823 12.1838 10.1724 12.4463 9.91801C13.3852 9.00852 13.9678 7.73594 13.9678 6.32642C13.9678 3.56499 11.7292 1.32642 8.96777 1.32642Z"
                          fill="#E59A2C" />
                      </svg>
                      <div>You could <span class="text-bold">free up R {{debtToIncomeInfo.debtRepaymentsAfterDCRS |
                          number:'1.0-0'}} more</span> with debt consolidation</div>
                    </div>
                    <button [style.background]="debtToIncomeInfo?.dcrsColorCode"
                      (click)="expertCallbackPopup()"
                      id="btn_leadGen_consolidateLoan_callBack_debtAffordabilitySolution"
                      name="btn_leadGen_consolidateLoan_callBack_debtAffordabilitySolution">Talk to an expert to learn
                      how</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
        </div>
        <!-- progress bar-->
      </div>
    </div>
  </section>

  <!--Sheet For Desktop start-->
  <div  #offcanvasDTIDesktop class="offcanvas offcanvas-end px-2" tabindex="-1" id="offcanvasDTIDesktop" aria-labelledby="offcanvasLabel">
  <div class="offcanvas-header pt-md-5">
    <button type="button" id="btn_auxiliaryButton_debtAffordability_viewMore_sheet_journeyEnd_close" name="btn_auxiliaryButton_debtAffordability_viewMore_sheet_journeyEnd_close" class="btn-close text-reset pt-2" (click)="closeOffcanvas('desktop')"></button>
  </div>
  <div class="offcanvas-body">
    <div class="d-flex flex-column align-items-center">
    <h1 class="offcanvas-header-heading">Your debt-to-income (DTI) ratio is <span [style.color]="debtToIncomeInfo?.dtiColorCode">{{debtToIncomeInfo.debtToIncomeRatio}}%</span></h1>
    <p class="offcanvas-header-desc">This measures how much of your income goes towards your debt repayments. A high percentage limits financial flexibility, even with a strong credit score.</p>
    </div>

    <div class="accordion accordion-flush dti-accordion mb-4" id="accordiondtidesktop">
  <div class="accordion-item">
    <h2 class="accordion-header dti-accordion-header" id="dti-desktop-accordion-heading">
      <button
        class="accordion-button collapsed dti-accordion-btn px-2"
        id="accordion_auxiliaryButton_debtAffordability_showMore_calculation"
        name="accordion_auxiliaryButton_debtAffordability_showMore_calculation"
        type="button"
        aria-expanded="false"
        aria-controls="dti-accordion-desktop"
        (click)="toggleAccordion('dti-accordion-desktop')"
      >
        How is your DTI ratio calculated?
      </button>
    </h2>
    <div id="dti-accordion-desktop" class="accordion-collapse collapse" aria-labelledby="dti-desktop-accordion-heading" >
      <div class="accordion-body dti-accordion-body">
        <div class="d-flex align-items-center justify-content-between mb-4">    
          <svg viewBox="0 0 36 36" class="offcanvas-circle-svg-large">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent"
                   [style.strokeDasharray]="debtToIncomeInfo.debtToIncomeRatio + ', 100'"
                      [style.stroke]="debtToIncomeInfo.dtiColorCode"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="6" text-anchor="middle" >
                        <tspan x="18" dy="6">Your </tspan>
                        <tspan x="18" dy="4.5">DTI Ratio</tspan>
                      </text>
                    <text x="18.5" y="26" text-anchor="middle">{{debtToIncomeInfo.debtToIncomeRatio}}%</text>
                  </svg>

                  <div>=</div>

                  <div class="d-flex flex-column align-items-center justify-content-around">

                    <div class="offcanvas-accordion-fraction"> 
                    <p>YOUR <br>Monthly debt repayment</p>
                    <h6>R {{debtToIncomeInfo.debtRepayments| number:'1.0-0'}}</h6>
                    </div>

                    <hr class="offcanvas-accordion-hr">

                    <div class="offcanvas-accordion-fraction">
                      <p>YOUR <br>Monthly income</p>
                      <h6>R {{debtToIncomeInfo.grossIncome| number:'1.0-0'}}</h6>
                    </div>

                  </div>

        </div>

        <div class="offcanvas-accordion-footext"> <span>{{debtToIncomeInfo.debtToIncomeRatio}}%</span> of your income goes towards debt,<br> 
leaving you with <span>{{debtToIncomeInfo.netIncomePercent}}%</span> to cover all other expenses.</div>



      </div>
    </div>
  </div>
</div>

<div class="offcanvas-tip-box">
  <div><img src='../../assets/images/jm-small-icon.png' width="16px"></div>
  <div class="ps-2 pe-1">
    <h6 class="offcanvas-tip-box-header">TIP: KEEP YOUR DTI RATIO BELOW 40%</h6>
    <p class="offcanvas-tip-box-desc" *ngIf="debtToIncomeInfo.debtToIncomeRatio < 40">Our coaches provide expert tips and guidance to help you succeed at every step of your financial journey.</p>
    <p class="offcanvas-tip-box-desc" *ngIf="debtToIncomeInfo.debtToIncomeRatio >= 40">You can reduce your monthly debt repayments with debt consolidation. With lower interest rates and legal protection, it&#39;s the good money choice.</p>
    <div class="offcanvas-tip-box-btns">
      <button class="w-100 darkbtn text-center" *ngIf="debtToIncomeInfo.debtToIncomeRatio < 40" 
      (click)="dtiCoachCallback(47)"
      id="btn_leadGen_coach_callBack_debtAffordabilitySheet" name="btn_leadGen_coach_callBack_debtAffordabilitySheet">
        <img src="../../assets/images/telephone-icon.png" class="icon"> <span >Speak to a coach</span></button>

      <button class="w-100 darkbtn text-center" *ngIf="debtToIncomeInfo.debtToIncomeRatio >= 40" 
          (click)="idmLeadCallback('btn_leadGen_consolidateLoan_callBack_debtAffordabilitySheet')" 
        id="btn_leadGen_consolidateLoan_callBack_debtAffordabilitySheet" 
        name="btn_leadGen_consolidateLoan_callBack_debtAffordabilitySheet">
        <img src="../../assets/images/telephone-icon.png" class="icon" ><span >Speak to an expert</span></button>
      <a href="/portal/account" id="btn_userJourney_creditReportRedirect_debtAffordability" name="btn_userJourney_creditReportRedirect_debtAffordability" class="w-100 lightbtn-darkbr">View your credit report</a>
    </div>
  </div>
</div>


  </div>
</div>
<!-- Sheet For Desktop end -->


<!-- Sheet For Mobile start -->
<div #offcanvasDTIMobile class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvasDTIMobile" aria-labelledby="offcanvasBottomLabel" >
  <div class="offcanvas-header ">
    <button type="button" id="btn_auxiliaryButton_debtAffordability_viewMore_sheet_journeyEnd_close" name="btn_auxiliaryButton_debtAffordability_viewMore_sheet_journeyEnd_close" class="btn-close text-reset pt-2" (click)="closeOffcanvas('mobile')"></button>
  </div>
  <div class="offcanvas-body">
    
    <div class="d-flex flex-column align-items-center">
    <h1 class="offcanvas-header-heading">Your debt-to-income (DTI) ratio is <span [style.color]="debtToIncomeInfo?.dtiColorCode">{{debtToIncomeInfo.debtToIncomeRatio}}%</span></h1>
    <p class="offcanvas-header-desc">This measures how much of your income goes towards your debt repayments. A high percentage limits financial flexibility, even with a strong credit score.</p>
    </div>

    <div class="accordion accordion-flush dti-accordion" id="accordiondtimobile">
  <div class="accordion-item">
    <h2 class="accordion-header dti-accordion-header" id="dti-mobile-accordion-heading">
      <button
        class="accordion-button collapsed dti-accordion-btn px-2"
        id="accordion_auxiliaryButton_debtAffordability_showMore_calculation"
        name="accordion_auxiliaryButton_debtAffordability_showMore_calculation"
        type="button"
        aria-expanded="false"
        aria-controls="dti-accordion-mobile"
        (click)="toggleAccordion('dti-accordion-mobile')"
      >
        How is your DTI ratio calculated?
      </button>
    </h2>
    <div id="dti-accordion-mobile" class="accordion-collapse collapse" aria-labelledby="dti-mobile-accordion-heading" >
      <div class="accordion-body dti-accordion-body">
        <div class="d-flex align-items-center justify-content-around mb-4">    
       <svg viewBox="0 0 36 36" class="circle-svg-small">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent"
                      [style.strokeDasharray]="creditHealthInfo.salaryGoingTowardDebtPercent + ' ' + (100-debtToIncomeInfo.debtToIncomeRatio)"
                      [style.stroke]="debtToIncomeInfo?.dtiColorCode"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <!-- [style.fill]="creditHealthInfoUiTextElement.salaryTowardDebt?.colorCode" -->
                    <text x="18" y="7" text-anchor="middle" >
                        <tspan x="18" dy="6">Your </tspan>
                        <tspan x="18" dy="4.5">DTI Ratio</tspan>
                      </text>
                    <text x="18.5" y="26" text-anchor="middle">{{debtToIncomeInfo.debtToIncomeRatio}}%</text>
                  </svg>

                  <div>=</div>

                  <div class="d-flex flex-column align-items-center justify-content-around">

                    <div class="offcanvas-accordion-fraction"> 
                    <p>YOUR <br>Monthly debt repayment</p>
                    <h6>R {{debtToIncomeInfo.debtRepayments| number:'1.0-0'}}</h6>
                    </div>

                    <hr class="offcanvas-accordion-hr">

                    <div class="offcanvas-accordion-fraction">
                      <p>YOUR <br>Monthly income</p>
                      <h6>R {{debtToIncomeInfo.grossIncome| number:'1.0-0'}}</h6>
                    </div>

                  </div>

        </div>

        <div class="offcanvas-accordion-footext"> <span>{{debtToIncomeInfo.debtToIncomeRatio}}%</span> of your income goes towards debt,<br> 
leaving you with <span>{{debtToIncomeInfo.netIncomePercent}}%</span> to cover all other expenses.</div>



      </div>
    </div>
  </div>
</div>

<div class="offcanvas-tip-box">
  <div><img src='../../assets/images/jm-small-icon.png' width="16px"></div>
  <div class="ps-2 pe-1">
    <h6 class="offcanvas-tip-box-header">TIP: KEEP YOUR DTI RATIO BELOW 40%</h6>
 <p class="offcanvas-tip-box-desc" *ngIf="debtToIncomeInfo.debtToIncomeRatio < 40">Our coaches provide expert tips and guidance to help you succeed at every step of your financial journey.</p>
    <p class="offcanvas-tip-box-desc" *ngIf="debtToIncomeInfo.debtToIncomeRatio >= 40">You can reduce your monthly debt repayments with debt consolidation. With lower interest rates and legal protection, it&#39;s the good money choice.</p>
     <div class="offcanvas-tip-box-btns">
      <button class="w-100 darkbtn text-center" *ngIf="debtToIncomeInfo.debtToIncomeRatio < 40" 
      (click)="dtiCoachCallback(47)"
      id="btn_leadGen_coach_callBack_debtAffordabilitySheet" name="btn_leadGen_coach_callBack_debtAffordabilitySheet">
        <img src="../../assets/images/telephone-icon.png" class="icon"> <span >Speak to a coach</span></button>

      <button class="w-100 darkbtn text-center" *ngIf="debtToIncomeInfo.debtToIncomeRatio >= 40" 
          (click)="idmLeadCallback('btn_leadGen_consolidateLoan_callBack_debtAffordabilitySheet')" 
        id="btn_leadGen_consolidateLoan_callBack_debtAffordabilitySheet" name="btn_leadGen_consolidateLoan_callBack_debtAffordabilitySheet">
        <img src="../../assets/images/telephone-icon.png" class="icon" ><span >Speak to an expert</span></button>
      <a href="/portal/account" id="btn_userJourney_creditReportRedirect_debtAffordability" name="btn_userJourney_creditReportRedirect_debtAffordability" class="w-100 lightbtn-darkbr">View your credit report</a>
    </div>
  </div>
</div>


  </div>
</div>
<!-- Sheet For Mobile end -->

<div #offcanvasNewCSDesktop class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasNewCSDesktop" aria-labelledby="offcanvasNewCSDesktop">
  <div class="offcanvas-header header-sec">
    <div class="heading">Your credit score has a new look</div>
    <button type="button" id="btn_auxiliaryButton_creditScore_featureNoticeDrawerClose_dashboard" name="btn_auxiliaryButton_creditScore_featureNoticeDrawerClose_dashboard" class="btn-close text-reset pt-2" (click)="closeOffcanvasNewCS('desktop')"></button>
  </div>
  <div class="offcanvas-body px-3 my-3">
    <div class="block-sec">
      <div>
      You may notice a change in your credit score. This is because we've updated the bureau data used to calculate it. This does not necessarily mean your credit profile has changed – it simply reflects an update to how your score is calculated.
      </div>
      <div class="drawer_border"></div>
      <div>Here's a brief reminder to help you understand what your score represents:</div>
      <div class="drawer_table">
        <div class="drawer_table_item">
          <div>Not enough info</div><div>You may have no credit history or very limited info available.</div>
        </div>
        <div class="drawer_table_item">
          <div>Needs work</div><div>You may find it difficult to get credit.</div>
        </div>
        <div class="drawer_table_item">
          <div>Below average</div><div>Some lenders may see you as high risk.</div>
        </div>
        <div class="drawer_table_item">
          <div>Average</div><div>You’re likely to access credit, but not the best deals.</div>
        </div>
        <div class="drawer_table_item">
          <div>Good</div><div>You’re likely to be approved for most types of credit.</div>
        </div>
        <div class="drawer_table_item_last">
          <div>Excellent</div><div>You’re in a strong position to get the best offers.</div>
        </div>
      </div>
      <div class="drawer_border"></div>
      <div>If you have any further questions about this update, please click below, and one of our coaches will reach out shortly.</div>
      <div class="drawer_border"></div>
      <div class="drawer_btn_section">
        <button id="btn_leadGen_coach_callBack_featureNoticeDrawer_dashboard" name="btn_leadGen_coach_callBack_featureNoticeDrawer_dashboard" (click)="creditScoreCoachCallback(48)">Chat with a coach</button>
        <button id="btn_auxiliaryButton_creditScore_featureNoticeDrawer_close_dashboard" name="btn_auxiliaryButton_creditScore_featureNoticeDrawer_close_dashboard" 
        (click)="closeOffcanvasNewCS('desktop')">No, thank you</button>
      </div>
    </div>
    
  </div>
</div>

<div #offcanvasNewCSMobile class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvasNewCSMobile"
  aria-labelledby="offcanvasNewCSMobile">
  <div class="offcanvas-header header-sec">
    <div class="heading">Your credit score has a new look</div>
    <button type="button" id="btn_auxiliaryButton_creditScore_featureNoticeDrawerClose_dashboard" name="btn_auxiliaryButton_creditScore_featureNoticeDrawerClose_dashboard" class="btn-close text-reset pt-2"
      (click)="closeOffcanvasNewCS('mobile')"></button>
  </div>
  <div class="offcanvas-body px-3 my-3">
    <div class="block-sec">
      <div>
       You may notice a change in your credit score. This is because we've updated the bureau data used to calculate it. This does not necessarily mean your credit profile has changed – it simply reflects an update to how your score is calculated.
      </div>
      <div class="drawer_border"></div>
      <div>Here's a brief reminder to help you understand what your score represents:</div>
      <div class="drawer_table">
        <div class="drawer_table_item">
          <div>Not enough info</div>
          <div>You may have no credit history or very limited info available.</div>
        </div>
        <div class="drawer_table_item">
          <div>Needs work</div>
          <div>You may find it difficult to get credit.</div>
        </div>
        <div class="drawer_table_item">
          <div>Below average</div>
          <div>Some lenders may see you as high risk.</div>
        </div>
        <div class="drawer_table_item">
          <div>Average</div>
          <div>You’re likely to access credit, but not the best deals.</div>
        </div>
        <div class="drawer_table_item">
          <div>Good</div>
          <div>You’re likely to be approved for most types of credit.</div>
        </div>
        <div class="drawer_table_item_last">
          <div>Excellent</div>
          <div>You’re in a strong position to get the best offers.</div>
        </div>
      </div>
      <div class="drawer_border"></div>
      <div>If you have any further questions about this update, please click below, and one of our coaches will reach
        out shortly.</div>
      <div class="drawer_border"></div>
      <div class="drawer_btn_section">
        <button id="btn_leadGen_coach_callBack_featureNoticeDrawer_dashboard" name="btn_leadGen_coach_callBack_featureNoticeDrawer_dashboard" (click)="creditScoreCoachCallback(48)">Chat with a coach</button>
        <button id="btn_auxiliaryButton_creditScore_featureNoticeDrawer_close_dashboard" name="btn_auxiliaryButton_creditScore_featureNoticeDrawer_close_dashboard" 
        (click)="closeOffcanvasNewCS('mobile')">No, thank you</button>
      </div>
    </div>

  </div>
</div>



  <section class="bg-white b5containeradjust pb-md-5 pb-3">
    <div class="container">
      <div class="d-flex align-items-stretch">
        <!--product display-->
        <div class="d-flex flex-wrap pt-md-5 col-12 px-lg-3 px-3">
        
        <!-- Original product Tiles header -->
        <section>
          <div class="col-md-12 col-12 d-flex">
            <div class="pre_qualify mb-3 mb-md-4 mt-4 mt-md-0">
              <h3 class="fw-bold">Your Personalised Offers
                <!-- Second popover trigger -->
                <a #topSolutionsPopoverBtn style="cursor: pointer;" name='tip_auxilaryButton_chatToCoach_showMore_topSolutions' id='tip_auxilaryButton_chatToCoach_showMore_topSolutions' (click)="togglePopover('topSolutionsPopover', topSolutionsPopoverBtn)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                      stroke="#4AAEAC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12 16V12" stroke="#4AAEAC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12 8H12.01" stroke="#4AAEAC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </a>
              </h3>
            </div>
            <div class="totlproduct_1 d-md-block d-none ms-5">
              <a name="btn_RedireactProductPage_DashBoard" class="text-decoration-none" href="javascript:void(0)"
                routerLink="/portal/solutions">
                View all 
            
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.3536 4.35355C11.5488 4.15829 11.5488 3.84171 11.3536 3.64645L8.17157 0.464467C7.97631 0.269205 7.65973 0.269205 7.46447 0.464467C7.2692 0.659729 7.2692 0.976311 7.46447 1.17157L10.2929 4L7.46447 6.82843C7.2692 7.02369 7.2692 7.34027 7.46447 7.53553C7.65973 7.7308 7.97631 7.7308 8.17157 7.53553L11.3536 4.35355ZM-4.37114e-08 4.5L11 4.5L11 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
                    fill="#E59A2C" />
                </svg>
            
              </a>
            </div>
            </div>
        </section>


         
          <section>
            <div class="col-md-12 d-flex flex-wrap align-items-center justify-content-between">
              <div class="row gx-lg-3 gx-0 align-items-stretch">
                 <!-- Product Tiles Original Variant  -->
                <div class="row gx-lg-4 gx-0 align-items-stretch pe-0">
                  <div class="col-md-4 mb-md-0 mb-3 col-12 d-flex align-items-stretch pe-0">
                    <div class="phol_1 d-flex flex-wrap align-items-stretch">
                      <div class="topproholder w-100">
                        <div class="topproimg_1">
                          <img src="../../assets/images/debt-1.png" alt="" />
                        </div>
                        <div>
                          <h4 class="topproheading_1">Debt got you down?
                            <span class="topproheading_2">Get help and get it sorted</span> 
                          </h4>

                            <div class="d-flex"><span [ngClass]="'d-block ' + dcStatus?.qualifyClass">{{dcStatus?.description}}</span>
                            </div>


  
                          <ul class="d-flex flex-column gap8 mb-3 pt-0">
                            <li class="d-flex">
                              <div><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path
                                  d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.4774 9.41674L5.38388 7.32322C5.09098 7.03033 4.61611 7.03033 4.32322 7.32322C4.03032 7.61612 4.03032 8.09099 4.32322 8.38388L6.96966 11.0303C7.26256 11.3232 7.73743 11.3232 8.03032 11.0303C8.03685 11.0238 8.043 11.0169 8.04876 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z"
                                  fill="#3D4A59" />
                              </svg></div>
                              <div class="ps-2"><span>Combine all your debt into one lower monthly payment </span></div>
                            </li>
                            <li class="d-flex">
                              <div><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                  <path
                                    d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.4774 9.41674L5.38388 7.32322C5.09098 7.03033 4.61611 7.03033 4.32322 7.32322C4.03032 7.61612 4.03032 8.09099 4.32322 8.38388L6.96966 11.0303C7.26256 11.3232 7.73743 11.3232 8.03032 11.0303C8.03685 11.0238 8.043 11.0169 8.04876 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z"
                                    fill="#3D4A59" />
                                </svg></div>
                              <div class="ps-2"><span>Pay less interest</span></div>
                            </li>
                            <li class="d-flex"><div><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path
                                  d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.4774 9.41674L5.38388 7.32322C5.09098 7.03033 4.61611 7.03033 4.32322 7.32322C4.03032 7.61612 4.03032 8.09099 4.32322 8.38388L6.96966 11.0303C7.26256 11.3232 7.73743 11.3232 8.03032 11.0303C8.03685 11.0238 8.043 11.0169 8.04876 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z"
                                  fill="#3D4A59" />
                              </svg></div>
                            <div class="ps-2"><span>Get more cash for living expenses</span></div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    <div class="w-100 d-flex flex-wrap w-100 align-self-end">
                        <div
                          [ngClass]="(dcStatus?.criteria == 'no-yes')?'buttonpanel dcStaton_1  w-100 p-md-2':'buttonpanel w-100 p-md-0'" class="d-flex flex-column flex-wrap justify-content-center align-self-end  p-3 mt-2">
                          <div class="dc-amt-txt w-100"
                          *ngIf="dcStatus?.criteria == 'no-yes'">
                          <span class="d-flex text-center text-md-start justify-content-center align-items-center font-style ">Estimated monthly <span> reduction </span> in credit payments:</span>
                          </div>
                          <div class="d-block  d-lg-flex align-items-center justify-content-between mt-0 mt-lg-2">
                          <div>
                            <span *ngIf="dcStatus?.criteria == 'no-yes'" class="d-flex justify-content-center align-items-center text-green fw-bold me-auto my-2 my-lg-0">R {{(monthlyInstalment
                            - dbc_Dcrs) |
                            number}}</span>
                          </div>
                          <div class="d-block  d-md-flex justify-content-end align-items-center">
                        
                       <button class="bank_button mb-0"
                            *ngIf="dcStatus?.criteria == 'no-yes' && this.UserGeminiNumber <= 400"
                            (click)="OmniLeadCreate('btn_leadGen_consolidateLoan_dcCallback_dashboard','Callback')"
                            id="btn_leadGen_consolidateLoan_dcCallback_dashboard"
                            name="btn_leadGen_consolidateLoan_dcCallback_dashboard">{{dcStatus?.ctaText}}</button>

                          <button class="bank_button mb-0"
                            *ngIf="dcStatus?.criteria == 'no-yes' && this.UserGeminiNumber > 400 && this.UserGeminiNumber <= 999"
                            (click)="OmniLeadCreate('btn_leadGen_consolidateLoan_dcOnlineJourney_dashboard','Online')"
                            id="btn_leadGen_consolidateLoan_dcOnlineJourney_dashboard"
                            name="btn_leadGen_consolidateLoan_dcOnlineJourney_dashboard">{{dcStatus?.ctaText}}</button>


                            <button class="toppbtn_1" *ngIf="dcStatus?.criteria != 'no-yes'"
                              (click)="debtConsolidationCallback()" id="btn_DebtConsolidationCallMe_DashboardPage"
                              name="btn_DebtConsolidationCallMe_DashboardPage">{{dcStatus?.dashboardCTAText}}</button>
                          </div>
                          </div>
                        </div>
  
                      </div>
  
                    </div>
                  </div>
                  <div class="col-md-4 mb-md-0 mb-3 col-12 d-flex align-items-stretch pe-0">
                    <div class="phol_1 d-flex flex-wrap align-items-stretch col-12" id="splOnboarding" style="position: relative;">
                      <div class="topproholder w-100">
                        <div class="topproimg_1">
                          <img src="../../assets/images/pl-1.png" alt="" />
                        </div>
  
                        <div>
                          <h4 class="topproheading_1">Need cash?
                            <span class="topproheading_2">Get a personal loan today</span>
                          </h4>
                          <div *ngIf="splStatus?.isInPendindingState==false; else noPLData">

                              <div class="d-flex"><span [ngClass]="'d-block ' + splStatus?.qualifyClass">{{splStatus?.description}}</span>
                          <!-- guidemark -->
                                <!-- <div class="info-wrapper ms-2 mb-3" *ngIf="dcEligibility">
                                   @if (UserGeminiNumber >= 600 && UserGeminiNumber
                                  <= 799) {  
                                    <img src="../../assets/svgs/info.svg" alt="info-svg" />
                                  } 
                                  @if (UserGeminiNumber >= 800 && UserGeminiNumber
                                  <= 999) { 
                                    <img src="../../assets/svgs/warning-icon.svg" alt="warning-svg" />
                                  } 
                              
                                  <div class="custom-tooltip mt-2">
                                    <h4 class="fw-bold gray-color">Make an informed choice</h4>
                                    <hr class="custom-hr" />
                                    <p class="tooltip-text">
                                      Taking a new loan can increase your debt load. If you're already juggling payments, consider
                                      <a class="tooltip-click-text text-decoration-underline" (click)="openOffcanvasguidemark('Sanlam','Dashboard')">DebtBusters’ Debt Consolidation</a> offer.
                                    </p>
                                  </div>
                                </div> -->
                                 <!-- guidemark -->
                              </div>
                          
                          <ul class="d-flex flex-column gap8 mb-3 mb-md-0 pt-0">
                            <li class="d-flex"><div><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path
                                  d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.4774 9.41674L5.38388 7.32322C5.09098 7.03033 4.61611 7.03033 4.32322 7.32322C4.03032 7.61612 4.03032 8.09099 4.32322 8.38388L6.96966 11.0303C7.26256 11.3232 7.73743 11.3232 8.03032 11.0303C8.03685 11.0238 8.043 11.0169 8.04876 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z"
                                  fill="#3D4A59" />
                              </svg></div>
                            <div class="ps-2"><span>Borrow up to R350,000</span></div></li>
                            <li class="d-flex"><div><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path
                                  d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.4774 9.41674L5.38388 7.32322C5.09098 7.03033 4.61611 7.03033 4.32322 7.32322C4.03032 7.61612 4.03032 8.09099 4.32322 8.38388L6.96966 11.0303C7.26256 11.3232 7.73743 11.3232 8.03032 11.0303C8.03685 11.0238 8.043 11.0169 8.04876 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z"
                                  fill="#3D4A59" />
                              </svg></div>
                            <div class="ps-2"><span>Personalised interest rates</span></div></li>
                            <li class="d-flex"><div><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path
                                  d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.4774 9.41674L5.38388 7.32322C5.09098 7.03033 4.61611 7.03033 4.32322 7.32322C4.03032 7.61612 4.03032 8.09099 4.32322 8.38388L6.96966 11.0303C7.26256 11.3232 7.73743 11.3232 8.03032 11.0303C8.03685 11.0238 8.043 11.0169 8.04876 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z"
                                  fill="#3D4A59" />
                              </svg></div>
                            <div class="ps-2"><span>Up to 84 months’ repayment term</span></div></li>
                          </ul>
                          </div>
                          <ng-template #noPLData>
                            <div class="text-center pt-md-4 pt-2">
                              <i>
                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M11 15V11M11 7H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z" stroke="#E59A2C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>                              
                              </i>
                              <p class="noscsPL mt-3">Your Sanlam personal loan <br/> application is in progress</p>
                            </div>
                          </ng-template>
                        </div>
                        
                      </div>
                      <div *ngIf="splStatus?.isInPendindingState==false" class="bottomproholder_1 d-flex flex-wrap w-100 justify-content-end align-self-end pt-3 pt-md-0">
                        <button class="toppbtn_1" id="btn_leadGen_offerTile_splCallback_dashboard" name="btn_leadGen_offerTile_splCallback_dashboard" (click)="splCallbackApplyNow()"
                        *ngIf="splStatus?.criteria?.toLowerCase() != 'approve' && splStatus?.criteria?.toLowerCase() != 'maybe-high'">{{splStatus?.dashboardCTAText}}</button>
                        <button class="toppbtn_1" id="btn_leadGen_offerTile_splOnlineJourney_dashboard" name="btn_leadGen_offerTile_splOnlineJourney_dashboard" (click)="personalLoanOffer()"
                        *ngIf="splStatus?.criteria?.toLowerCase() === 'approve' || splStatus?.criteria?.toLowerCase() === 'maybe-high'">{{splStatus?.ctaText}}</button>
                      </div>
                      <!-- Lottie Hand Animation -->
                      <div 
                        *ngIf="showHandAnimation" 
                        #splHandAnimationContainer 
                        style="position: absolute; 
                               bottom: -50px; 
                               left: 70%; 
                               transform: translateX(-50%); 
                               width: 100px; 
                               height: 100px; 
                               z-index: 1000; 
                               pointer-events: none;">
                      </div>
                    </div>
                  </div>
                  <!-- capfin Tile  -->
                    <div *ngIf="IsShowCapfin" class="col-md-4 mb-md-0 mb-3 col-12 d-flex align-items-stretch pe-0">
                    <div class="phol_1 d-flex flex-wrap align-items-stretch" id="capfinOnboarding" style="position: relative;">
                      <div class="topproholder w-100">
                        <div class="topproimg_1">
                          <img src="../../assets/images/capfin.svg" alt="" />
                        </div>
                        <div>
                          <h4 class="topproheading_1">Looking for a little extra?
                            <span class="topproheading_2">Get approval in minutes</span>
                          </h4>
                            <div class="d-flex"><span [ngClass]="'d-block ' + capfinStatus?.qualifyClass">{{capfinStatus?.description}}</span>
                                <!-- guidemark -->
                                <!-- <div class="info-wrapper ms-2 mb-3" *ngIf="dcEligibility">
                                   @if (UserGeminiNumber >= 600 && UserGeminiNumber
                                  <= 799) {  
                                    <img src="../../assets/svgs/info.svg" alt="info-svg" />
                                   } 
                                   @if (UserGeminiNumber >= 800 && UserGeminiNumber
                                  <= 999) { 
                                    <img src="../../assets/svgs/warning-icon.svg" alt="warning-svg" />
                                  } 
                              
                                  <div class="custom-tooltip mt-2">
                                    <h4 class="fw-bold gray-color">Make an informed choice</h4>
                                    <hr class="custom-hr" />
                                    <p class="tooltip-text">
                                      Taking a new loan can increase your debt load. If you're already juggling payments, consider
                                      <a class="tooltip-click-text text-decoration-underline" (click)="openOffcanvasguidemark('Capfin','Dashboard')">DebtBusters’ Debt Consolidation</a> offer.
                                    </p>
                                  </div>
                                </div> -->
                                 <!-- guidemark -->
                            </div>
                          <ul class="d-flex flex-column gap8 mb-3 mb-md-0 pt-0">
                            <li class="d-flex"><div><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path
                                  d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.4774 9.41674L5.38388 7.32322C5.09098 7.03033 4.61611 7.03033 4.32322 7.32322C4.03032 7.61612 4.03032 8.09099 4.32322 8.38388L6.96966 11.0303C7.26256 11.3232 7.73743 11.3232 8.03032 11.0303C8.03685 11.0238 8.043 11.0169 8.04876 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z"
                                  fill="#3D4A59" />
                              </svg></div>
                            <div class="ps-2"><span>Borrow up to R50,000 </span></div>
                            </li>
                            <li class="d-flex"><div><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path
                                  d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.4774 9.41674L5.38388 7.32322C5.09098 7.03033 4.61611 7.03033 4.32322 7.32322C4.03032 7.61612 4.03032 8.09099 4.32322 8.38388L6.96966 11.0303C7.26256 11.3232 7.73743 11.3232 8.03032 11.0303C8.03685 11.0238 8.043 11.0169 8.04876 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z"
                                  fill="#3D4A59" />
                              </svg></div>
                            <div class="ps-2"><span>Access and manage your loan anytime, anywhere</span></div>
                            </li>
                            <li class="d-flex"><div><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path
                                  d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.4774 9.41674L5.38388 7.32322C5.09098 7.03033 4.61611 7.03033 4.32322 7.32322C4.03032 7.61612 4.03032 8.09099 4.32322 8.38388L6.96966 11.0303C7.26256 11.3232 7.73743 11.3232 8.03032 11.0303C8.03685 11.0238 8.043 11.0169 8.04876 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z"
                                  fill="#3D4A59" />
                              </svg></div>
                            <div class="ps-2"><span>No hidden costs</span></div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="bottomproholder_1 d-flex flex-wrap w-100 justify-content-end align-self-end pt-0 pt-md-0">
                        <a class="toppbtn_1 text-center"
                           href="https://www.capfin.co.za/apply-now/application-details?a=CF000126" name="btn_leadGen_offerTile_capfinOnlineJourney_dashboard" id="btn_leadGen_offerTile_capfinOnlineJourney_dashboard" target="_blank">{{capfinStatus?.ctaText}}</a>

                      </div>
                      <!-- Lottie Hand Animation -->
                        <div 
                          *ngIf="showHandAnimation" 
                          #capfinHandAnimationContainer 
                          style="position: absolute; 
                                bottom: -50px; 
                                left: 70%; 
                                transform: translateX(-50%); 
                                width: 100px; 
                                height: 100px; 
                                z-index: 1000; 
                                pointer-events: none;">
                        </div>
                    </div>
                  </div>
                  <!-- Wingfield Tile  -->


                  

                                    <!-- wingfield product tile  start -->

                  <div *ngIf="!IsShowCapfin" class="col-md-4 mb-md-0 mb-3 col-12 d-flex align-items-stretch pe-0">
                    <div class="phol_1 d-flex flex-wrap align-items-stretch">
                      <div class="topproholder w-100">
                        <div class="topproimg_1">
                          <img src="../../assets/images/vf-1.png" alt="" />
                        </div>
                        <div>
                          <h4 class="topproheading_1">Dreaming of a new ride?
                            <span class="topproheading_2">Get vehicle finance</span>
                          </h4>
                            <div class="d-flex"><span [ngClass]="'d-block ' + vehicleFinanceStatus?.qualifyClass">{{vehicleFinanceStatus?.description}}</span>
                            </div>
                          <ul class="d-flex flex-column gap8 mb-3 mb-md-0 pt-0">
                            <li class="d-flex"><div><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path
                                  d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.4774 9.41674L5.38388 7.32322C5.09098 7.03033 4.61611 7.03033 4.32322 7.32322C4.03032 7.61612 4.03032 8.09099 4.32322 8.38388L6.96966 11.0303C7.26256 11.3232 7.73743 11.3232 8.03032 11.0303C8.03685 11.0238 8.043 11.0169 8.04876 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z"
                                  fill="#3D4A59" />
                              </svg></div>
                            <div class="ps-2"><span>Tailored interest rates</span></div>
                            </li>
                            <li class="d-flex"><div><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path
                                  d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.4774 9.41674L5.38388 7.32322C5.09098 7.03033 4.61611 7.03033 4.32322 7.32322C4.03032 7.61612 4.03032 8.09099 4.32322 8.38388L6.96966 11.0303C7.26256 11.3232 7.73743 11.3232 8.03032 11.0303C8.03685 11.0238 8.043 11.0169 8.04876 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z"
                                  fill="#3D4A59" />
                              </svg></div>
                            <div class="ps-2"><span>Affordable repayments</span></div>
                            </li>
                            <li class="d-flex"><div><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path
                                  d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.4774 9.41674L5.38388 7.32322C5.09098 7.03033 4.61611 7.03033 4.32322 7.32322C4.03032 7.61612 4.03032 8.09099 4.32322 8.38388L6.96966 11.0303C7.26256 11.3232 7.73743 11.3232 8.03032 11.0303C8.03685 11.0238 8.043 11.0169 8.04876 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z"
                                  fill="#3D4A59" />
                              </svg></div>
                            <div class="ps-2"><span>Convenient financing options       </span></div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="bottomproholder_1 d-flex flex-wrap w-100 justify-content-end align-self-end pt-3 pt-md-0">
                        <button class="toppbtn_1" id="btn_leadGen_offerTile_wingfieldCallback_dashboard" name="btn_leadGen_offerTile_wingfieldCallback_dashboard" 
                          (click)="vehicleFinanceCallback()">{{vehicleFinanceStatus?.dashboardCTAText}}</button>
                      </div>
                    </div>
                  </div> 
                                   <!-- wingfield product tile end -->

                </div>
              </div>
              
              <div class="d-md-none w-100">
                <div class="col-12">
                  <a name="btn_RedireactSolutionPage_DashBoard" href="/portal/solutions" class="reportbtn darkbtnbg">
                    View all my offers
                  </a>
                </div>
              </div>
            </div> 
          </section>
        </div>
        <!--product display-->
      </div>
    </div>
  </section>

  <section class="bg-gry pb-4 pt-4 pt-md-5 b5containeradjust mb-bg-2 d-block d-md-none">
    <div class="container">
      <div class="d-flex align-items-stretch">
        <!-- progress bar-->
        <div class="col-md-12 col-12 px-md-0 px-3" *ngIf="isDataAvailable || isDataAvailable==null">

          <h3 class="fw-bold text-start">How You Compare
            <ng-template #tipContent>* For your age group the average salary to debt ratio is 23%</ng-template>
          </h3>

          <div class="bg-white pb-2 px-md-5 mt-3 pt-md-5 pb-md-5 boxShadow">


            <div class="spcmobile">
              <div class="spc-score-bar">
                <span class="your-sc-text-blue" [style.margin-left]="scoreProgress+'%'">
                  <div class="item">
                    <p>Your score</p>
                    <svg [ngClass]="setClassesScoreProgress()" height="25px" id="Layer_1"
                      style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="25px"
                      xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <path
                        d="M98.9,184.7l1.8,2.1l136,156.5c4.6,5.3,11.5,8.6,19.2,8.6c7.7,0,14.6-3.4,19.2-8.6L411,187.1l2.3-2.6  c1.7-2.5,2.7-5.5,2.7-8.7c0-8.7-7.4-15.8-16.6-15.8v0H112.6v0c-9.2,0-16.6,7.1-16.6,15.8C96,179.1,97.1,182.2,98.9,184.7z" />
                    </svg>
                    <p class="percentage" [ngClass]="setClassesScoreProgress()">{{scoreProgress}}%</p>
                  </div>
                </span>
                <div class="bar"></div>
                <div class="d-flex flex-wrap">
                  <div class="number-grap mobile-spce-maintain0">0%</div>
                  <div class="number-grap">20%</div>
                  <div class="number-grap">40%</div>
                  <div class="number-grap">60%</div>
                  <div class="number-grap d-flex justify-content-between"><span>80%</span> <span
                      class="mobile-spce-maintain1">100%</span> </div>
                </div>
                <span class="your-sc-text-blue" [style.margin-left]="scoreAgeProgress+'%'">
                  <div class="item">
                    <p class="percentage" [ngClass]="setClassesScoreAgeProgress()">
                      {{scoreAgeProgress}}%
                    </p>
                    <svg [ngClass]="setClassesScoreAgeProgress()" height="25px" id="Layer_1"
                      style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="25px"
                      xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <path
                        d="M413.1,327.3l-1.8-2.1l-136-156.5c-4.6-5.3-11.5-8.6-19.2-8.6c-7.7,0-14.6,3.4-19.2,8.6L101,324.9l-2.3,2.6  C97,330,96,333,96,336.2c0,8.7,7.4,15.8,16.6,15.8v0h286.8v0c9.2,0,16.6-7.1,16.6-15.8C416,332.9,414.9,329.8,413.1,327.3z" />
                    </svg>
                    <p>Average for your age group</p>
                  </div>
                </span>
              </div>
            </div>


          </div>

        </div>
        <!-- progress bar-->
      </div>
    </div>
    <div class="col-md-5 col-12 px-md-3 px-3 bggrmobile "*ngIf="creditInsightData?.length > 0">
      <h2 class="page-caption">Your Credit Score History</h2>
      <div class="scorebox">
        <app-credit-score-history [item]="ChartId[0]"></app-credit-score-history>
      </div>
    </div>
  </section>
  <section class="score_breakdown d-md-none b5containeradjust d-block py-4 pb-5  mb-bg-2">
    <div class='container'>
      <h3 class="fw-bold pb-3 px-md-0 px-3">Understand Your Debt</h3>
      <div class='col-12 px-md-0 px-3'>
        <owl-carousel-o (window:resize)="onResize($event)" [options]="customOptions">
          <ng-template carouselSlide>
            <div class="item">
              <div class="cell_head">
                <div class="icon"><svg id="Group_144" data-name="Group 144" xmlns="http://www.w3.org/2000/svg"
                    width="14.725" height="15.08" viewBox="0 0 14.725 15.08">
                    <path id="Path_74" data-name="Path 74"
                      d="M543.344,202.943a.353.353,0,0,1-.151-.033,2.123,2.123,0,1,1,3.021-1.924,2.1,2.1,0,0,1-.224.95.356.356,0,1,1-.636-.319,1.411,1.411,0,1,0-2.673-.631,1.416,1.416,0,0,0,.814,1.278.356.356,0,0,1-.151.679"
                      transform="translate(-536.9 -192.146)" fill="#fff" />
                    <path id="Path_75" data-name="Path 75"
                      d="M546.03,211.4a1.116,1.116,0,0,1-1.113-1.143v-1.325s0-.012,0-.019a.626.626,0,0,1,0-.194.356.356,0,0,1,.7.106s0,.007,0,.011c0,.024.006.057.006.1v1.325a.4.4,0,1,0,.8,0v-1.038a.356.356,0,1,1,.712,0v1.038a1.117,1.117,0,0,1-1.114,1.143"
                      transform="translate(-538.802 -198.342)" fill="#fff" />
                    <path id="Path_76" data-name="Path 76"
                      d="M543.078,208.4h0l-11.182-.022a.356.356,0,0,1,0-.712h0l10.823.02-.036-6.652a.357.357,0,0,1,.354-.358h0a.357.357,0,0,1,.356.355l.037,7.01a.356.356,0,0,1-.356.358"
                      transform="translate(-530.148 -193.321)" fill="#fff" />
                    <path id="Path_77" data-name="Path 77"
                      d="M531.5,208.249a.356.356,0,0,1-.356-.356V200.8a.356.356,0,0,1,.712,0v7.094a.356.356,0,0,1-.356.356"
                      transform="translate(-529.894 -193.169)" fill="#fff" />
                    <path id="Path_78" data-name="Path 78"
                      d="M564.021,194.332a.354.354,0,0,1-.222-.078c-.01-.008-1-.8-2.005-1.641a.356.356,0,1,1,.458-.546c1,.836,1.981,1.622,1.992,1.63a.356.356,0,0,1-.222.634"
                      transform="translate(-549.651 -187.693)" fill="#fff" />
                    <path id="Path_79" data-name="Path 79"
                      d="M527.949,186.323a.356.356,0,0,1-.237-.622c.445-.4,6.688-5.583,6.954-5.8a.356.356,0,0,1,.458,0c.018.015,1.777,1.507,3.34,2.818a.356.356,0,1,1-.458.545c-1.232-1.034-2.587-2.18-3.114-2.627-1.16.964-6.318,5.252-6.706,5.6a.355.355,0,0,1-.237.09"
                      transform="translate(-527.593 -179.815)" fill="#fff" />
                    <path id="Path_80" data-name="Path 80"
                      d="M561.906,185.693a.356.356,0,0,1-.356-.356v-3.461a.356.356,0,1,1,.712,0v3.461a.356.356,0,0,1-.356.356"
                      transform="translate(-549.576 -180.918)" fill="#fff" />
                    <path id="Path_81" data-name="Path 81"
                      d="M557.332,184.575a.356.356,0,0,1-.356-.356v-2.041a.356.356,0,0,1,.712,0v2.041a.356.356,0,0,1-.356.356"
                      transform="translate(-546.615 -181.114)" fill="#fff" />
                    <path id="Path_82" data-name="Path 82"
                      d="M558.3,181.424h-2.846a.356.356,0,0,1,0-.712H558.3a.356.356,0,1,1,0,.712"
                      transform="translate(-545.396 -180.396)" fill="#fff" />
                    <path id="Path_83" data-name="Path 83"
                      d="M542.9,192.451a.353.353,0,0,1-.23-.085l-5.293-4.475c-.94.768-4.487,3.666-5.366,4.368a.356.356,0,0,1-.444-.556c1.007-.805,5.543-4.513,5.589-4.551a.357.357,0,0,1,.455,0l5.52,4.666a.356.356,0,0,1-.23.628"
                      transform="translate(-530.077 -184.514)" fill="#fff" />
                    <path id="Path_84" data-name="Path 84"
                      d="M549.944,208.184a.356.356,0,1,1,.252-.1.358.358,0,0,1-.252.1"
                      transform="translate(-541.832 -197.72)" fill="#fff" />
                  </svg>
                </div>
                <p class="mt-1 mb-1">Home</p>
                <div class="divider"></div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable || isDataAvailable==null">
                <div class="col-6">
                  <p>No. of open<br>accounts</p>
                </div>
                <div class="col-4 offset-2">
                  <p>{{creditHealthInfo.homeLoanAccountCount}}</p>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable!=null && !isDataAvailable">
                <div class="col-6">
                  <p>No. of open<br>accounts</p>
                </div>
                <div class="col-4 offset-2">
                  <p>0</p>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable || isDataAvailable==null">
                <div class="col-6">
                  <p class="m-0">Your debt is made up of</p>
                </div>
                <div class="col-4 offset-2">
                  <svg viewBox="0 0 36 36" class="circle-svg">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent"
                      [style.strokeDasharray]="creditHealthInfo.homeLoanDebtBalancePercent + ' ' + (100-creditHealthInfo.homeLoanDebtBalancePercent)"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" y="14" text-anchor="middle" dy="7"
                      font-size="20">{{creditHealthInfo.homeLoanDebtBalancePercent?.toFixed(0)}}%</text>
                  </svg>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable!=null && !isDataAvailable">
                <div class="col-6">
                  <p class="m-0">Your debt is made up of</p>
                </div>
                <div class="col-4 offset-2">
                  <svg viewBox="0 0 36 36" class="circle-svg">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent"
                      [style.strokeDasharray]="creditHealthInfo.homeLoanDebtBalancePercent + ' ' + (100-creditHealthInfo.homeLoanDebtBalancePercent)"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" y="14" text-anchor="middle" dy="7" font-size="20">0</text>
                  </svg>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable || isDataAvailable==null">
                <div class="col-6">
                  <p class="m-0">How much have you paid-off</p>
                </div>
                <div class="col-4 offset-2">
                  <svg viewBox="0 0 36 36" class="circle-svg yellow">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent"
                      [style.strokeDasharray]="creditHealthInfo.homeLoanTotalPaidOffPercent + ' ' + (100-creditHealthInfo.homeLoanTotalPaidOffPercent)"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" y="14" text-anchor="middle" dy="7"
                      font-size="20">{{creditHealthInfo.homeLoanTotalPaidOffPercent?.toFixed(0)}}%</text>
                  </svg>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable!=null && !isDataAvailable">
                <div class="col-6">
                  <p class="m-0">How much have you paid-off</p>
                </div>
                <div class="col-4 offset-2">
                  <svg viewBox="0 0 36 36" class="circle-svg">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent" stroke-dasharray="0, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" y="14" text-anchor="middle" dy="7" font-size="20">0</text>
                  </svg>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="item">
              <div class="cell_head">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17.172" height="13.075" viewBox="0 0 17.172 13.075">
                    <path id="car-solid"
                      d="M15.987,67.58H14.073l-.532-1.33A3.562,3.562,0,0,0,10.217,64H6.157a3.563,3.563,0,0,0-3.324,2.25L2.3,67.58H.387a.383.383,0,0,0-.372.477l.192.767a.383.383,0,0,0,.372.291h.642a2.032,2.032,0,0,0-.706,1.534v1.534a2.029,2.029,0,0,0,.511,1.34v1.728a1.023,1.023,0,0,0,1.023,1.023H3.072A1.023,1.023,0,0,0,4.1,75.252V74.229h8.184v1.023A1.023,1.023,0,0,0,13.3,76.275h1.023a1.023,1.023,0,0,0,1.023-1.023V73.524a2.028,2.028,0,0,0,.511-1.34V70.649a2.032,2.032,0,0,0-.706-1.534H15.8a.383.383,0,0,0,.372-.291l.192-.767a.384.384,0,0,0-.372-.477ZM4.732,67.01a1.535,1.535,0,0,1,1.425-.964h4.06a1.535,1.535,0,0,1,1.425.964l.637,1.593H4.1Zm-1.66,5.167a1.02,1.02,0,1,1,0-2.04,1.968,1.968,0,0,1,1.534,1.53c0,.612-.921.51-1.534.51Zm10.229,0c-.614,0-1.534.1-1.534-.51a1.968,1.968,0,0,1,1.534-1.53,1.02,1.02,0,1,1,0,2.04Z"
                      transform="translate(0.399 -63.6)" fill="none" stroke="#fff" stroke-width="0.8" />
                  </svg>
                </div>
                <p class="mt-1 mb-1">Car</p>
                <div class="divider"></div>
              </div>

              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable || isDataAvailable==null">
                <div class="col-6">
                  <p>No. of open<br>accounts</p>
                </div>
                <div class="col-4 offset-2">
                  <p>{{creditHealthInfo.carLoanAccountCount}}</p>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable!=null && !isDataAvailable">
                <div class="col-6">
                  <p>No. of open<br>accounts</p>
                </div>
                <div class="col-4 offset-2">
                  <p>0</p>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable || isDataAvailable==null">
                <div class="col-6">
                  <p class="m-0">Your debt is made up of</p>
                </div>
                <div class="col-4 offset-2">
                  <svg viewBox="0 0 36 36" class="circle-svg">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent"
                      [style.strokeDasharray]="creditHealthInfo.carLoanDebtBalancePercent + ' ' + (100-creditHealthInfo.carLoanDebtBalancePercent)"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" y="14" text-anchor="middle" dy="7"
                      font-size="20">{{creditHealthInfo.carLoanDebtBalancePercent?.toFixed(0)}}%</text>
                  </svg>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable!=null && !isDataAvailable">
                <div class="col-6">
                  <p class="m-0">Your debt is made up of</p>
                </div>
                <div class="col-4 offset-2">
                  <svg viewBox="0 0 36 36" class="circle-svg">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent" stroke-dasharray="0, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" y="14" text-anchor="middle" dy="7" font-size="20">0</text>
                  </svg>
                </div>
              </div>

              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable || isDataAvailable==null">
                <div class="col-6">
                  <p class="m-0">How much have you paid-off</p>
                </div>
                <div class="col-4 offset-2">
                  <svg viewBox="0 0 36 36" class="circle-svg yellow">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent"
                      [style.strokeDasharray]="creditHealthInfo.carLoanTotalPaidOffPercent + ' ' + (100-creditHealthInfo.carLoanTotalPaidOffPercent)"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" y="14" text-anchor="middle" dy="7"
                      font-size="20">{{creditHealthInfo.carLoanTotalPaidOffPercent?.toFixed(0)}}%</text>
                  </svg>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable!=null && !isDataAvailable">
                <div class="col-6">
                  <p class="m-0">How much have you paid-off</p>
                </div>
                <div class="col-4 offset-2">
                  <svg viewBox="0 0 36 36" class="circle-svg yellow">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent" stroke-dasharray="0, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" y="14" text-anchor="middle" dy="7" font-size="20">0</text>
                  </svg>
                </div>
              </div>

            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="item">
              <div class="cell_head">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16.027" height="13.061" viewBox="0 0 16.027 13.061">
                    <path id="tshirt-solid"
                      d="M14.923,2.29,10.3,0A3.444,3.444,0,0,1,7.536,1.12,3.444,3.444,0,0,1,4.771,0L.15,2.29a.383.383,0,0,0-.171.51L1.337,5.518a.383.383,0,0,0,.51.171l1.343-.657a.379.379,0,0,1,.546.342v6.019a.759.759,0,0,0,.76.76h6.076a.759.759,0,0,0,.76-.76V5.371a.38.38,0,0,1,.546-.342l1.343.657a.379.379,0,0,0,.51-.171L15.091,2.8A.379.379,0,0,0,14.923,2.29Z"
                      transform="translate(0.493 0.509)" fill="none" stroke="#fff" stroke-width="0.8" />
                  </svg>
                </div>
                <p class="mt-1 mb-1">Clothing</p>
                <div class="divider"></div>
              </div>

              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable || isDataAvailable==null">
                <div class="col-6">
                  <p>No. of open<br>accounts</p>
                </div>
                <div class="col-4 offset-2">
                  <p>{{creditHealthInfo.retailerLoanAccountCount}}</p>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable!=null && !isDataAvailable">
                <div class="col-6">
                  <p>No. of open<br>accounts</p>
                </div>
                <div class="col-4 offset-2">
                  <p>0</p>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable || isDataAvailable==null">
                <div class="col-6">
                  <p class="m-0">Your debt is made up of</p>
                </div>
                <div class="col-4 offset-2">
                  <svg viewBox="0 0 36 36" class="circle-svg">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent"
                      [style.strokeDasharray]="creditHealthInfo.retailerLoanDebtBalancePercent + ' ' + (100-creditHealthInfo.retailerLoanDebtBalancePercent)"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" y="14" text-anchor="middle" dy="7"
                      font-size="20">{{creditHealthInfo.retailerLoanDebtBalancePercent?.toFixed(0)}}%</text>
                  </svg>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable!=null && !isDataAvailable">
                <div class="col-6">
                  <p class="m-0">Your debt is made up of</p>
                </div>
                <div class="col-4 offset-2">
                  <svg viewBox="0 0 36 36" class="circle-svg">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent" stroke-dasharray="0, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" y="14" text-anchor="middle" dy="7" font-size="20">0</text>
                  </svg>
                </div>
              </div>

              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable || isDataAvailable==null">
                <div class="col-6">
                  <p class="m-0">How much have you paid-off</p>
                </div>
                <div class="col-4 offset-2">
                  <svg viewBox="0 0 36 36" class="circle-svg yellow">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent"
                      [style.strokeDasharray]="creditHealthInfo.retailerLoanTotalPaidOffPercent + ' ' + (100-creditHealthInfo.retailerLoanTotalPaidOffPercent)"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" y="14" text-anchor="middle" dy="7"
                      font-size="20">{{creditHealthInfo.retailerLoanTotalPaidOffPercent?.toFixed(0)}}%</text>
                  </svg>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable!=null && !isDataAvailable">
                <div class="col-6">
                  <p class="m-0">How much have you paid-off</p>
                </div>
                <div class="col-4 offset-2">
                  <svg viewBox="0 0 36 36" class="circle-svg yellow">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent" stroke-dasharray="0, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" y="14" text-anchor="middle" dy="7" font-size="20">0</text>
                  </svg>
                </div>
              </div>

            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="item">
              <div class="cell_head">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16.182" height="12.764" viewBox="0 0 16.182 12.764">
                    <path id="credit-card-regular_1_" data-name="credit-card-regular (1)"
                      d="M14.1,32H1.284A1.283,1.283,0,0,0,0,33.282v9.4a1.283,1.283,0,0,0,1.284,1.282H14.1a1.283,1.283,0,0,0,1.284-1.282v-9.4A1.283,1.283,0,0,0,14.1,32ZM1.445,33.282H13.937a.161.161,0,0,1,.16.16v1.122H1.284V33.442A.161.161,0,0,1,1.445,33.282Zm12.492,9.4H1.445a.161.161,0,0,1-.16-.16v-4.54H14.1v4.54A.161.161,0,0,1,13.937,42.682Zm-8.81-2.67v1.068a.321.321,0,0,1-.32.32H2.884a.321.321,0,0,1-.32-.32V40.011a.321.321,0,0,1,.32-.32H4.807A.321.321,0,0,1,5.127,40.011Zm5.127,0v1.068a.321.321,0,0,1-.32.32H6.3a.321.321,0,0,1-.32-.32V40.011a.321.321,0,0,1,.32-.32H9.934A.321.321,0,0,1,10.254,40.011Z"
                      transform="translate(0.4 -31.6)" fill="none" stroke="#fff" stroke-width="0.8" />
                  </svg>
                </div>
                <p class="mt-1 mb-1">Credit Card</p>
                <div class="divider"></div>
              </div>

              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable || isDataAvailable==null">
                <div class="col-6">
                  <p>No. of open<br>accounts</p>
                </div>
                <div class="col-4 offset-2">
                  <p>{{creditHealthInfo.creditLoanAccountCount}}</p>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable!=null && !isDataAvailable">
                <div class="col-6">
                  <p>No. of open<br>accounts</p>
                </div>
                <div class="col-4 offset-2">
                  <p>0</p>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable || isDataAvailable==null">
                <div class="col-6">
                  <p class="m-0">Your debt is made up of</p>
                </div>
                <div class="col-4 offset-2">
                  <svg viewBox="0 0 36 36" class="circle-svg">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent"
                      [style.strokeDasharray]="creditHealthInfo.creditLoanDebtBalancePercent + ' ' + (100-creditHealthInfo.creditLoanDebtBalancePercent)"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" y="14" text-anchor="middle" dy="7"
                      font-size="20">{{creditHealthInfo.creditLoanDebtBalancePercent?.toFixed(0)}}%</text>
                  </svg>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable!=null && !isDataAvailable">
                <div class="col-6">
                  <p class="m-0">Your debt is made up of</p>
                </div>
                <div class="col-4 offset-2">
                  <svg viewBox="0 0 36 36" class="circle-svg">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent" stroke-dasharray="0, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" y="14" text-anchor="middle" dy="7" font-size="20">0</text>
                  </svg>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable || isDataAvailable==null">
                <div class="col-6">
                  <p class="m-0">How much have you paid-off</p>
                </div>
                <div class="col-4 offset-2">
                  <svg viewBox="0 0 36 36" class="circle-svg yellow">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent"
                      [style.strokeDasharray]="creditHealthInfo.creditLoanTotalPaidOffPercent + ' ' + (100-creditHealthInfo.creditLoanTotalPaidOffPercent)"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" y="14" text-anchor="middle" dy="7"
                      font-size="20">{{creditHealthInfo.creditLoanTotalPaidOffPercent?.toFixed(0)}}%</text>
                  </svg>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable!=null && !isDataAvailable">
                <div class="col-6">
                  <p class="m-0">How much have you paid-off</p>
                </div>
                <div class="col-4 offset-2">
                  <svg viewBox="0 0 36 36" class="circle-svg yellow">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent" stroke-dasharray="0, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" y="14" text-anchor="middle" dy="7" font-size="20">0</text>
                  </svg>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="item">
              <div class="cell_head">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14.852" height="10.636" viewBox="0 0 14.852 10.636">
                    <path id="money-bill-wave-solid"
                      d="M13.638,32.493A6.5,6.5,0,0,0,11.082,32c-2.7,0-5.408,1.369-8.112,1.369a6.661,6.661,0,0,1-2.034-.3.751.751,0,0,0-.227-.036.7.7,0,0,0-.708.7V40.7a.7.7,0,0,0,.414.647,6.5,6.5,0,0,0,2.556.493c2.7,0,5.408-1.369,8.113-1.369a6.661,6.661,0,0,1,2.034.3.751.751,0,0,0,.227.036.7.7,0,0,0,.708-.7V33.14a.7.7,0,0,0-.414-.647ZM1.054,34.2a7.64,7.64,0,0,0,1.377.2,1.407,1.407,0,0,1-1.377,1.132Zm0,6.257V39.409a1.4,1.4,0,0,1,1.4,1.348A5.3,5.3,0,0,1,1.054,40.458Zm5.972-1.432a2.143,2.143,0,0,1,0-4.215,2.143,2.143,0,0,1,0,4.215Zm5.972.61A7.549,7.549,0,0,0,11.8,39.45,1.4,1.4,0,0,1,13,38.368Zm0-5.184A1.4,1.4,0,0,1,11.772,33.1,5.278,5.278,0,0,1,13,33.378Z"
                      transform="translate(0.4 -31.6)" fill="none" stroke="#fff" stroke-width="0.8" />
                  </svg>
                </div>
                <p class="mt-1 mb-1">Loans</p>
                <div class="divider"></div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable || isDataAvailable==null">
                <div class="col-6">
                  <p>No. of open<br>accounts</p>
                </div>
                <div class="col-4 offset-2">
                  <p>{{creditHealthInfo.personalLoanAccountCount}}</p>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable!=null && !isDataAvailable">
                <div class="col-6">
                  <p>No. of open<br>accounts</p>
                </div>
                <div class="col-4 offset-2">
                  <p>0</p>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable || isDataAvailable==null">
                <div class="col-6">
                  <p class="m-0">Your debt is made up of</p>
                </div>
                <div class="col-4 offset-2">
                  <svg viewBox="0 0 36 36" class="circle-svg">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent"
                      [style.strokeDasharray]="creditHealthInfo.personalLoanDebtBalancePercent + ' ' + (100-creditHealthInfo.personalLoanDebtBalancePercent)"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" y="14" text-anchor="middle" dy="7"
                      font-size="20">{{creditHealthInfo.personalLoanDebtBalancePercent?.toFixed(0)}}%</text>
                  </svg>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable!=null && !isDataAvailable">
                <div class="col-6">
                  <p class="m-0">Your debt is made up of</p>
                </div>
                <div class="col-4 offset-2">
                  <svg viewBox="0 0 36 36" class="circle-svg">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent" stroke-dasharray="0, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" y="14" text-anchor="middle" dy="7" font-size="20">0</text>
                  </svg>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable || isDataAvailable==null">
                <div class="col-6">
                  <p class="m-0">How much have you paid-off</p>
                </div>
                <div class="col-4 offset-2">
                  <svg viewBox="0 0 36 36" class="circle-svg yellow">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent"
                      [style.strokeDasharray]="creditHealthInfo.personalLoanTotalPaidOffPercent + ' ' + (100-creditHealthInfo.personalLoanTotalPaidOffPercent)"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" y="14" text-anchor="middle" dy="7"
                      font-size="20">{{creditHealthInfo.personalLoanTotalPaidOffPercent?.toFixed(0)}}%</text>
                  </svg>
                </div>
              </div>
              <div class="row mt-2 d-flex align-items-center" *ngIf="isDataAvailable!=null && !isDataAvailable">
                <div class="col-6">
                  <p class="m-0">How much have you paid-off</p>
                </div>
                <div class="col-4 offset-2">
                  <svg viewBox="0 0 36 36" class="circle-svg yellow">
                    <path class="around" stroke-dasharray="100, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <path class="percent" stroke-dasharray="0, 100"
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    <text x="18" y="14" text-anchor="middle" dy="7" font-size="20">0</text>
                  </svg>
                </div>
              </div>
            </div>
          </ng-template>
        </owl-carousel-o>
      </div>
    </div>
  </section>



  <section class="bg-gry pb-5  mb-bg-2 b5containeradjust d-none d-md-block">
    <div class="score_breakdown pt-4">
      <div class="container">
        <div class="d-flex flex-wrap px-3">
          <div class="col-12 col-lg-7 customgrid">
            <div class="d-flex">
              <div class="col">
                <h3 class="fw-bold">Understand Your Debt</h3>
              </div>
            </div>
            <div class="d-flex mt-4">
              <div class="col-2 px-1">
                <div class="details">
                  <div class="cell_head pt-md-5 mt-md-3">
                    <h4></h4>
                  </div>
                  <div class="cell">
                    <p>No. of open accounts</p>
                  </div>
                  <div class="cell">
                    <p>Your debt is made up of</p>
                  </div>
                  <div class="cell">
                    <p>How much have you paid-off</p>
                  </div>
                </div>
              </div>
              <div class="col-2 px-1">
                <div class="item">
                  <div class="cell_head">
                    <div class="icon"><svg id="Group_144" data-name="Group 144" xmlns="http://www.w3.org/2000/svg"
                        width="14.725" height="15.08" viewBox="0 0 14.725 15.08">
                        <path id="Path_74" data-name="Path 74"
                          d="M543.344,202.943a.353.353,0,0,1-.151-.033,2.123,2.123,0,1,1,3.021-1.924,2.1,2.1,0,0,1-.224.95.356.356,0,1,1-.636-.319,1.411,1.411,0,1,0-2.673-.631,1.416,1.416,0,0,0,.814,1.278.356.356,0,0,1-.151.679"
                          transform="translate(-536.9 -192.146)" fill="#fff" />
                        <path id="Path_75" data-name="Path 75"
                          d="M546.03,211.4a1.116,1.116,0,0,1-1.113-1.143v-1.325s0-.012,0-.019a.626.626,0,0,1,0-.194.356.356,0,0,1,.7.106s0,.007,0,.011c0,.024.006.057.006.1v1.325a.4.4,0,1,0,.8,0v-1.038a.356.356,0,1,1,.712,0v1.038a1.117,1.117,0,0,1-1.114,1.143"
                          transform="translate(-538.802 -198.342)" fill="#fff" />
                        <path id="Path_76" data-name="Path 76"
                          d="M543.078,208.4h0l-11.182-.022a.356.356,0,0,1,0-.712h0l10.823.02-.036-6.652a.357.357,0,0,1,.354-.358h0a.357.357,0,0,1,.356.355l.037,7.01a.356.356,0,0,1-.356.358"
                          transform="translate(-530.148 -193.321)" fill="#fff" />
                        <path id="Path_77" data-name="Path 77"
                          d="M531.5,208.249a.356.356,0,0,1-.356-.356V200.8a.356.356,0,0,1,.712,0v7.094a.356.356,0,0,1-.356.356"
                          transform="translate(-529.894 -193.169)" fill="#fff" />
                        <path id="Path_78" data-name="Path 78"
                          d="M564.021,194.332a.354.354,0,0,1-.222-.078c-.01-.008-1-.8-2.005-1.641a.356.356,0,1,1,.458-.546c1,.836,1.981,1.622,1.992,1.63a.356.356,0,0,1-.222.634"
                          transform="translate(-549.651 -187.693)" fill="#fff" />
                        <path id="Path_79" data-name="Path 79"
                          d="M527.949,186.323a.356.356,0,0,1-.237-.622c.445-.4,6.688-5.583,6.954-5.8a.356.356,0,0,1,.458,0c.018.015,1.777,1.507,3.34,2.818a.356.356,0,1,1-.458.545c-1.232-1.034-2.587-2.18-3.114-2.627-1.16.964-6.318,5.252-6.706,5.6a.355.355,0,0,1-.237.09"
                          transform="translate(-527.593 -179.815)" fill="#fff" />
                        <path id="Path_80" data-name="Path 80"
                          d="M561.906,185.693a.356.356,0,0,1-.356-.356v-3.461a.356.356,0,1,1,.712,0v3.461a.356.356,0,0,1-.356.356"
                          transform="translate(-549.576 -180.918)" fill="#fff" />
                        <path id="Path_81" data-name="Path 81"
                          d="M557.332,184.575a.356.356,0,0,1-.356-.356v-2.041a.356.356,0,0,1,.712,0v2.041a.356.356,0,0,1-.356.356"
                          transform="translate(-546.615 -181.114)" fill="#fff" />
                        <path id="Path_82" data-name="Path 82"
                          d="M558.3,181.424h-2.846a.356.356,0,0,1,0-.712H558.3a.356.356,0,1,1,0,.712"
                          transform="translate(-545.396 -180.396)" fill="#fff" />
                        <path id="Path_83" data-name="Path 83"
                          d="M542.9,192.451a.353.353,0,0,1-.23-.085l-5.293-4.475c-.94.768-4.487,3.666-5.366,4.368a.356.356,0,0,1-.444-.556c1.007-.805,5.543-4.513,5.589-4.551a.357.357,0,0,1,.455,0l5.52,4.666a.356.356,0,0,1-.23.628"
                          transform="translate(-530.077 -184.514)" fill="#fff" />
                        <path id="Path_84" data-name="Path 84"
                          d="M549.944,208.184a.356.356,0,1,1,.252-.1.358.358,0,0,1-.252.1"
                          transform="translate(-541.832 -197.72)" fill="#fff" />
                      </svg>
                    </div>
                    <p class="mt-1 mb-1">Home</p>
                    <div class="divider"></div>
                  </div>

                  <div class="cell" *ngIf="isDataAvailable || isDataAvailable==null">
                    <p>{{creditHealthInfo.homeLoanAccountCount}}</p>
                  </div>
                  <div class="cell" *ngIf="isDataAvailable!=null && !isDataAvailable">
                    <p>0</p>
                  </div>
                  <div class="cell" *ngIf="isDataAvailable || isDataAvailable==null">
                    <svg viewBox="0 0 36 36" class="circle-svg">
                      <path class="around" stroke-dasharray="100, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent"
                        [style.strokeDasharray]="creditHealthInfo.homeLoanDebtBalancePercent + ' ' + (100-creditHealthInfo.homeLoanDebtBalancePercent)"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="14" text-anchor="middle" dy="7"
                        font-size="20">{{creditHealthInfo.homeLoanDebtBalancePercent?.toFixed(0)}}%</text>
                    </svg>
                  </div>

                  <div class="cell" *ngIf="isDataAvailable!=null && !isDataAvailable">
                    <svg viewBox="0 0 36 36" class="circle-svg">
                      <path class="around" stroke-dasharray="100, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent" stroke-dasharray="0, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="14" text-anchor="middle" dy="7" font-size="20">0</text>
                    </svg>
                  </div>

                  <div class="cell" *ngIf="isDataAvailable || isDataAvailable==null">
                    <svg viewBox="0 0 36 36" class="circle-svg yellow">
                      <path class="around" stroke-dasharray="100, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent"
                        [style.strokeDasharray]="creditHealthInfo.homeLoanTotalPaidOffPercent + ' ' + (100-creditHealthInfo.homeLoanTotalPaidOffPercent)"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="14" text-anchor="middle" dy="7"
                        font-size="20">{{creditHealthInfo.homeLoanTotalPaidOffPercent?.toFixed(0)}}%</text>
                    </svg>
                  </div>
                  <div class="cell" *ngIf="isDataAvailable!=null && !isDataAvailable">
                    <svg viewBox="0 0 36 36" class="circle-svg yellow">
                      <path class="around" stroke-dasharray="100, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent" stroke-dasharray="0, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="14" text-anchor="middle" dy="7" font-size="20">0</text>
                    </svg>
                  </div>

                </div>
              </div>

              <div class="col-2 px-1">
                <div class="item">
                  <div class="cell_head">
                    <div class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="17.172" height="13.075"
                        viewBox="0 0 17.172 13.075">
                        <path id="car-solid"
                          d="M15.987,67.58H14.073l-.532-1.33A3.562,3.562,0,0,0,10.217,64H6.157a3.563,3.563,0,0,0-3.324,2.25L2.3,67.58H.387a.383.383,0,0,0-.372.477l.192.767a.383.383,0,0,0,.372.291h.642a2.032,2.032,0,0,0-.706,1.534v1.534a2.029,2.029,0,0,0,.511,1.34v1.728a1.023,1.023,0,0,0,1.023,1.023H3.072A1.023,1.023,0,0,0,4.1,75.252V74.229h8.184v1.023A1.023,1.023,0,0,0,13.3,76.275h1.023a1.023,1.023,0,0,0,1.023-1.023V73.524a2.028,2.028,0,0,0,.511-1.34V70.649a2.032,2.032,0,0,0-.706-1.534H15.8a.383.383,0,0,0,.372-.291l.192-.767a.384.384,0,0,0-.372-.477ZM4.732,67.01a1.535,1.535,0,0,1,1.425-.964h4.06a1.535,1.535,0,0,1,1.425.964l.637,1.593H4.1Zm-1.66,5.167a1.02,1.02,0,1,1,0-2.04,1.968,1.968,0,0,1,1.534,1.53c0,.612-.921.51-1.534.51Zm10.229,0c-.614,0-1.534.1-1.534-.51a1.968,1.968,0,0,1,1.534-1.53,1.02,1.02,0,1,1,0,2.04Z"
                          transform="translate(0.399 -63.6)" fill="none" stroke="#fff" stroke-width="0.8" />
                      </svg>
                    </div>
                    <p class="mt-1 mb-1">Car</p>
                    <div class="divider"></div>
                  </div>

                  <div class="cell" *ngIf="isDataAvailable || isDataAvailable==null">
                    <p>{{creditHealthInfo.carLoanAccountCount}}</p>
                  </div>
                  <div class="cell" *ngIf="isDataAvailable!=null && !isDataAvailable">
                    <p>0</p>
                  </div>
                  <div class="cell" *ngIf="isDataAvailable || isDataAvailable==null">
                    <svg viewBox="0 0 36 36" class="circle-svg">
                      <path class="around" stroke-dasharray="100, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent"
                        [style.strokeDasharray]="creditHealthInfo.carLoanDebtBalancePercent + ' ' + (100-creditHealthInfo.carLoanDebtBalancePercent)"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="14" text-anchor="middle" dy="7"
                        font-size="20">{{creditHealthInfo.carLoanDebtBalancePercent?.toFixed(0)}}%</text>
                    </svg>
                  </div>
                  <div class="cell" *ngIf="isDataAvailable!=null && !isDataAvailable">
                    <svg viewBox="0 0 36 36" class="circle-svg">
                      <path class="around" stroke-dasharray="100, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent" stroke-dasharray="0, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="14" text-anchor="middle" dy="7" font-size="20">0</text>
                    </svg>
                  </div>

                  <div class="cell" *ngIf="isDataAvailable || isDataAvailable==null">
                    <svg viewBox="0 0 36 36" class="circle-svg yellow">
                      <path class="around" stroke-dasharray="100, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent"
                        [style.strokeDasharray]="creditHealthInfo.carLoanTotalPaidOffPercent + ' ' + (100-creditHealthInfo.carLoanTotalPaidOffPercent)"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="14" text-anchor="middle" dy="7"
                        font-size="20">{{creditHealthInfo.carLoanTotalPaidOffPercent?.toFixed(0)}}%</text>
                    </svg>
                  </div>
                  <div class="cell" *ngIf="isDataAvailable!=null && !isDataAvailable">
                    <svg viewBox="0 0 36 36" class="circle-svg yellow">
                      <path class="around" stroke-dasharray="100, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent" stroke-dasharray="0, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="14" text-anchor="middle" dy="7" font-size="20">0</text>
                    </svg>
                  </div>

                </div>
              </div>

              <div class="col-2 px-1">
                <div class="item">
                  <div class="cell_head">
                    <div class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16.027" height="13.061"
                        viewBox="0 0 16.027 13.061">
                        <path id="tshirt-solid"
                          d="M14.923,2.29,10.3,0A3.444,3.444,0,0,1,7.536,1.12,3.444,3.444,0,0,1,4.771,0L.15,2.29a.383.383,0,0,0-.171.51L1.337,5.518a.383.383,0,0,0,.51.171l1.343-.657a.379.379,0,0,1,.546.342v6.019a.759.759,0,0,0,.76.76h6.076a.759.759,0,0,0,.76-.76V5.371a.38.38,0,0,1,.546-.342l1.343.657a.379.379,0,0,0,.51-.171L15.091,2.8A.379.379,0,0,0,14.923,2.29Z"
                          transform="translate(0.493 0.509)" fill="none" stroke="#fff" stroke-width="0.8" />
                      </svg>
                    </div>
                    <p class="mt-1 mb-1">Clothing</p>
                    <div class="divider"></div>
                  </div>

                  <div class="cell" *ngIf="isDataAvailable || isDataAvailable==null">
                    <p>{{creditHealthInfo.retailerLoanAccountCount}}</p>
                  </div>
                  <div class="cell" *ngIf="isDataAvailable!=null && !isDataAvailable">
                    <p>0</p>
                  </div>
                  <div class="cell" *ngIf="isDataAvailable || isDataAvailable==null">
                    <svg viewBox="0 0 36 36" class="circle-svg">
                      <path class="around" stroke-dasharray="100, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent"
                        [style.strokeDasharray]="creditHealthInfo.retailerLoanDebtBalancePercent + ' ' + (100-creditHealthInfo.retailerLoanDebtBalancePercent)"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="14" text-anchor="middle" dy="7"
                        font-size="20">{{creditHealthInfo.retailerLoanDebtBalancePercent?.toFixed(0)}}%</text>
                    </svg>
                  </div>
                  <div class="cell" *ngIf="isDataAvailable!=null && !isDataAvailable">
                    <svg viewBox="0 0 36 36" class="circle-svg">
                      <path class="around" stroke-dasharray="100, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent" stroke-dasharray="0, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="14" text-anchor="middle" dy="7" font-size="20">0</text>
                    </svg>
                  </div>

                  <div class="cell" *ngIf="isDataAvailable || isDataAvailable==null">
                    <svg viewBox="0 0 36 36" class="circle-svg yellow">
                      <path class="around" stroke-dasharray="100, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent"
                        [style.strokeDasharray]="creditHealthInfo.retailerLoanTotalPaidOffPercent + ' ' + (100-creditHealthInfo.retailerLoanTotalPaidOffPercent)"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="14" text-anchor="middle" dy="7"
                        font-size="20">{{creditHealthInfo.retailerLoanTotalPaidOffPercent?.toFixed(0)}}%</text>
                    </svg>
                  </div>
                  <div class="cell" *ngIf="isDataAvailable!=null && !isDataAvailable">
                    <svg viewBox="0 0 36 36" class="circle-svg yellow">
                      <path class="around" stroke-dasharray="100, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent" stroke-dasharray="0, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="14" text-anchor="middle" dy="7" font-size="20">0</text>
                    </svg>
                  </div>

                </div>
              </div>

              <div class="col-2 px-1">
                <div class="item">
                  <div class="cell_head">
                    <div class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16.182" height="12.764"
                        viewBox="0 0 16.182 12.764">
                        <path id="credit-card-regular_1_" data-name="credit-card-regular (1)"
                          d="M14.1,32H1.284A1.283,1.283,0,0,0,0,33.282v9.4a1.283,1.283,0,0,0,1.284,1.282H14.1a1.283,1.283,0,0,0,1.284-1.282v-9.4A1.283,1.283,0,0,0,14.1,32ZM1.445,33.282H13.937a.161.161,0,0,1,.16.16v1.122H1.284V33.442A.161.161,0,0,1,1.445,33.282Zm12.492,9.4H1.445a.161.161,0,0,1-.16-.16v-4.54H14.1v4.54A.161.161,0,0,1,13.937,42.682Zm-8.81-2.67v1.068a.321.321,0,0,1-.32.32H2.884a.321.321,0,0,1-.32-.32V40.011a.321.321,0,0,1,.32-.32H4.807A.321.321,0,0,1,5.127,40.011Zm5.127,0v1.068a.321.321,0,0,1-.32.32H6.3a.321.321,0,0,1-.32-.32V40.011a.321.321,0,0,1,.32-.32H9.934A.321.321,0,0,1,10.254,40.011Z"
                          transform="translate(0.4 -31.6)" fill="none" stroke="#fff" stroke-width="0.8" />
                      </svg>

                    </div>
                    <p class="mt-1 mb-1">Credit Card</p>
                    <div class="divider"></div>
                  </div>

                  <div class="cell" *ngIf="isDataAvailable || isDataAvailable==null">
                    <p>{{creditHealthInfo.creditLoanAccountCount}}</p>
                  </div>
                  <div class="cell" *ngIf="isDataAvailable!=null && !isDataAvailable">
                    <p>0</p>
                  </div>
                  <div class="cell" *ngIf="isDataAvailable || isDataAvailable==null">
                    <svg viewBox="0 0 36 36" class="circle-svg">
                      <path class="around" stroke-dasharray="100, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent"
                        [style.strokeDasharray]="creditHealthInfo.creditLoanDebtBalancePercent + ' ' + (100-creditHealthInfo.creditLoanDebtBalancePercent)"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="14" text-anchor="middle" dy="7"
                        font-size="20">{{creditHealthInfo.creditLoanDebtBalancePercent?.toFixed(0)}}%</text>
                    </svg>
                  </div>
                  <div class="cell" *ngIf="isDataAvailable!=null && !isDataAvailable">
                    <svg viewBox="0 0 36 36" class="circle-svg">
                      <path class="around" stroke-dasharray="100, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent" stroke-dasharray="0, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="14" text-anchor="middle" dy="7" font-size="20">0</text>
                    </svg>
                  </div>

                  <div class="cell" *ngIf="isDataAvailable || isDataAvailable==null">
                    <svg viewBox="0 0 36 36" class="circle-svg yellow">
                      <path class="around" stroke-dasharray="100, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent"
                        [style.strokeDasharray]="creditHealthInfo.creditLoanTotalPaidOffPercent + ' ' + (100-creditHealthInfo.creditLoanTotalPaidOffPercent)"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="14" text-anchor="middle" dy="7"
                        font-size="20">{{creditHealthInfo.creditLoanTotalPaidOffPercent?.toFixed(0)}}%</text>
                    </svg>
                  </div>
                  <div class="cell" *ngIf="isDataAvailable!=null && !isDataAvailable">
                    <svg viewBox="0 0 36 36" class="circle-svg yellow">
                      <path class="around" stroke-dasharray="100, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent" stroke-dasharray="0, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="14" text-anchor="middle" dy="7" font-size="20">0</text>
                    </svg>
                  </div>


                </div>
              </div>

              <div class="col-2 px-1">
                <div class="item">
                  <div class="cell_head">
                    <div class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14.852" height="10.636"
                        viewBox="0 0 14.852 10.636">
                        <path id="money-bill-wave-solid"
                          d="M13.638,32.493A6.5,6.5,0,0,0,11.082,32c-2.7,0-5.408,1.369-8.112,1.369a6.661,6.661,0,0,1-2.034-.3.751.751,0,0,0-.227-.036.7.7,0,0,0-.708.7V40.7a.7.7,0,0,0,.414.647,6.5,6.5,0,0,0,2.556.493c2.7,0,5.408-1.369,8.113-1.369a6.661,6.661,0,0,1,2.034.3.751.751,0,0,0,.227.036.7.7,0,0,0,.708-.7V33.14a.7.7,0,0,0-.414-.647ZM1.054,34.2a7.64,7.64,0,0,0,1.377.2,1.407,1.407,0,0,1-1.377,1.132Zm0,6.257V39.409a1.4,1.4,0,0,1,1.4,1.348A5.3,5.3,0,0,1,1.054,40.458Zm5.972-1.432a2.143,2.143,0,0,1,0-4.215,2.143,2.143,0,0,1,0,4.215Zm5.972.61A7.549,7.549,0,0,0,11.8,39.45,1.4,1.4,0,0,1,13,38.368Zm0-5.184A1.4,1.4,0,0,1,11.772,33.1,5.278,5.278,0,0,1,13,33.378Z"
                          transform="translate(0.4 -31.6)" fill="none" stroke="#fff" stroke-width="0.8" />
                      </svg>
                    </div>
                    <p class="mt-1 mb-1">Loans</p>
                    <div class="divider"></div>
                  </div>

                  <div class="cell" *ngIf="isDataAvailable || isDataAvailable==null">
                    <p>{{creditHealthInfo.personalLoanAccountCount}}</p>
                  </div>
                  <div class="cell" *ngIf="isDataAvailable!=null && !isDataAvailable">
                    <p>0</p>
                  </div>
                  <div class="cell" *ngIf="isDataAvailable || isDataAvailable==null">
                    <svg viewBox="0 0 36 36" class="circle-svg">
                      <path class="around" stroke-dasharray="100, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent"
                        [style.strokeDasharray]="creditHealthInfo.personalLoanDebtBalancePercent + ' ' + (100-creditHealthInfo.personalLoanDebtBalancePercent)"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="14" text-anchor="middle" dy="7"
                        font-size="20">{{creditHealthInfo.personalLoanDebtBalancePercent?.toFixed(0)}}%</text>
                    </svg>
                  </div>
                  <div class="cell" *ngIf="isDataAvailable!=null && !isDataAvailable">
                    <svg viewBox="0 0 36 36" class="circle-svg">
                      <path class="around" stroke-dasharray="100, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent" stroke-dasharray="0, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="14" text-anchor="middle" dy="7" font-size="20">0</text>
                    </svg>
                  </div>

                  <div class="cell" *ngIf="isDataAvailable || isDataAvailable==null">
                    <svg viewBox="0 0 36 36" class="circle-svg yellow">
                      <path class="around" stroke-dasharray="100, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent"
                        [style.strokeDasharray]="creditHealthInfo.personalLoanTotalPaidOffPercent + ' ' + (100-creditHealthInfo.personalLoanTotalPaidOffPercent)"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="14" text-anchor="middle" dy="7"
                        font-size="20">{{creditHealthInfo.personalLoanTotalPaidOffPercent?.toFixed(0)}}%</text>
                    </svg>
                  </div>
                  <div class="cell" *ngIf="isDataAvailable!=null && !isDataAvailable">
                    <svg viewBox="0 0 36 36" class="circle-svg yellow">
                      <path class="around" stroke-dasharray="100, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="percent" stroke-dasharray="0, 100"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <text x="18" y="14" text-anchor="middle" dy="7" font-size="20">0</text>
                    </svg>
                  </div>

                </div>
              </div>
            </div>
          </div>



          <div class="col-12 col-xl-4 col-lg-5 ps-xl-0 ps-lg-5 offset-xl-1 pt-4 pt-lg-0 pt-md-4 d-none d-md-block">
            <div class="row text-center">
              <div class="col-12">
                <h3 class="fw-bold">Health Check</h3>
              </div>
            </div>



            <div *ngIf="isDataAvailable || isDataAvailable==null" class="row mt-2 ">
              <div class="col-4 spacing-lf position-relative">
                <div class="health_card orange" (click)="showUpdateIncomeModel()">
                  <h5 class="text-white">Total<br>Monthly<br>Income</h5>
                  <span name="btnUpdateIncomePopupDashboardPage">
                    <i class="edit-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="15" height="20" x="0" y="0"
                        viewBox="0 0 401.52289 401" style="enable-background:new 0 0 512 512" xml:space="preserve"
                        class="">
                        <path xmlns="http://www.w3.org/2000/svg"
                          d="m376.628906 13.441406c-17.574218-17.574218-46.066406-17.574218-63.640625 0l-178.40625 178.40625c-1.222656 1.222656-2.105469 2.738282-2.566406 4.402344l-23.460937 84.699219c-.964844 3.472656.015624 7.191406 2.5625 9.742187 2.550781 2.546875 6.269531 3.527344 9.742187 2.566406l84.699219-23.464843c1.664062-.460938 3.179687-1.34375 4.402344-2.566407l178.402343-178.410156c17.546875-17.585937 17.546875-46.054687 0-63.640625zm-220.257812 184.90625 146.011718-146.015625 47.089844 47.089844-146.015625 146.015625zm-9.40625 18.875 37.621094 37.625-52.039063 14.417969zm227.257812-142.546875-10.605468 10.605469-47.09375-47.09375 10.609374-10.605469c9.761719-9.761719 25.589844-9.761719 35.351563 0l11.738281 11.734375c9.746094 9.773438 9.746094 25.589844 0 35.359375zm0 0"
                          fill="#ffffff" data-original="#000000" stroke="white" stroke-width="15" />
                        <path xmlns="http://www.w3.org/2000/svg"
                          d="m370.589844 250.972656c-5.523438 0-10 4.476563-10 10v88.789063c-.019532 16.5625-13.4375 29.984375-30 30h-280.589844c-16.5625-.015625-29.980469-13.4375-30-30v-260.589844c.019531-16.558594 13.4375-29.980469 30-30h88.789062c5.523438 0 10-4.476563 10-10 0-5.519531-4.476562-10-10-10h-88.789062c-27.601562.03125-49.96875 22.398437-50 50v260.59375c.03125 27.601563 22.398438 49.96875 50 50h280.589844c27.601562-.03125 49.96875-22.398437 50-50v-88.792969c0-5.523437-4.476563-10-10-10zm0 0"
                          fill="#ffffff" data-original="#000000" class="" stroke="white" stroke-width="20" />
                      </svg>
                    </i>
                  </span>
                  <div class="divider"></div>
                  <h4 class="text-white font-weight-bold">R {{creditHealthInfo.grossIncome | currency:' ': 'symbol' :
                    '1.0-0'}}</h4>
                </div>
              </div>

              <div class="col-4 position-relative">
                <div class="health_card lblue">
                  <h5 class="text-white">Total<br>Current<br>Balance</h5>
                  <div class="divider"></div>
                  <h4 class="text-white font-weight-bold">R {{creditHealthInfo.totalCurrentBalance | currency:' ':
                    'symbol' : '1.0-0'}}</h4>
                </div>
              </div>

              <div class="col-4 position-relative">
                <div class="health_card blue">
                  <h5 class="text-white">Total<br>Monthly<br>Repayment</h5>
                  <div class="divider"></div>
                  <h4 class="text-white font-weight-bold">R {{creditHealthInfo.totalMonthlyInstalments | currency:' ':
                    'symbol' : '1.0-0'}}</h4>
                </div>
              </div>
            </div>

            <div *ngIf="isDataAvailable!=null && !isDataAvailable" class="row mt-2 ">
              <div class="col-4 position-relative">
                <div class="health_card orange">
                  <h5 class="text-white">Total<br>Monthly<br>Income</h5>
                  <div class="divider"></div>
                  <h4 class="text-white font-weight-bold">R 0</h4>
                </div>
              </div>

              <div class="col-4 position-relative">
                <div class="health_card lblue">
                  <h5 class="text-white">Total<br>Current<br>Balance</h5>
                  <div class="divider"></div>
                  <h4 class="text-white font-weight-bold">R 0</h4>
                </div>
              </div>

              <div class="col-4 position-relative">
                <div class="health_card blue">
                  <h5 class="text-white">Total<br>Monthly<br>Repayment</h5>
                  <div class="divider"></div>
                  <h4 class="text-white font-weight-bold">R 0</h4>
                </div>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-6 spacing-lf position-relative">
                <a name="btn_RedireactAccountPage_DashBoard" class="text-decoration-none" href="/portal/account">
                  <div class="health_card lblue text-center">




                    <svg class="mb-3" width="88" height="88" viewBox="0 0 827 835" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M819.5 417.865C819.5 644.17 637.879 827.5 413.995 827.5C190.111 827.5 8.49011 644.17 8.49011 417.865C8.49011 191.56 190.111 8.22998 413.995 8.22998C637.879 8.22998 819.5 191.56 819.5 417.865Z"
                        stroke="white" stroke-width="13" />
                      <path
                        d="M139 203.5H136.5V206V633.163V635.663H139H695H697.5V633.163V206V203.5H695H139ZM689.186 626.298H144.723L145.989 305.826H689.186V626.298ZM689.186 297.666H145.999V211.66H689.186V297.666Z"
                        fill="white" stroke="white" stroke-width="5" />
                      <path
                        d="M502.102 233.302H499.602V235.802V275.538V278.038H502.102H660.959H663.459V275.538V235.802V233.302H660.959H502.102ZM655.125 269.858H507.815V241.363H655.125V269.858Z"
                        fill="white" stroke="white" stroke-width="5" />
                      <path
                        d="M309.204 233.302H306.704V235.802V275.538V278.038H309.204H354.592H357.092V275.538V235.802V233.302H354.592H309.204ZM314.375 240.731H349.863V270.49H314.375V240.731Z"
                        fill="white" stroke="white" stroke-width="5" />
                      <path
                        d="M241.122 233.302H238.622V235.802V275.538V278.038H241.122H286.51H289.01V275.538V235.802V233.302H286.51H241.122ZM246.253 240.731H281.741V270.49H246.253V240.731Z"
                        fill="white" stroke="white" stroke-width="5" />
                      <path
                        d="M173.041 233.302H170.541V235.802V275.538V278.038H173.041H218.429H220.929V275.538V235.802V233.302H218.429H173.041ZM212.976 270.49H178.132V241.363H212.976V270.49Z"
                        fill="white" stroke="white" stroke-width="5" />
                      <path
                        d="M622.898 365.608L623.021 372.033L627.272 367.214L628.652 365.65L629.297 364.919L629.277 363.944L628.635 332.977L628.617 332.152L629.562 330.753L628.596 331.141L628.559 329.35L627.218 329.893L627.199 328.866L626.238 330.29L625.197 330.712L592.421 343.984L591.56 344.332L591.135 345.159L590.041 347.293L586.983 353.25L593.197 350.754L616.281 341.478L543.254 449.56C541.254 448.188 538.746 446.666 536.125 445.35C532.527 443.544 528.312 441.916 524.796 441.916C520.335 441.916 516.128 442.952 512.473 444.775L473.532 410.565C474.982 408.893 476.608 406.824 478.03 404.654C479.053 403.095 480.001 401.436 480.701 399.799C481.389 398.191 481.908 396.442 481.908 394.746C481.908 382.106 470.288 372.378 456.714 372.378C443.141 372.378 431.52 382.106 431.52 394.746C431.52 398.129 433.583 401.381 435.592 403.904C437.133 405.839 438.929 407.681 440.413 409.179L384.67 493.232C384.419 493.164 384.148 493.09 383.86 493.011C383.357 492.874 382.803 492.722 382.213 492.564C381.336 492.33 380.422 492.095 379.611 491.917C378.871 491.755 377.99 491.586 377.286 491.586C374.475 491.586 370.728 492.637 367.434 493.828C364.728 494.806 362.075 495.974 360.108 497.001L320.64 474.067C320.956 473.043 321.34 471.774 321.705 470.498C322.038 469.33 322.363 468.132 322.606 467.095C322.827 466.153 323.051 465.071 323.051 464.284C323.051 451.645 311.431 441.916 297.857 441.916C284.283 441.916 272.663 451.645 272.663 464.284C272.663 465.4 272.998 466.603 273.363 467.638C273.747 468.727 274.256 469.879 274.776 470.967C275.298 472.06 275.853 473.133 276.336 474.06C276.406 474.193 276.473 474.323 276.539 474.448C276.625 474.613 276.707 474.771 276.785 474.921L215.11 552.114C214.179 551.953 213.077 551.785 211.993 551.639C210.22 551.401 208.267 551.191 207.082 551.191C193.508 551.191 181.888 560.919 181.888 573.559C181.888 586.198 193.508 595.927 207.082 595.927C220.655 595.927 232.276 586.198 232.276 573.559C232.276 571.64 231.652 569.693 230.808 567.906C229.952 566.094 228.789 564.284 227.527 562.594C225.629 560.053 223.419 557.669 221.467 555.826L281.575 479.827C283.331 480.95 285.518 482.291 287.802 483.476C290.917 485.09 294.647 486.652 297.857 486.652C301.426 486.652 305.341 485.722 308.859 484.348C311.708 483.235 314.433 481.779 316.611 480.151L355.468 502.73C354.882 503.957 354.28 505.368 353.754 506.79C352.893 509.119 352.092 511.854 352.092 513.954C352.092 526.594 363.712 536.323 377.286 536.323C390.859 536.323 402.48 526.594 402.48 513.954C402.48 510.099 400.329 506.327 397.922 503.284C396.025 500.886 393.773 498.698 391.691 496.946L446.354 413.813C446.665 413.94 446.998 414.079 447.351 414.226C448.139 414.555 449.027 414.926 450.002 415.311C451.118 415.753 452.296 416.191 453.4 416.52C454.457 416.836 455.644 417.114 456.714 417.114C458.456 417.114 461.082 416.61 463.389 416.072C465.08 415.679 466.762 415.228 468.078 414.837L507.205 449.763C506.969 450.12 506.705 450.514 506.418 450.943L506.399 450.971C505.55 452.239 504.543 453.743 503.581 455.269C502.617 456.799 501.665 458.404 500.946 459.865C500.291 461.196 499.602 462.838 499.602 464.284C499.602 476.924 511.222 486.652 524.796 486.652C538.37 486.652 549.99 476.924 549.99 464.284C549.99 463.537 549.823 462.605 549.645 461.776C549.455 460.888 549.2 459.893 548.936 458.93C548.582 457.64 548.2 456.363 547.904 455.404L622.501 344.776L622.898 365.608ZM475.181 394.796C475.158 396.806 473.76 401.003 470.59 404.675C467.492 408.264 462.942 411.068 456.826 410.794L456.77 410.791H456.714C455.726 410.791 454.138 410.358 452.117 409.345C450.156 408.361 448.007 406.943 445.96 405.253C441.869 401.876 438.66 397.818 437.772 394.47C437.87 392.322 439.084 388.394 442.02 384.942C444.993 381.448 449.68 378.504 456.714 378.504C459.452 378.504 464.043 379.359 467.949 381.871C471.728 384.302 474.883 388.272 475.181 394.796ZM279.674 464.136C279.735 462.065 281.053 458.056 284.043 454.661C286.999 451.304 291.43 448.726 297.636 449.277L297.747 449.286H297.857C300.621 449.286 305.417 450.154 309.276 452.525C312.994 454.811 315.704 458.359 315.17 464.051L315.159 464.167V464.284C315.159 467.063 315.108 470.135 313.148 472.885C311.246 475.553 307.124 478.446 297.707 479.676C295.16 479.63 290.963 478.412 287.192 475.762C283.447 473.131 280.386 469.278 279.674 464.136ZM192.412 583.307C189.53 579.835 188.448 575.823 188.415 573.66C189.011 567.128 192.236 563.143 195.993 560.715C199.873 558.206 204.354 557.356 207.082 557.356H207.214L207.346 557.342C211.681 556.881 216.33 559.522 220.099 563.45C221.934 565.363 223.432 567.455 224.444 569.345C225.505 571.327 225.86 572.767 225.832 573.454C225.549 580.243 222.325 584.169 218.506 586.501C214.554 588.915 209.889 589.643 207.082 589.643C199.845 589.643 195.247 586.722 192.412 583.307ZM377.286 529.604C374.692 529.604 369.57 528.314 365.37 525.557C361.215 522.83 358.574 519.127 359.331 514.345C360.201 508.843 362.548 505.314 365.642 502.96C368.811 500.55 372.964 499.222 377.638 498.556C381.296 498.035 385.547 500.382 389.18 504.173C390.931 506 392.389 508.016 393.396 509.857C394.448 511.779 394.849 513.219 394.849 513.954C394.849 519.132 392.016 522.989 388.223 525.658C384.362 528.376 379.841 529.604 377.286 529.604ZM524.796 479.678C523.901 479.678 522.292 479.174 520.132 477.968C518.066 476.816 515.802 475.196 513.698 473.387C511.59 471.577 509.715 469.64 508.392 467.884C507.73 467.006 507.24 466.219 506.925 465.554C506.598 464.864 506.53 464.453 506.53 464.284C506.53 464.114 506.599 463.698 506.928 462.998C507.245 462.324 507.736 461.527 508.4 460.637C509.726 458.857 511.604 456.89 513.712 455.05C515.818 453.213 518.082 451.564 520.148 450.391C522.311 449.163 523.914 448.654 524.796 448.654C525.671 448.654 527.246 449.158 529.365 450.382C531.39 451.552 533.602 453.196 535.657 455.032C537.715 456.869 539.543 458.833 540.835 460.611C541.48 461.501 541.959 462.299 542.268 462.974C542.589 463.675 542.66 464.1 542.66 464.284C542.66 464.468 542.59 464.887 542.271 465.578C541.964 466.245 541.487 467.032 540.843 467.909C539.554 469.663 537.728 471.598 535.672 473.406C533.618 475.212 531.406 476.828 529.382 477.977C527.265 479.179 525.684 479.678 524.796 479.678Z"
                        fill="white" stroke="white" stroke-width="5" />
                    </svg>



                    <h5 class="text-white mb-0">View Your Full</h5>
                    <h3 class="text-white font-weight-bold">Credit Report</h3>
                  </div>
                </a>
              </div>
              <div class="col-6 position-relative">
                <a name="btn_CallMeBack_Dashboard" class="text-decoration-none" href="javascript:void(0)"
                  (click)="callbackPopup()">
                  <div class="health_card blue text-center">

                    <svg class="mb-3" width="88" height="88" viewBox="0 0 827 835" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <g id="cta">
                        <path id="Vector"
                          d="M398.483 576.749C398.483 576.749 443.692 559.732 455.462 555.765C467.204 551.773 478.793 551.923 485.187 556.823C494.867 564.253 575.56 631.076 582.322 636.941C589.083 642.815 590.787 657.231 578.76 669.518C566.775 681.81 512.691 729.517 492.917 726.279C473.116 723.007 390.681 710.222 254.431 542.9C118.207 375.632 126.773 297.738 128.641 278.982C130.508 260.235 193.898 223.941 209.717 216.344C225.555 208.761 239.936 214.343 244.202 221.745C249.052 230.171 295.907 320.374 301.014 330.676C304.513 337.716 301.465 348.269 294.256 357.837C287.075 367.427 257.624 403.792 257.624 403.792C257.624 403.792 270.987 433.331 321.296 495.084C371.613 556.849 398.483 576.749 398.483 576.749Z"
                          stroke="white" stroke-width="15" stroke-miterlimit="10" />
                        <path id="Vector_2"
                          d="M475.68 308.987C489.734 311.096 502.911 315.803 514.443 322.832C525.975 329.862 535.63 339.074 542.845 349.931C550.06 360.788 554.691 373.072 556.467 386.067C558.243 399.062 557.129 412.507 553.19 425.617"
                          stroke="white" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" />
                        <path id="Vector_3"
                          d="M480.196 235.37C507.815 239.181 533.493 248.016 555.74 261.36C577.987 274.704 596.358 292.292 609.786 313.101C623.215 333.91 631.432 357.526 633.961 382.576C636.491 407.626 633.281 433.611 624.52 459.022"
                          stroke="white" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" />
                        <path id="Vector_4"
                          d="M499.337 159.969C535.185 166.307 568.973 179.341 598.731 198.311C628.489 217.282 653.622 241.808 672.665 270.462C691.708 299.116 704.279 331.323 709.647 365.207C715.015 399.09 713.071 433.972 703.929 467.818"
                          stroke="white" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" />
                        <path id="Ellipse 1"
                          d="M819.5 417.865C819.5 644.171 637.879 827.5 413.995 827.5C190.111 827.5 8.49011 644.171 8.49011 417.865C8.49011 191.559 190.111 8.22998 413.995 8.22998C637.879 8.22998 819.5 191.559 819.5 417.865Z"
                          stroke="white" stroke-width="15" />
                      </g>
                    </svg>

                    <h5 class="text-white mb-0">Speak To A</h5>
                    <h3 class="text-white font-weight-bold">Coach</h3>
                  </div>
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </section>


  

<app-insurance-widget></app-insurance-widget>

<section class=" cc-footer-container  d-block ">
  <div class="d-flex flex-md-column align-items-center justify-content-between px-sm-1 px-md-3 cc-footer-wrapper">
    <div class="cc-footer-header-container">
      <h6> Your Credit Coach</h6>
      <img src="../../assets/images/jm-logo-icon-grey.png" width="14px" />
    </div>
    <div class="d-flex flex-column align-items-center mt-md-2">
      <p class="cc-footer-text">Get free, expert support to help you make good money choices</p>
      <button class="cc-btn mx-1" name="btn_leadGen_coach_callBack_coachBanner"
        id="btn_leadGen_coach_callBack_coachBanner" (click)="coachBannerLmsCallback()">Chat with a coach</button>
    </div>
  </div>
</section>


<ng-template #callbackConfirmationModel let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Free callback request</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"
      name="callbackConfirmationModelClosed" isCloseButton="true">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="callbackErrorMsg!=''" class="alert alert-success" role="alert">
      {{callbackErrorMsg}}
    </div>
    <div *ngIf="callbackSuccessMsg!=''" class="alert alert-success" role="alert">
      {{callbackSuccessMsg}}
    </div>
    <div class="txthd" *ngIf="callbackErrorMsg==''">Do you want a Coach to call you now?</div>
  </div>
  <div class="modal-footer" *ngIf="callbackErrorMsg==''">
    <button id="btn_CallbackConfirmationPopUpNo_Dashboard" name="btn_CallbackConfirmationPopUpNo_Dashboard"
      type="button" class="popup-border" (click)="modal.dismiss('No')">No</button>
    <button id="btn_CallbackConfirmationPopUpYes_Dashboard" name="btn_CallbackConfirmationPopUpYes_Dashboard"
      type="button" class="popup-primary" (click)="userCallback()">Yes</button>
  </div>
</ng-template>

<ng-template #captureIncomeModel let-modal>
  <div class="modal-header orangeheader">
    <h4 class="modal-title text-white" id="modal-basic-title">Please enter your monthly after tax income</h4>
  </div>
  <form class="capture-income-form" [formGroup]="captureIncomeForm" (ngSubmit)="updateIncome()">
    <div class="modal-body">
      <div *ngIf="captureIncomeErrorMsg!=''" class="alert alert-danger" role="alert">
        {{captureIncomeErrorMsg}}
      </div>
      <div class="form-group fullwidth">
        <div class="form-field  gi-hld">
          <p class="text-orange">Why should you provide your take-home salary?</p>
          <p>We need to know your take-home salary in order for us to accurately calculate your debt to income ratio,
            your risk profile and to provide the guidance that fits your needs. </p>
          <label for="GrossIncome">Take-home salary</label>
          <input class="form-control mt-1" type="text" appCurrencyMask placeholder="R 20,000"
            formControlName="GrossIncome" id="currency-number" (blur)="changeGrossIncome()"
            [value]="this.captureIncomeForm.value.GrossIncome" isRequired="true">
          <div *ngIf="captureIncomeFormControls.GrossIncome.touched && captureIncomeFormControls.GrossIncome.errors"
            class="invalid-feedback">
            <div *ngIf="captureIncomeFormControls.GrossIncome.errors.required">Take-home salary is required</div>
            <div *ngIf="captureIncomeFormControls.GrossIncome.errors.min">Invalid Take-home salary</div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button id="btntSubmitTakeHomeSalaryDashboardPage" name="btntSubmitTakeHomeSalaryDashboardPage" type="submit"
        class="popup-primary">Continue</button>
    </div>
  </form>
</ng-template>

<!-- product modal templet -->
<!-- Modal Maybe or Declined -->
<ng-template #finCheckAgreeModal let-modal>
  <div class="modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" name="finCheckAgreeModal"
      isCloseButton="true" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Do you give consent to send your details on to the third party providers and consent to pull a credit report?</p>
  </div>
  <div class="modal-footer justify-content-between">
    <button type="button" class="bank_button mb-0 ms-0" data-toggle="modal" data-dismiss="modal"
      (click)="fincheckLead()" name="btn_PersonalLoanFincheckConsentAgree_SolutionPage">Yes , I agree please contact
      me</button>
    <button type="button" class="bank_button mb-0 me-0 bg-gry" data-dismiss="modal"
      (click)="modal.dismiss('Cross click')" name="btn_PersonalLoanFincheckConsentDisagree_SolutionPage">No</button>
  </div>
</ng-template>

<ng-template #finCheckSubmitModal let-modal>
  <div class="modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss('Cross click')"
      name="btn_PersonalLoanFincheckConsentAgree_SolutionPage_Closed" isCloseButton="true">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Thank you for your application. Please stay close to your phone and expect an SMS or phone call from one of our
      trusted financial partners.</p>
  </div>
</ng-template>

<ng-template #finCheckErrorModal let-modal>
  <div class="modal-header">
    <button name="btn_FinCheckErrorClose_Dashboard" type="button" class="close" data-dismiss="modal" aria-label="Close"
      (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Something went wrong, please try again after sometime.</p>
  </div>
</ng-template>
<!-- Modal Maybe or Declined -->

<ng-template #callbackSuccessModel let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Free callback request</h4>
    <button type="button" class="close" name="{{closeCallMeBackPopupButtonName}}" isCloseButton="true"
      data-dismiss="modal" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" class="alert alert-success" role="alert">
    <p>{{callbackSuccessMsg}}</p>
  </div>
</ng-template>

<ng-template #callbackErrorModel let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Free callback request</h4>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
      name="{{closeCallMeBackPopupButtonName}}" isCloseButton="true" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" class="alert alert-success" role="alert">
    <p>{{callBackErrorDebt}}</p>
  </div>
</ng-template>
<ng-template #lesDeclineModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h4 class="modal-title"></h4>
    <button name="btn_LesDeclineClose_Dashboard" type="button" class="close" data-dismiss="modal" aria-label="Close"
      (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Your application with Sanlam Personal Loans is still in progress. You should receive feedback shortly. Please
      feel free tot chat to your coach if you have any questions?</p>
  </div>
</ng-template>

<ng-template #carInsuranceConfirmationModel let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Free callback request</h4>
    <button type="button" class="close" aria-label="Close" name="carInsurancePopupClosed" isCloseButton="true"
      (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="txthd" *ngIf="callbackErrorMsg==''">Do you want a consultant to call you now?</div>
  </div>
  <div class="modal-footer" *ngIf="callbackErrorMsg==''">
    <button name="btn_CarInsuranceConfirmationNo_Dashboard" type="button" class="popup-border"
      (click)="modal.dismiss('No')">No</button>
    <button name="btn_CarInsuranceConfirmationYes_Dashboard" type="button" class="popup-primary"
      (click)="carInsuranceCallback()">Yes</button>
  </div>
</ng-template>

<ng-template #carInsuranceSuccessModel let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Free callback request</h4>
    <button type="button" class="close" data-dismiss="modal" name="carInsuranceSuccessCallBaclModalClosed"
      isCloseButton="true" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" class="alert alert-success" role="alert">
    <p>Our consultant will contact you shortly.</p>
  </div>
</ng-template>

<!-- User Welcome Text Modal -->
<ng-template #welcomeModel let-modal>
  <form class="welcome-form" [formGroup]="welcomeForm" (ngSubmit)="updateWelcome()">
    <div class="modal-body">
      <div class="form-group fullwidth">
        <div class="form-field  gi-hld">
          <div>
            <h6 class="modal-title welcomeMessage" id="modal-basic-title">{{welcomeMsg}} </h6>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">

      <button id="btntUserWelcomeTextDashboardPage" name="btntUserWelcomeTextDashboardPage" type="submit"
        class="popup-border">Continue</button>
    </div>
  </form>
</ng-template>


<!-- Modal approved -->
<ng-template #lesApprovedModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title"><img src="assets/images/slogo.png" alt="" width="120px" /></h5>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" name="btn_SPLViewOfferClose_Dashboard"
      isCloseButton="true">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="d-flex flex-wrap w-100">
      <div class="col-md-9 col-9">
        <h5 class="text-orange mb-1">Loan Amount</h5>
        <p>
          R 5,000 to R 350,000
        </p>

        <h5 class="text-orange mb-1">Loan Term</h5>
        <p>
          12 to 84 months
        </p>

        <h5 class="text-orange mb-1">Loan Interest Rate</h5>
        <p>
          16% to 28.50%
        </p>
      </div>
      <div class="col-md-3 col-3 align-self-end">
        <div class="d-flex justify-content-end"><button type="button" class="bank_button mb-0 mbtn"
            (click)="transferLead()" name="btn_LoanAmount_DashboardPage_Go">Go</button></div>
      </div>
    </div>
  </div>
 
  <div class="modal-footer flex-wrap py-0">

    <p class="w-100 mt-2 text-sm">Sanlam Personal Loans (Pty) Ltd, Reg No. 2001/016316/07
      Registered Credit Provider (NCRCP272)
      DirectAxis SA (Pty) Ltd is an authorised service provider (FSP license 7249)
      Refer to Sanlam website for directors and company secretary detail.</p>
  </div>


</ng-template>

<!-- monthly expenses Modal -->
<ng-template #monthlyExpenses let-modal>
  <div class="modal-header orangeheader">
    <h4 class="modal-title text-white" id="modal-basic-title">Your monthly expenses</h4>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
      name="btn_MonthlyExpenses_DashboardPage_ClosePopup" (click)="modal.dismiss('Cross click')" isCloseButton="true">
      <svg enable-background="new 0 0 256 256" height="30px" id="Layer_1" version="1.1" viewBox="0 0 256 256"
        width="30px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path
          d="M137.051,128l75.475-75.475c2.5-2.5,2.5-6.551,0-9.051s-6.551-2.5-9.051,0L128,118.949L52.525,43.475  c-2.5-2.5-6.551-2.5-9.051,0s-2.5,6.551,0,9.051L118.949,128l-75.475,75.475c-2.5,2.5-2.5,6.551,0,9.051  c1.25,1.25,2.888,1.875,4.525,1.875s3.275-0.625,4.525-1.875L128,137.051l75.475,75.475c1.25,1.25,2.888,1.875,4.525,1.875  s3.275-0.625,4.525-1.875c2.5-2.5,2.5-6.551,0-9.051L137.051,128z"
          fill="#fff" />
      </svg>
    </button>
  </div>
  <form [formGroup]="monthlyExpensesForm" (ngSubmit)="saveMonthlyExpenses()">
    <div class="modal-body">
      <div *ngIf="monthlyExpensesErrorMsg!=''" class="alert alert-danger" role="alert">
        {{monthlyExpensesErrorMsg}}
      </div>
      <div class="form-group mb-0 fullwidth">
        <div class="form-field  gi-hld">
          <div class="infoxt">
            <p class="text-orange text-bold ptext-popup">Why should you provide your monthly expenses? </p>
            <p class="ptext-popup">We need to know your monthly expenses in order to calculate the car what you can
              afford. </p>
            <div class="expenceholder">

              <label class="monthexpence">Monthly expenses (excluding debt/ credit repayments)</label>
              <input type="text" class="form-control" id="monthlyExpenses" appCurrencyMask placeholder="R10,000"
                formControlName="MonthlyExpenses" (blur)="changeMonthlyExpenses()" />
              <div
                *ngIf="monthlyExpensesFormControls.MonthlyExpenses.touched && monthlyExpensesFormControls.MonthlyExpenses.errors"
                class="invalid-feedback">
                <div *ngIf="monthlyExpensesFormControls.MonthlyExpenses.errors.required">Monthly expense is required
                </div>
                <div *ngIf="monthlyExpensesFormControls.MonthlyExpenses.errors.min">Invalid monthly expense</div>
              </div>

            </div>
          </div>
          <div class="d-flex justify-content-end pt-2 pb-3">
            <button type="submit" class="popup-primary" name="btn_MonthlyExpenses_DashboardPage_Continue"
              data-dismiss="modal" aria-label="Close">Continue</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<!-- finance indicator Modal -->
<ng-template #financeIndicator let-modal>
  <form>
    <div class="modal-header orangeheader">
      <h4 class="modal-title text-center text-white" id="modal-basic-title">Vehicle Finance Indicator</h4>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        name="btn_FinanceIndicator_DashboardPage_ClosePopup" name="financeIndicator" isCloseButton="true"
        (click)="modal.dismiss('Cross click')">
        <svg enable-background="new 0 0 256 256" height="30px" id="Layer_1" version="1.1" viewBox="0 0 256 256"
          width="30px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <path
            d="M137.051,128l75.475-75.475c2.5-2.5,2.5-6.551,0-9.051s-6.551-2.5-9.051,0L128,118.949L52.525,43.475  c-2.5-2.5-6.551-2.5-9.051,0s-2.5,6.551,0,9.051L118.949,128l-75.475,75.475c-2.5,2.5-2.5,6.551,0,9.051  c1.25,1.25,2.888,1.875,4.525,1.875s3.275-0.625,4.525-1.875L128,137.051l75.475,75.475c1.25,1.25,2.888,1.875,4.525,1.875  s3.275-0.625,4.525-1.875c2.5-2.5,2.5-6.551,0-9.051L137.051,128z"
            fill="#fff" />
        </svg>
      </button>
    </div>

    <div class="modal-body p-0">
      <div class="form-group mb-0 fullwidth">
        <div class="form-field gi-hld">

          <div class="chance-succes" *ngIf="categoryType != 3">
            <div class="d-flex flex-wrap justify-content-center pt-4 px-3">
              <div class="col-md-6">
                <p class="text-success text-center text-bold mb-0 actxt" *ngIf="categoryType == 1">Congratulations!</p>
                <p class="ptext-popup text-center" *ngIf="categoryType == 1">You have a good chance to qualify for
                  vehicle finance. </p>
                <p class="ptext-popup text-center" *ngIf="categoryType == 2">You have a chance to qualify for vehicle
                  finance. </p>

              </div>
              <div class="col-md-12">
                <p class="text-center">Speak to your dealership for more insights.</p>
              </div>
            </div>
            <hr class="divider my-0" />

            <div class="d-flex align-items-center  pt-3">
              <div class="col-lg-8 col-md-10 col-8">
                <p class="m-0">Estimated amount you could qualify for: </p>
              </div>
              <div class="col-lg-4 col-md-2 col-4 ps-0">
                <p class="m-0 text-right"><span class="text-bold">R {{vehiclePrice | number}}</span></p>
              </div>
            </div>
            <hr class="divider" />
            <div class="d-flex align-items-center ">
              <div class="col-lg-8 col-md-10 col-8">
                <p class="m-0">Estimated monthly repayment you can afford: </p>
              </div>
              <div class="col-lg-4 col-md-2 col-4 ps-0">
                <p class="m-0 text-right"><span class="text-bold">R {{maxMonthlyInstallment | number}}</span></p>
              </div>
            </div>
            <hr />
            <p class="ofxt mb-0 text-center px-3 mb-3">We assumed an interest rate of {{categoryType == 1 ? '11' :
              '13'}}% and a term of 6 years for this calculation. Actual values and T’s and C’s will depend on your
              chosen vehicle finance provider. </p>

          </div>

          <div class="chance-low" *ngIf="categoryType == 3">
            <div class="d-flex flex-wrap justify-content-center pt-4 px-3">
              <div class="col-md-7">
                <p class="ptext-popup text-center">Your chances of getting vehicle financing are not good. </p>
              </div>
              <div class="col-md-12">
                <p class="text-center">Speak to your dealership for more insights.</p>
              </div>
            </div>
            <hr class="divider mt-0" />
            <div class="d-flex justify-content-center">
              <div class="col-md-7">
                <p class="ptext-popup text-center">The main reasons you may not qualify can include: </p>
              </div>
            </div>
            <div class="col-md-12">
              <ul class="indicator-list">
                <li>You have signed up for debt counselling</li>
                <li>You have overdue accounts</li>
                <li>You have a low credit score</li>
                <li>Your monthly affordability is less than R1,000</li>
              </ul>
            </div>


          </div>


          <div class="d-flex justify-content-center pt-2 pb-3">
            <button name="btn_FinanceIndicator_DashboardPage_ViewFullProfile" type="button"
              class="popup-primary mx-auto" (click)="modal.dismiss('Cross click')">View your full profile</button>
          </div>

        </div>
      </div>

    </div>
  </form>
</ng-template>

<ng-template #updateIncomeModel let-modal>
  <div class="modal-header orangeheader">
    <h4 class="modal-title text-white" id="modal-basic-title">Update your monthly income</h4>
    <button *ngIf="!IsDebtAffordability" type="button" class="close" data-dismiss="modal" aria-label="Close"
      name="btn_UpdateIncomemModel_Close_DashboardPage" (click)="modal.dismiss('Cross click')" isCloseButton="true">
      <svg enable-background="new 0 0 256 256" height="30px" id="Layer_1" version="1.1" viewBox="0 0 256 256"
        width="30px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path
          d="M137.051,128l75.475-75.475c2.5-2.5,2.5-6.551,0-9.051s-6.551-2.5-9.051,0L128,118.949L52.525,43.475  c-2.5-2.5-6.551-2.5-9.051,0s-2.5,6.551,0,9.051L118.949,128l-75.475,75.475c-2.5,2.5-2.5,6.551,0,9.051  c1.25,1.25,2.888,1.875,4.525,1.875s3.275-0.625,4.525-1.875L128,137.051l75.475,75.475c1.25,1.25,2.888,1.875,4.525,1.875  s3.275-0.625,4.525-1.875c2.5-2.5,2.5-6.551,0-9.051L137.051,128z"
          fill="#fff" />
      </svg>
    </button>
    <button *ngIf="IsDebtAffordability" id="btn_auxilaryButton_userInput_editIncome_closePopUp_debtAffordability" name="btn_auxilaryButton_userInput_editIncome_closePopUp_debtAffordability" type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss('Cross click')" isCloseButton="true">
      <svg enable-background="new 0 0 256 256" height="30px" id="Layer_1" version="1.1" viewBox="0 0 256 256"
        width="30px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path
          d="M137.051,128l75.475-75.475c2.5-2.5,2.5-6.551,0-9.051s-6.551-2.5-9.051,0L128,118.949L52.525,43.475  c-2.5-2.5-6.551-2.5-9.051,0s-2.5,6.551,0,9.051L118.949,128l-75.475,75.475c-2.5,2.5-2.5,6.551,0,9.051  c1.25,1.25,2.888,1.875,4.525,1.875s3.275-0.625,4.525-1.875L128,137.051l75.475,75.475c1.25,1.25,2.888,1.875,4.525,1.875  s3.275-0.625,4.525-1.875c2.5-2.5,2.5-6.551,0-9.051L137.051,128z"
          fill="#fff" />
      </svg>
    </button>
  </div>
  <form class="capture-income-form" [formGroup]="updateIncomeForm" (ngSubmit)="updateGrossIncome()">
    <div class="modal-body">
      <div *ngIf="updateIncomeErrorMsg!=''" class="alert alert-danger" role="alert">
        {{updateIncomeErrorMsg}}
      </div>
      <div class="form-group fullwidth ">
        <div class="form-field  gi-hld">
          <p>This is your take-home salary calculated after tax. </p>
          <div class="row">
            <div class="col-md-8 col-sm-12">
              <input class="form-control" type="text" appCurrencyMask formControlName="GrossIncome" id="currency-number"
                (input)="enableUpdateIncome()" isRequired="true">
              <div *ngIf="updateIncomeFormControls.GrossIncome.touched && updateIncomeFormControls.GrossIncome.errors"
                class="invalid-feedback">
                <div *ngIf="updateIncomeFormControls.GrossIncome.errors.required">Take-home salary is required</div>
                <div *ngIf="updateIncomeFormControls.GrossIncome.errors.min">Invalid Take-home salary</div>
              </div>
            </div>
            <div class="col-md-4 col-sm-12 text-sm-end text-md-center text-end">
              <button *ngIf="!IsDebtAffordability" name="btnUpdateGrossIncomeDashboardPage" type="submit" class="toppbtn updatebtn "
                [class.toppbtn-disabled]="UpdateIncomeDisabled" [disabled]="UpdateIncomeDisabled">Update</button>
              <button *ngIf="IsDebtAffordability" id="btn_auxilaryButton_userInput_editIncome_updateIncome_debtAffordability" name="btn_auxilaryButton_userInput_editIncome_updateIncome_debtAffordability" type="submit" class="toppbtn updatebtn "
                [class.toppbtn-disabled]="UpdateIncomeDisabled" [disabled]="UpdateIncomeDisabled">Update</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #DCCallbackConfirmationModel let-modal>
  <div class="modal-header">
    <h4 class="modal-title fw-bold">Talk to a debt expert?</h4>
    <button id="btn_auxiliaryButton_consolidateLoan_callBack_popUp_close_debtAffordabilitySolution" name="btn_auxiliaryButton_consolidateLoan_callBack_popUp_close_debtAffordabilitySolution" type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"
      isCloseButton="true">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="callbackErrorMsg!=''" class="alert alert-success" role="alert">
      {{callbackErrorMsg}}
    </div>
    <div *ngIf="callbackSuccessMsg!=''" class="alert alert-success" role="alert">
      {{callbackSuccessMsg}}
    </div>
    <div class="txthd" *ngIf="callbackErrorMsg==''"><p>Would you like a debt expert to call you for FREE to chat about managing your debt?</p>
      <p>You can save money and reduce stress!</p></div>
  </div>
  <div class="modal-footer dc-popup-footer" *ngIf="callbackErrorMsg==''">
    <button id="btn_auxiliaryButton_consolidateLoan_callBack_popUp_no_debtAffordabilitySolution" name="btn_auxiliaryButton_consolidateLoan_callBack_popUp_no_debtAffordabilitySolution"
      type="button" class="popup-border dc-popup-btn" (click)="modal.dismiss('No')">No</button>
    <button id="btn_leadGen_consolidateLoan_callBack_popUp_yes_debtAffordabilitySolution" name="btn_leadGen_consolidateLoan_callBack_popUp_yes_debtAffordabilitySolution"
      type="button" class="popup-primary dc-popup-btn" (click)="idmLeadCallback('btn_leadGen_consolidateLoan_callBack_popUp_yes_debtAffordabilitySolution')">Yes</button>
  </div>
</ng-template>
<ng-template #DCCallbackSuccessModel let-modal>
  <div class="modal-header">
    <h4 class="modal-title fw-bold">Free call-back incoming</h4>
    <button id="btn_auxiliaryButton_consolidateLoan_callBack_popUp_journeyEnd_close_debtAffordabilitySolution"
     name="btn_auxiliaryButton_consolidateLoan_callBack_popUp_journeyEnd_close_debtAffordabilitySolution" type="button" class="close"
      isCloseButton="true"
      data-dismiss="modal" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" class="alert" role="alert">
    <p>Stand by, a debt expert will call you shortly.</p>
  </div>
  <div class="modal-footer" style="justify-content: flex-end !important;">
    <button id="btn_auxiliaryButton_consolidateLoan_callBack_popUp_journeyEnd_closeOK_debtAffordabilitySolution"
     name="btn_auxiliaryButton_consolidateLoan_callBack_popUp_journeyEnd_closeOK_debtAffordabilitySolution"type="button" 
     class="popup-primary"  isCloseButton="true" data-dismiss="modal"
      aria-label="Close" (click)="modal.dismiss('Cross click')">
      Ok, thanks!
    </button>
    </div>
</ng-template>

<ng-template #DCCallbackErrorModel let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Free callback request</h4>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
      name="{{closeCallMeBackPopupButtonName}}" isCloseButton="true" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" class="alert alert-success" role="alert">
    <p>{{callBackErrorDebt}}</p>
  </div>
</ng-template>
<div class="modal fade" id="termcontent" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog  modal-dialog-scrollable" role="document">
    <div class="modal-content">

      <!--Keep this-->
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Terms & Conditions</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          name="btn_PersonalLoanTerms_Close_DashboardPage">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>
          Detailed below, is the complete list of Terms & Conditions that should be displayed to a customer when
          applying for a personal loan
        </p>
        <h5 class="text-orange">You confirm that</h5>
        <ul class="list-text">
          <li>You are not currently over-indebted</li>
          <li>You are not under administration, sequestration or debt review and have not been declared mentally unfit
            by an order of court</li>
          <li>All information you give us is true and correct</li>
          <li>You will ensure that you have read and understood the terms and conditions that follow before accepting
            any loan amount that you may be offered</li>
        </ul>
        <h5 class="text-orange">You agree that DirectAxis may</h5>
        <ul class="list-text">
          <li>Check and verify any information that we need in connection with this agreement</li>
          <li>May contact you by SMS or email about this or future applications</li>
        </ul>
        <h5 class="text-orange">English</h5>
        <p>You confirm that you are able to read and fully understand English. If you cannot read English or do not
          fully understand English, you should not carry on with this online personal loan application and should call
          us to apply in one of the other languages we support namely Afrikaans, Xhosa, Zulu or Sesotho.</p>

        <h5 class="text-orange">Afrikaans</h5>
        <p>U bevestig dat u Engels kan lees en Engels ten volle verstaan. Indien u nie Engels kan lees nie, óf Engels
          nie ten volle verstaan nie, moet u asseblief nie met hierdie aanlyn aansoek om ‘n persoonlike lening voortgaan
          nie. Skakel ons eerder: ons kan u telefonies in Afrikaans, Xhosa, Zulu of Sotho help om u aansoek te voltooi.
        </p>

        <h5 class="text-orange">Zulu</h5>
        <p>Uyaqinisekisa ukuthi uyakwazi ukufunda isiNgisi futhi usiqonda ngokuphelele. Uma ungakwazi ukufunda isiNgisi
          noma ungasiqondi ngokuphelele isiNgisi, akumele uqhubeke nokufaka isicelo sokubolekwa imali nge-inthanethi
          kodwa esikhundleni salokho kumele usifonele ukuze ufake isicelo sakho ngolunye lwezilimi esizisebenzisayo,
          isiBhunu, isiXhosa, isiZulu kanye neSesotho.</p>

        <h5 class="text-orange">Sesotho</h5>
        <p>O netefatsa hore o kgona ho bala mme o utlwisisa Senyesemane ka botlalo. Haeba o sa kgone ho bala Senyesemane
          kapa o sa utlwisise Senyesemane ka botlalo, o tlameha ho se tswele pele ka kopo ena ya mokitlane wa motho ya
          inthaneteng mme o re letsetse ho etsa kopo ka e nngwe ya tse ding tsa dipuo tseo re di sebedisang, e leng
          Afrikanse, Sexhosa, Sezulu kapa Sesotho.</p>

        <h5 class="text-orange">Xhosa</h5>
        <p>Uqinisekisa ukuba uyakwazi ukusithetha isiNgesi kwaye usiqonda ngokupheleleyo. Ukuba awukwazi ukusifunda
          isiNgesi okanye awusiqondi ngokupheleleyo, akufuneki uqhubeke ngesi sicelo semali-mboleko sifumaneka
          kwikhompyutha kwaye kufuneka ufake isicelo ngezinye iilwimi esizixhasayo ezizezi, isiBhulu, isiXhosa, isiZulu
          okanye isiSuthu.</p>


      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="bank_button mb-0 ms-0" (click)="transferLead()"
          name="btn_PersonalLoanTermsAgree_DashboardPage">Yes , I agree to the Terms and Condition</button>
        <button type="button" class="bank_button mb-0 me-0 bg-gry" data-dismiss="modal"
          name="btn_PersonalLoanTermsDecline_DashboardPage">No</button>
      </div>
      <!--Keep this-->

    </div>
  </div>
</div>
<ng-template #CoachCallbackSuccessModel let-modal>
  <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">Free call-back incoming</h4>
            <button type="button" id="btn_auxiliaryButton_creditScore_callBackRequested_popUpClose_dashboard" class="close"
                data-dismiss="modal" name="btn_auxiliaryButton_creditScore_callBackRequested_popUpClose_dashboard" isCloseButton="true" aria-label="Close"
                (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true" style="pointer-events: none;">&times;</span>
            </button>
        </div>
        <div class="modal-body" role="alert">
            <p class="mb-0">An agent will contact you shortly.</p>
        </div>
        <div class="modal-footer">
            <button id="btn_auxiliaryButton_creditScore_callBackRequested_popUpCloseBottom_dashboard"
                name="btn_auxiliaryButton_creditScore_callBackRequested_popUpCloseBottom_dashboard" type="button" class="popup-primary"
                (click)="modal.dismiss('Cross click')">OK, thanks!</button>
        </div>
    </div>
</ng-template>
<!-- 
<app-guidemark-offcanvas   [tile]="selectedTile"
  [page]="selectedPage" [creditPaymentsAmount]="creditPaymentsAmount"></app-guidemark-offcanvas> -->

<!-- End-->
<!-- Contact HTML Start 
 <app-contact></app-contact>-->
<!-- Contact HTML End -->